<template>
	<div id="indexEdit" class="indexEdit clearfix" @mousedown="mousedown" @mousemove="mousemove" @mouseup="mouseup">
		<div class="el-loading-mask is-fullscreen" v-show="loadingMark">
			<div class="el-loading-spinner">
				<svg viewBox="25 25 50 50" class="circular">
					<circle style="animation: unset !important" cx="50" cy="50" r="20" fill="none" class="path"></circle>
				</svg>
				<!--<p class="el-loading-text">正在等待图表生成 ...</p>-->
			</div>
		</div>
		<div class="noContent" v-if="!ShowContent">
			<img :src="nullData" class="nullData">
			<span class="nullSpan">还没有任何内容，请前往首页编辑页面编辑首页</span>
		</div>
		<div class="mould_show clearfix" v-if="ShowContent">
			<el-form ref="form" label-width="" @submit.native.prevent>
				<div class="show_content clearfix" id='NewMouldBy' :class="{'backgroundBy456': mouldId == 4 || mouldId == 5 || mouldId == 6, 'backgroundBy7': mouldId == 7}">
					<div class="left" :style="leftStyle">

						<div class="left_top" v-if="mouldId == 3 || mouldId == 6">
							<div class="top-box OneDataSet">
								<!--left_top.one[0]-->
								<!--选择类型为数据集时-->
								<div class="dataSet">

									<!--标题-->
									<div class="datasetHeader" v-if="left_top.one.length > 1">
										<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':left_top_one==index}" v-for="(item,index) in left_top.one" @click="changeBox('left_top_one',index)">
											<div class="headerbox">
												{{item.name}}
											</div>
											<div class="shu" v-if="index != left_top.one.length-1"></div>
										</div>
									</div>
									<div class="datasetTitle" :title='left_top.one[0].name' v-if="left_top.one.length == 1">
										{{left_top.one[0].name}}
									</div>

									<!--数据集-->
									<div class="datasetBox" :index='index' v-show="left_top_one==index" :ref="'left_top_one'+index" v-for="(item,index) in left_top.one">
										<!--数据集为表格时-->
										<div class="datasetTable leftTopTable clearfix centerTopByTable" :style="fontSizeUpdate(item.value,item.unit,'centerTopByTable')">
											<span class="TableValue" v-if="item.value != null && item.value != undefined">{{common.fmoney(item.value)}}</span>
											<span class="TableValue" v-if="item.value == null && item.value == undefined"> - </span>
											<span class="TableUnit" v-if="item.value != null && item.value != undefined">{{item.unit}}</span>
											<!--<span class="TableUnitEn">℃</span>-->
										</div>
									</div>
								</div>
							</div>
							<div class="top-box OneDataSet">
								<!--left_top.two[0]-->
								<!--选择类型为数据集时-->
								<div class="dataSet">

									<!--标题-->
									<div class="datasetHeader" v-if="left_top.two.length > 1">
										<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':left_top_two==index}" v-for="(item,index) in left_top.two" @click="changeBox('left_top_two',index)">
											<div class="headerbox">
												{{item.name}}
											</div>
											<div class="shu" v-if="index != left_top.two.length-1"></div>
										</div>
									</div>
									<div class="datasetTitle" :title='left_top.two[0].name' v-if="left_top.two.length == 1">
										{{left_top.two[0].name}}
									</div>

									<!--数据集-->
									<div class="datasetBox" :index='index' v-show="left_top_two==index" :ref="'left_top_two'+index" v-for="(item,index) in left_top.two">
										<!--数据集为表格时-->
										<div class="datasetTable leftTopTable clearfix" :style="fontSizeUpdate(item.value,item.unit,'centerTopByTable')">
											<span class="TableValue" v-if="item.value != null && item.value != undefined">{{common.fmoney(item.value)}}</span>
											<span class="TableValue" v-if="item.value == null && item.value == undefined"> - </span>
											<span class="TableUnit" v-if="item.value != null && item.value != undefined">{{item.unit}}</span>
											<!--<span class="TableUnitEn">℃</span>-->
										</div>
									</div>
								</div>
							</div>
							<div class="top-box OneDataSet">
								<!--left_top.three[0]-->
								<!--选择类型为数据集时-->
								<div class="dataSet">

									<!--标题-->
									<div class="datasetHeader" v-if="left_top.three.length > 1">
										<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':left_top_three==index}" v-for="(item,index) in left_top.three" @click="changeBox('left_top_three',index)">
											<div class="headerbox">
												{{item.name}}
											</div>
											<div class="shu" v-if="index != left_top.three.length-1"></div>
										</div>
									</div>
									<div class="datasetTitle" :title='left_top.three[0].name' v-if="left_top.three.length == 1">
										{{left_top.three[0].name}}
									</div>

									<!--数据集-->
									<div class="datasetBox" :index='index' v-show="left_top_three==index" :ref="'left_top_three'+index" v-for="(item,index) in left_top.three">
										<!--数据集为表格时-->
										<div class="datasetTable leftTopTable clearfix" :style="fontSizeUpdate(item.value,item.unit,'centerTopByTable')">
											<span class="TableValue" v-if="item.value != null && item.value != undefined">{{common.fmoney(item.value)}}</span>
											<span class="TableValue" v-if="item.value == null && item.value == undefined"> - </span>
											<span class="TableUnit" v-if="item.value != null && item.value != undefined">{{item.unit}}</span>
											<!--<span class="TableUnitEn">℃</span>-->
										</div>
									</div>
								</div>
							</div>
							<div class="top-box OneDataSet">
								<!--left_top.four[0]-->
								<!--选择类型为数据集时-->
								<div class="dataSet">

									<!--标题-->
									<div class="datasetHeader" v-if="left_top.four.length > 1">
										<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':left_top_four==index}" v-for="(item,index) in left_top.four" @click="changeBox('left_top_four',index)">
											<div class="headerbox">
												{{item.name}}
											</div>
											<div class="shu" v-if="index != left_top.four.length-1"></div>
										</div>
									</div>
									<div class="datasetTitle" :title='left_top.four[0].name' v-if="left_top.four.length == 1">
										{{left_top.four[0].name}}
									</div>

									<!--数据集-->
									<div class="datasetBox" :index='index' v-show="left_top_four==index" :ref="'left_top_four'+index" v-for="(item,index) in left_top.four">
										<!--数据集为表格时-->
										<div class="datasetTable leftTopTable clearfix" :style="fontSizeUpdate(item.value,item.unit,'centerTopByTable')">
											<span class="TableValue" v-if="item.value != null && item.value != undefined">{{common.fmoney(item.value)}}</span>
											<span class="TableValue" v-if="item.value == null && item.value == undefined"> - </span>
											<span class="TableUnit" v-if="item.value != null && item.value != undefined">{{item.unit}}</span>
											<!--<span class="TableUnitEn">℃</span>-->
										</div>
									</div>
								</div>
							</div>
							<div class="top-box OneDataSet" style="margin-right: 0">
								<!--left_top.five[0]-->
								<!--选择类型为数据集时-->
								<div class="dataSet">

									<!--标题-->
									<div class="datasetHeader" v-if="left_top.five.length > 1">
										<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':left_top_five==index}" v-for="(item,index) in left_top.five" @click="changeBox('left_top_five',index)">
											<div class="headerbox">
												{{item.name}}
											</div>
											<div class="shu" v-if="index != left_top.five.length-1"></div>
										</div>
									</div>
									<div class="datasetTitle" :title='left_top.five[0].name' v-if="left_top.five.length == 1">
										{{left_top.five[0].name}}
									</div>

									<!--数据集-->
									<div class="datasetBox" :index='index' v-show="left_top_five==index" :ref="'left_top_five'+index" v-for="(item,index) in left_top.five">
										<!--数据集为表格时-->
										<div class="datasetTable leftTopTable clearfix" :style="fontSizeUpdate(item.value,item.unit,'centerTopByTable')">
											<span class="TableValue" v-if="item.value != null && item.value != undefined">{{common.fmoney(item.value)}}</span>
											<span class="TableValue" v-if="item.value == null && item.value == undefined"> - </span>
											<span class="TableUnit" v-if="item.value != null && item.value != undefined">{{item.unit}}</span>
											<!--<span class="TableUnitEn">℃</span>-->
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="left_top_7 clearfix" v-if="mouldId == 7">
							<div class="top-row showLine">
								<div class="row-data one">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_2.one[0] ? left_top_2.one[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_2.one[0]">{{left_top_2.one[0].name}}</span>
											<span v-if="!left_top_2.one[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_2.one[0] && left_top_2.one[0].value!=null && left_top_2.one[0]!=undefined">
											<div v-if="left_top_2.one[0].value != null && left_top_2.one[0].value != undefined">{{common.fmoney(left_top_2.one[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_2.one[0].value != null && left_top_2.one[0].value != undefined">{{left_top_2.one[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_2.one[0] || left_top_2.one[0].value == null || left_top_2.one[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
								<div class="row-data two">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_2.two[0] ? left_top_2.two[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_2.two[0]">{{left_top_2.two[0].name}}</span>
											<span v-if="!left_top_2.two[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_2.two[0] && left_top_2.two[0].value!=null && left_top_2.two[0]!=undefined">
											<div v-if="left_top_2.two[0].value != null && left_top_2.two[0].value != undefined">{{common.fmoney(left_top_2.two[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_2.two[0].value != null && left_top_2.two[0].value != undefined">{{left_top_2.two[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_2.two[0] || left_top_2.two[0].value == null || left_top_2.two[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
								<div class="row-data three">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_2.three[0] ? left_top_2.three[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_2.three[0]">{{left_top_2.three[0].name}}</span>
											<span v-if="!left_top_2.three[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_2.three[0] && left_top_2.three[0].value!=null && left_top_2.three[0]!=undefined">
											<div v-if="left_top_2.three[0].value != null && left_top_2.three[0].value != undefined">{{common.fmoney(left_top_2.three[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_2.three[0].value != null && left_top_2.three[0].value != undefined">{{left_top_2.three[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_2.three[0] || left_top_2.three[0].value == null || left_top_2.three[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
								<div class="row-data four">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_2.four[0] ? left_top_2.four[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_2.four[0]">{{left_top_2.four[0].name}}</span>
											<span v-if="!left_top_2.four[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_2.four[0] && left_top_2.four[0].value!=null && left_top_2.four[0]!=undefined">
											<div v-if="left_top_2.four[0].value != null && left_top_2.four[0].value != undefined">{{common.fmoney(left_top_2.four[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_2.four[0].value != null && left_top_2.four[0].value != undefined">{{left_top_2.four[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_2.four[0] || left_top_2.four[0].value == null || left_top_2.four[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
							</div>
							<div class="top-row">
								<div class="row-data one">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_3.one[0] ? left_top_3.one[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_3.one[0]">{{left_top_3.one[0].name}}</span>
											<span v-if="!left_top_3.one[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_3.one[0] && left_top_3.one[0].value!=null && left_top_3.one[0]!=undefined">
											<div v-if="left_top_3.one[0].value != null && left_top_3.one[0].value != undefined">{{common.fmoney(left_top_3.one[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_3.one[0].value != null && left_top_3.one[0].value != undefined">{{left_top_3.one[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_3.one[0] || left_top_3.one[0].value == null || left_top_3.one[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
								<div class="row-data two">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_3.two[0] ? left_top_3.two[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_3.two[0]">{{left_top_3.two[0].name}}</span>
											<span v-if="!left_top_3.two[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_3.two[0] && left_top_3.two[0].value!=null && left_top_3.two[0]!=undefined">
											<div v-if="left_top_3.two[0].value != null && left_top_3.two[0].value != undefined">{{common.fmoney(left_top_3.two[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_3.two[0].value != null && left_top_3.two[0].value != undefined">{{left_top_3.two[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_3.two[0] || left_top_3.two[0].value == null || left_top_3.two[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
								<div class="row-data three">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_3.three[0] ? left_top_3.three[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_3.three[0]">{{left_top_3.three[0].name}}</span>
											<span v-if="!left_top_3.three[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_3.three[0] && left_top_3.three[0].value!=null && left_top_3.three[0]!=undefined">
											<div v-if="left_top_3.three[0].value != null && left_top_3.three[0].value != undefined">{{common.fmoney(left_top_3.three[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_3.three[0].value != null && left_top_3.three[0].value != undefined">{{left_top_3.three[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_3.three[0] || left_top_3.three[0].value == null || left_top_3.three[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
								<div class="row-data four">
									<div class="data-content clearfix">
										<div class="top-name" :title="left_top_3.four[0] ? left_top_3.four[0].name : ''">
											<img src="../../assets/image/indexEditor/model7/textLeft.png" />
											<span v-if="left_top_3.four[0]">{{left_top_3.four[0].name}}</span>
											<span v-if="!left_top_3.four[0]"> - </span>
											<img src="../../assets/image/indexEditor/model7/textRight.png" />
										</div>
										<div class="top-value" v-if="left_top_3.four[0] && left_top_3.four[0].value!=null && left_top_3.four[0]!=undefined">
											<div v-if="left_top_3.four[0].value != null && left_top_3.four[0].value != undefined">{{common.fmoney(left_top_3.four[0].value)}}</div>
											<div style="font-size: 12px;" v-if="left_top_3.four[0].value != null && left_top_3.four[0].value != undefined">{{left_top_3.four[0].unit}}</div>
										</div>
										<div class="top-value" v-if="!left_top_3.four[0] || left_top_3.four[0].value == null || left_top_3.four[0].value == undefined">
											<div style="font-size: 22px;"> - </div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!--组态地图-->
						<div class="left_center" :style="leftcenterStyle" ref="getPreviewDom" id="preview" :class="{'left_centerQP': FullShowMark,'left_centerBy123':mouldId==1||mouldId==2||mouldId==3}">
							<div class="mask" v-if="maskStateByFull"></div>
							<AttrBlackboard ref="addrobotFullScreen" @changeDivSpan="changeDivSpan" :type="'FullScreen'" style="font-weight: 500 !important;"></AttrBlackboard>
							<div class="center-box" :style="centerBoxStyle" :class="{'centerBoxBy7': mouldId == 7}">
								<!--<div class="center_title" :class="{'centerTitleFull': FullShowMark,'TitleTwo': mouldId==2||mouldId==5,'TitleThree': mouldId==3||mouldId==6}">{{$store.state.companyTitle}}</div>-->
								<div class="center_working" v-if="mouldId == 7">
									<p>系统运行状态</p>
									<div :class="systemState==1?'workNormal':'workError'">{{systemState==1?'正常':'异常'}}</div>
								</div>
								<div class="center_button" :style="centerButtonStyle" :class="{'centerBoxFull': FullShowMark,'ButtonTwo': mouldId==2||mouldId==5,'ButtonThree': mouldId==3||mouldId==6,'darkButton': mouldId==4||mouldId==5||mouldId==6,'lightButton':mouldId==1||mouldId==2||mouldId==3}">
									<div class="box editorClear" title="视角复原" @click="editorClear()"></div>
									<div class="box noFullTwo" title="显示设备名称(Alt)" data-name='1' :class="{'leftCenter': AttrShow}"></div>
									<div class="box noFull" title="组态全屏" v-if="!FullShowMark" @click="requestFullScreen()"></div>
									<div class="box rightCenter" title="退出全屏" v-if="FullShowMark" @click="requestFullScreenClose()"></div>
								</div>
								<preview ref="Addrobot" class="overunset" openMqtt='1' :scaleLev="scaleLev" :AttrShow='AttrShow' :style="{'transform':'scaleX('+scaleLev.scaleX+') scaleY('+scaleLev.scaleY+')'}" :class="{'noScale': FullShowMark}" :mouldId="mouldId" @attr='Addrobot'></preview>

								<!--小地图-->
								<!--<div class="MiniMap" :class="{'borderFFF': mouldId == 7}" :style="MiniMapStyle(scaleLev,$store.state.shotImg)" @mousewheel="handleScroll" v-show="$refs.Addrobot?scaleLevel!=$refs.Addrobot.scaleMaxValue:false">
									<div class="minizz"></div>
									<img class="shotImg" v-show="$store.state.shotImg!=''" :src="$store.state.shotImg" :style="MiniMapStyle(scaleLev,$store.state.shotImg)" draggable="false" />
									<div class="image-move-wapper" :style="{left: -dragContainer.newPoint.left + 'px', top: -dragContainer.newPoint.top + 'px'}">
										<div class="image-show-box" ref="imageShowBox" :style="nktBoxStyle(scaleLevel,scaleLev)">
											<div class="drag-container" ref="dragContainer" :style="{'left': dragContainer.newPoint.left+'px', 'top': dragContainer.newPoint.top+'px', width: 1345 * scaleLev.scaleX * .2 + 'px', height: 838 * scaleLev.scaleY * .2 + 'px'}" @mousedown="DragContainerMouseDown">
												<img class="drag-img" v-show="$store.state.shotImg!=''" :src="$store.state.shotImg" :style="MiniMapStyle(scaleLev,$store.state.shotImg)" draggable="false" />
											</div>
										</div>
									</div>
								</div>-->

								<!--图例-->
								<div class="center_tootip clearfix" :style="tootipStyle" :class="{'darkTootip': mouldId==4||mouldId==5||mouldId==6||mouldId==7,'lightTootip':mouldId==1||mouldId==2||mouldId==3}">
									<div class="legend">
										<div class="contentBox" @mouseenter="changeTip" @mouseleave="closeTip">
											<div class="tip" :class="{'active': tipMark}"><span>图例</span></div>
											<div class="tip_body clearfix" ref="tipBody">
												<div class="tip_box zc">
													<span>正常</span>
												</div>
												<div class="tip_box jg">
													<span>警告</span>
												</div>
												<div class="tip_box gz">
													<span>故障</span>
												</div>
												<div class="tip_box gj">
													<span>关机</span>
												</div>
												<div class="tip_box lx">
													<span>离线</span>
												</div>
											</div>
										</div>
									</div>
									<div class="errorTip alltip" :style="errorTipStyle">
										<span>全局报警概览</span>
									</div>
									<!--<div class="stateTip alltip" :style="stateTipStyle">
										<span>全局状态指示</span>
									</div>-->
								</div>
							</div>
						</div>
						<!--组态地图-->

						<div class="left_bottom" v-if="mouldId == 1 || mouldId == 4">
							<div class="bottom-box">
								<!--left_bottom.one[0]
									left_bottom.one[1]
									left_bottom.one[2]-->
								<!--选择类型为数据集时-->
								<div class="dataSet">

									<!--标题-->
									<div class="datasetHeader" v-if="left_bottom.one.length > 1">
										<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':left_bottom_one==index}" v-for="(item,index) in left_bottom.one" @click="changeBox('left_bottom_one',index)">
											<div class="headerbox">
												{{item.name}}
											</div>
											<div class="shu" v-if="index != left_bottom.one.length-1"></div>
										</div>
									</div>
									<div class="datasetTitle" :title='left_bottom.one[0].name' v-if="left_bottom.one.length == 1">
										{{left_bottom.one[0].name}}
									</div>

									<!--数据集-->
									<div class="datasetBox" :index='index' v-show="left_bottom_one==index" :ref="'left_bottom_one'+index" v-for="(item,index) in left_bottom.one">
										<!--数据集为表格时-->
										<div class="datasetTable" v-if="item.chartType==4">
											<el-table height="100%" :highlight-current-row="true" v-if="tableList['left_bottom_one'+index]" :data="tableList['left_bottom_one'+index].data" tooltip-effect="dark" :fit="true">
												<el-table-column width="20">
												</el-table-column>
												<el-table-column prop="address" width="140" label="时间">
													<template slot-scope="scope">
														<div class="createdTimeForTable" style="letter-spacing: 0.5px;">{{ changeTime(scope.row.createdTime)}}</div>
													</template>
												</el-table-column>

												<el-table-column v-for="(itemD,index) in tableList['left_bottom_one'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameA.split('/*/')[0]" v-if="itemD.nameA != ''">
													<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameA],itemD.unit)}}</template>
												</el-table-column>
												<el-table-column v-for="(itemD,index) in tableList['left_bottom_one'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameB" v-if="itemD.nameB != ''">
													<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameB],itemD.unit)}}</template>
												</el-table-column>
												<el-table-column v-for="(itemD,index) in tableList['left_bottom_one'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameC" v-if="itemD.nameC != ''">
													<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameC],itemD.unit)}}</template>
												</el-table-column>

												<!--<el-table-column>
												</el-table-column>-->
											</el-table>
										</div>
									</div>
								</div>
								<div class="left_top_" v-if="mouldId == 4"></div>
								<div class="right_top_" v-if="mouldId == 4"></div>
								<div class="left_bottom_" v-if="mouldId == 4"></div>
								<div class="right_bottom_" v-if="mouldId == 4"></div>
							</div>
						</div>

					</div>
					<div class="right" :class="{'ttt': mouldId == 7}" :style="rightStyle" v-if="mouldId != 3 && mouldId != 6">

						<div class="right_ right1 OneDataSet" v-if="mouldId != 1 && mouldId != 4 && mouldId != 7">
							<!--right.one[0]-->
							<!--选择类型为数据集时-->
							<div class="dataSet">

								<!--标题-->
								<div class="datasetHeader" v-if="right.one.length > 1">
									<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':right_one==index}" v-for="(item,index) in right.one" @click="changeBox('right_one',index)">
										<div class="headerbox">
											{{item.name}}
										</div>
										<div class="shu" v-if="index != right.one.length-1"></div>
									</div>
								</div>
								<div class="datasetTitle" :title='right.one[0].name' v-if="right.one.length == 1">
									{{right.one[0].name}}
								</div>

								<!--数据集-->
								<div class="datasetBox" :index='index' v-show="right_one==index" :ref="'right_one'+index" v-for="(item,index) in right.one">
									<!--数据集为表格时-->
									<div class="datasetTable clearfix rightTopTable lsDiv" :style="fontSizeUpdate(item.value,item.unit,'rightTopTable')">
										<span class="TableValue" v-if="item.value != null && item.value != undefined">{{common.fmoney(item.value)}}</span>
										<span class="TableValue" v-if="item.value == null && item.value == undefined"> - </span>
										<span class="TableUnit" v-if="item.value != null && item.value != undefined">{{item.unit}}</span>
										<!--<span class="TableUnitEn">℃</span>-->
									</div>
								</div>
							</div>
						</div>

						<div class="right_ right2 OneDataSet" v-if="mouldId != 1 && mouldId != 4 && mouldId != 7">
							<!--right.two[0]-->
							<!--选择类型为数据集时-->
							<div class="dataSet">

								<!--标题-->
								<div class="datasetHeader" v-if="right.two.length > 1">
									<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':right_two==index}" v-for="(item,index) in right.two" @click="changeBox('right_two',index)">
										<div class="headerbox">
											{{item.name}}
										</div>
										<div class="shu" v-if="index != right.two.length-1"></div>
									</div>
								</div>
								<div class="datasetTitle" :title='right.two[0].name' v-if="right.two.length == 1">
									{{right.two[0].name}}
								</div>

								<!--数据集-->
								<div class="datasetBox" :index='index' v-show="right_two==index" :ref="'right_two'+index" v-for="(item,index) in right.two">
									<!--数据集为表格时-->
									<div class="datasetTable clearfix lsDiv" v-if="mouldId==2||mouldId==5" :style="fontSizeUpdate(item.value,item.unit,'rightTopTable')">
										<span class="TableValue" v-if="item.value != null && item.value != undefined">{{common.fmoney(item.value)}}</span>
										<span class="TableValue" v-if="item.value == null && item.value == undefined"> - </span>
										<span class="TableUnit" v-if="item.value != null && item.value != undefined">{{item.unit}}</span>
										<!--<span class="TableUnitEn">℃</span>-->
									</div>
								</div>
							</div>
						</div>

						<div class="right_ right3" v-if="mouldId == 1 || mouldId == 4">
							<!--right.three[0]
								right.three[1]
								right.three[2]-->
							<div class="dataSet">

								<!--标题-->
								<div class="datasetHeader" v-if="right.three.length > 1">
									<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':right_three==index}" v-for="(item,index) in right.three" @click="changeBox('right_three',index)">
										<div class="headerbox">
											{{item.name}}
										</div>
										<div class="shu" v-if="index != right.three.length-1"></div>
									</div>
								</div>
								<div class="datasetTitle" :title='right.three[0].name' v-if="right.three.length == 1">
									{{right.three[0].name}}
								</div>

								<!--数据集-->
								<div class="datasetBox" :index='index' v-show="right_three==index" :ref="'right_three'+index" v-for="(item,index) in right.three">
									<!--数据集为表格时-->
									<div class="datasetTable" v-if="item.chartType==4">
										<el-table height="100%" :highlight-current-row="true" v-if="tableList['right_three'+index]" :data="tableList['right_three'+index].data" tooltip-effect="dark" :fit="true">
											<el-table-column width="20">
											</el-table-column>
											<el-table-column prop="address" width="140" label="时间">
												<template slot-scope="scope">
													<div class="createdTimeForTable" style="letter-spacing: 0.5px;">{{ changeTime(scope.row.createdTime)}}</div>
												</template>
											</el-table-column>

											<el-table-column v-for="(itemD,index) in tableList['right_three'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameA.split('/*/')[0]" v-if="itemD.nameA != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameA],itemD.unit)}}</template>
											</el-table-column>
											<el-table-column v-for="(itemD,index) in tableList['right_three'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameB" v-if="itemD.nameB != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameB],itemD.unit)}}</template>
											</el-table-column>
											<el-table-column v-for="(itemD,index) in tableList['right_three'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameC" v-if="itemD.nameC != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameC],itemD.unit)}}</template>
											</el-table-column>

											<!--<el-table-column>
											</el-table-column>-->
										</el-table>

									</div>
								</div>
							</div>
						</div>

						<div class="right4" v-if="mouldId == 7">
							<div class="right4_ right4_left">
								<div class="newDataSet clearfix" v-if="right.six.length != 0">
									<div class="newName" :title="right.six[0].name">{{right.six[0].name}}</div>
									<div class="newValue">{{ common.fmoney(rightSix.value) + rightSix.unit }}</div>
									<div class="newDataBox" :index='index' :ref="'right_six'+index" v-for="(item,index) in right.six"></div>
								</div>
							</div>
							<div class="right4_ right4_right">
								<div class="newName" title="">报警统计</div>
								<div class="newDataBox threeBg">
									<div class="lBox clearfix">
										<div class="cbody l1" :class="{'openL1': openL1}" @click="changeOpenL(1)">未确认</div>
										<div class="cbody l2" :class="{'openL2': openL2}" @click="changeOpenL(2)">已确认</div>
										<div class="cbody l3" :class="{'openL3': openL3}" @click="changeOpenL(3)">已恢复</div>
									</div>
									<div class="cBox clearfix">
										<div class="cbody c1" :class="{'openC1': openC1}" @click="changeOpenC(1)">提示</div>
										<div class="cbody c2" :class="{'openC2': openC2}" @click="changeOpenC(2)">警告</div>
										<div class="cbody c3" :class="{'openC3': openC3}" @click="changeOpenC(3)">故障</div>
									</div>
									<div class="Alarm" :style="{'z-index': outerZindex}" ref="Alarm"></div>
									<div class="Alarm2" :style="{'z-index': innerZindex,'top': typePreview?'25px':'15px'}" ref="Alarm2"></div>
								</div>
							</div>
						</div>

						<div class="right_ right_center" :class="{'right_Old': mouldId == 7}">
							<!--right.four[0]
								right.four[1]
								right.four[2]-->
							<div class="dataSet">

								<!--标题-->
								<div class="datasetHeader" v-if="right.four.length > 1 && mouldId != 7">
									<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':right_four==index}" v-for="(item,index) in right.four" @click="changeBox('right_four',index)">
										<div class="headerbox">
											{{item.name}}
										</div>
										<div class="shu" v-if="index != right.four.length-1"></div>
									</div>
								</div>
								<div class="datasetTitle" :title='right.four[0].name' v-if="right.four.length == 1">
									{{right.four[0].name}}
								</div>

								<!--数据集-->
								<div class="datasetBox" :index='index' v-show="right_four==index" :ref="'right_four'+index" v-for="(item,index) in right.four">
									<!--数据集为表格时-->
									<div class="datasetTable" v-if="item.chartType==4">
										<el-table height="100%" :highlight-current-row="true" v-if="tableList['right_four'+index]" :data="tableList['right_four'+index].data" tooltip-effect="dark" :fit="true">
											<el-table-column width="20">
											</el-table-column>
											<el-table-column prop="address" width="140" label="时间">
												<template slot-scope="scope">
													<div class="createdTimeForTable" style="letter-spacing: 0.5px;">{{ changeTime(scope.row.createdTime)}}</div>
												</template>
											</el-table-column>

											<el-table-column v-for="(itemD,index) in tableList['right_four'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameA.split('/*/')[0]" v-if="itemD.nameA != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameA],itemD.unit)}}</template>
											</el-table-column>
											<el-table-column v-for="(itemD,index) in tableList['right_four'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameB" v-if="itemD.nameB != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameB],itemD.unit)}}</template>
											</el-table-column>
											<el-table-column v-for="(itemD,index) in tableList['right_four'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameC" v-if="itemD.nameC != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameC],itemD.unit)}}</template>
											</el-table-column>

											<!--<el-table-column>
											</el-table-column>-->
										</el-table>

									</div>
								</div>
							</div>
						</div>

						<div class="right_ right_bottom" :class="{'right_Old': mouldId == 7}">
							<!--right.five[0]
								right.five[1]
								right.five[2]-->
							<div class="dataSet">

								<!--标题-->
								<div class="datasetHeader" v-if="right.five.length > 1 && mouldId != 7">
									<div class="headerFatherBox" :title="item.name" :class="{'marLeftZero':index == 0,'active':right_five==index}" v-for="(item,index) in right.five" @click="changeBox('right_five',index)">
										<div class="headerbox">
											{{item.name}}
										</div>
										<div class="shu" v-if="index != right.five.length-1"></div>
									</div>
								</div>
								<div class="datasetTitle" :title='right.five[0].name' v-if="right.five.length == 1">
									{{right.five[0].name}}
								</div>

								<!--数据集-->
								<div class="datasetBox" :index='index' v-show="right_five==index" :ref="'right_five'+index" v-for="(item,index) in right.five">
									<!--数据集为表格时-->
									<div class="datasetTable" v-if="item.chartType==4">
										<el-table height="100%" :highlight-current-row="true" v-if="tableList['right_five'+index]" :data="tableList['right_five'+index].data" tooltip-effect="dark" :fit="true">
											<el-table-column width="20">
											</el-table-column>
											<el-table-column prop="address" width="140" label="时间">
												<template slot-scope="scope">
													<div class="createdTimeForTable" style="letter-spacing: 0.5px;">{{ changeTime(scope.row.createdTime)}}</div>
												</template>
											</el-table-column>

											<el-table-column v-for="(itemD,index) in tableList['right_five'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameA.split('/*/')[0]" v-if="itemD.nameA != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameA],itemD.unit)}}</template>
											</el-table-column>
											<el-table-column v-for="(itemD,index) in tableList['right_five'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameB" v-if="itemD.nameB != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameB],itemD.unit)}}</template>
											</el-table-column>
											<el-table-column v-for="(itemD,index) in tableList['right_five'+index].attr" :key="index+Math.random()" prop="address" width="180" :label="itemD.nameC" v-if="itemD.nameC != ''">
												<template slot-scope="scope">{{ showTableData(scope.row[itemD.nameC],itemD.unit)}}</template>
											</el-table-column>

											<!--<el-table-column>
											</el-table-column>-->
										</el-table>

									</div>
								</div>
							</div>
						</div>

						<div class="right_last" v-if="mouldId == 7">
							<div class="right_last_ right_last_1">
								<div class="last_body clearfix" :class="{'right_last_colorY': rightSeven.type == 2,'right_last_colorR': rightSeven.type == 3}" v-if="right.seven[0]">
									<div class="last_name">{{right.seven[0].name?right.seven[0].name:''}}</div>
									<div class="last_box" ref="right_seven0"></div>
									<div class="last_value">{{common.fmoney(rightSeven.value) + ' ' + rightSeven.unit}}</div>
								</div>
							</div>
							<div class="right_last_ right_last_2">
								<div class="last_body clearfix" :class="{'right_last_colorY': rightEight.type == 2,'right_last_colorR': rightEight.type == 3}" v-if="right.eight[0]">
									<div class="last_name">{{right.eight[0].name?right.eight[0].name:''}}</div>
									<div class="last_box" ref="right_eight0"></div>
									<div class="last_value">{{common.fmoney(rightEight.value) + ' ' + rightEight.unit}}</div>
								</div>
							</div>
							<div class="right_last_ right_last_3">
								<div class="last_body clearfix" :class="{'right_last_colorY': rightNine.type == 2,'right_last_colorR': rightNine.type == 3}" v-if="right.nine[0]">
									<div class="last_name">{{right.nine[0].name?right.nine[0].name:''}}</div>
									<div class="last_box" ref="right_nine0"></div>
									<div class="last_value">{{common.fmoney(rightNine.value) + ' ' + rightNine.unit}}</div>
								</div>
							</div>
							<div class="right_last_ right_last_4" style="margin-right: 0 !important;">
								<div class="last_body clearfix" :class="{'right_last_colorY': rightTen.type == 2,'right_last_colorR': rightTen.type == 3}" v-if="right.ten[0]">
									<div class="last_name">{{right.ten[0].name?right.ten[0].name:''}}</div>
									<div class="last_box" ref="right_ten0"></div>
									<div class="last_value">{{common.fmoney(rightTen.value) + ' ' + rightTen.unit}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<div class="popup">
			<!-- 验证码授权 -->
			<div class="popup-clear" v-show='functionShow' id="privilege" style="position: fixed; height: 349px;text-align: left;margin-left: -216px">
				<div class="popup-title">
					获取验证码授权<i><img :src="notes" title="提示" style="position: relative; left: 5px; top: 3px;"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
				</div>
				<div class="popup-lab">
					手机号：
					<el-input disabled v-model="phone">{{phone}}</el-input>
				</div>
				<div class="popup-lab clearfix">
					<p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
					<el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
						<el-form-item prop="verifyCode">
							<el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
						</el-form-item>
					</el-form>
					<div class="code-box">
						<p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
						<p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
					</div>
				</div>
				<div class="popup-lab">
					<p class="btn-box" style="margin-top: 26px;text-align: center;">
						<el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
						<el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
					</p>
				</div>
			</div>
		</div>
		<div class="mask" v-if="maskState"></div>
		<AttrBlackboard ref="addrobot" @changeDivSpan="changeDivSpan"></AttrBlackboard>
	</div>
</template>
<script>
	import 'echarts-liquidfill/src/liquidFill.js'
	import preview from '@/components/MapEditor/Preview/indexPreview';
	import AttrBlackboard from '@/components/MapEditor/Preview/preview/AttrBlackboard.vue'
	import { mapState } from 'vuex';
	export default {
		name: 'IndexEditShow',
		data() {
			var self = this;
			return {
				//用于判断模板7中折线图是否只有一个属性
				NewLineByOneAttr: false,

				//存放模板7中折线图的时间
				setxAxisTime: [],

				//模板7中 NewLine的真实数据 用于展示鼠标移入时显示真实数据功能
				v_real: [],

				//当前水球体的背景
				waterGreen: require('@/assets/image/indexEditor/model7/water2.png'),
				waterRed: require('@/assets/image/indexEditor/model7/water1.png'),

				//控制3D环形图开关
				openL1: true,
				openL2: true,
				openL3: true,
				openC1: true,
				openC2: true,
				openC3: true,

				//存放报警统计3D环形图两组数据
				categoryData: [],
				levelData: [],
				categoryDataReal: [],
				levelDataReal: [],

				//存放3D环形图两个层级
				innerZindex: 2,
				outerZindex: 1,

				//存放当前模板7中的报警统计两个3D环形图
				InnerAlarmCharts: null, //内圈
				OuterAlarmCharts: null, //外圈

				//用于存放当前right six盒子中的值和单位
				rightTen: {
					value: 0,
					unit: '',
					type: 1
				},
				rightNine: {
					value: 0,
					unit: '',
					type: 1
				},
				rightEight: {
					value: 0,
					unit: '',
					type: 1
				},
				rightSeven: {
					value: 0,
					unit: '',
					type: 1
				},
				rightSix: {
					value: 0,
					unit: ''
				},

				dragContainer: {
					box: {
						w: 0,
						h: 0
					},
					point: {
						left: 0,
						top: 0
					},
					newPoint: {
						left: 0,
						top: 0
					}
				},
				mousePoint: {
					x: 0,
					y: 0
				},
				imageShowBox: {
					box: {
						w: 0,
						h: 0
					},
					dragcheck: {
						h: true,
						v: true
					}
				},
				AltMark: false, //判断是否按下Alt开关
				tipMark: false, //图例开关

				MqttOption: {}, //mqtt主题配置
				MqttByDataSetUrl: [], //数据集时间范围类型为 实时 情况下的url数组(多个)
				MqttCharts: [ /*{id:1,charts: {}}*/ ], //所有图表init实例化存放数组
				//退订时的回调
				MqttExitBackFunction: {
					onSuccess() {},
					onFailure(error) {}
				},

				typePreview: false, //判断是否为预览进入
				AttrShow: false, //是否在界面展示看板

				loadingMark: false, //从列表点击进入的时候的加载loading

				ShowContent: true, //显示页面内容开关
				type: 1, //当前企业的首页编辑类型 1为正常型组态,2为增强型组态(3D)

				nullData: require('@/assets/image/index/nullData.png'),

				totalChartsNum: 0, //需要加载的图表总数
				NowLoadNum: 0, //当前已加载完成的图表数

				FullShowMark: false, //判断当前是否为全屏的状态
				maskState: false, //遮罩
				maskStateByFull: false, //全屏状态的遮罩
				FullType: '', //用于判断当前调整窗口大小的类型是否为开启全屏

				//模板列表
				mouldOptions: [{
					id: 1,
					name: '模板一',
					img: require('../../assets/image/indexEditor/mould/mould1.png'),
				}, {
					id: 2,
					name: '模板二',
					img: require('../../assets/image/indexEditor/mould/mould2.png'),
				}, {
					id: 3,
					name: '模板三',
					img: require('../../assets/image/indexEditor/mould/mould3.png'),
				}, {
					id: 4,
					name: '模板四',
					img: require('../../assets/image/indexEditor/mould/mould4.png'),
				}, {
					id: 5,
					name: '模板五',
					img: require('../../assets/image/indexEditor/mould/mould5.png'),
				}, {
					id: 6,
					name: '模板六',
					img: require('../../assets/image/indexEditor/mould/mould6.png'),
				}, {
					id: 7,
					name: '模板七',
					img: require('../../assets/image/indexEditor/mould/mould7-1.png'),
				}],

				mouldId: null, //当前选中模板id

				systemState: 1, //当前全局系统运行状态显示  0为异常, 1为正常
				systemObj: {}, //存放当前全局系统的配置(设备code id 属性code)

				//数据集列表
				DataSetList: [],

				//设备列表
				DeviceList: [],

				//当前页面表格总存放地
				tableList: {},

				//当前操作的模型 (用于页面双向绑定)
				left_top: {
					one: [
						/*{
							name: '今日电量 ',
							chartType: 4,
							value: 66,
							unit: '%'
						}*/
					],
					two: [],
					three: [],
					four: [],
					five: [],
				},
				left_top_2: {
					one: [],
					two: [],
					three: [],
					four: []
				},
				left_top_3: {
					one: [],
					two: [],
					three: [],
					four: []
				},
				left_bottom: {
					one: [],
				},
				right: {
					one: [],
					two: [],
					three: [],
					four: [],
					five: [],
					six: [], //1
					seven: [], //1
					eight: [], //1
					nine: [], //1
					ten: [], //1
				},

				//当前操作的模型 (用于转换数据格式 保存 获取)
				mouldBox: [{
					name: 'left_top',
					children: [{
						name: 'one'
					}, {
						name: 'two'
					}, {
						name: 'three'
					}, {
						name: 'four'
					}, {
						name: 'five'
					}]
				}, {
					name: 'left_top_2',
					children: [{
						name: 'one'
					}, {
						name: 'two'
					}, {
						name: 'three'
					}, {
						name: 'four'
					}]
				}, {
					name: 'left_top_3',
					children: [{
						name: 'one'
					}, {
						name: 'two'
					}, {
						name: 'three'
					}, {
						name: 'four'
					}]
				}, {
					name: 'left_bottom',
					children: [{
						name: 'one'
					}]
				}, {
					name: 'right',
					children: [{
						name: 'one'
					}, {
						name: 'two'
					}, {
						name: 'three'
					}, {
						name: 'four'
					}, {
						name: 'five'
					}, {
						name: 'six'
					}, {
						name: 'seven'
					}, {
						name: 'eight'
					}, {
						name: 'nine'
					}, {
						name: 'ten'
					}]
				}],

				/*配置图表颜色*/
				color: ['#1C7DFA', '#4CD964', '#1DE9B6', '#FFF200'],
				LineColor: ['#1C7DFA', '#4CD964', '#1DE9B6', '#FFF200'],
				PieColor: ['#1C7DFA', '#4CD964', '#1DE9B6', '#FFF200'],
				BarColor: ['#1C7DFA', '#4CD964', '#1DE9B6', '#FFF200'],
				/*显示dataSet切换卡*/
				left_top_one: 0,
				left_top_two: 0,
				left_top_three: 0,
				left_top_four: 0,
				left_top_five: 0,
				left_bottom_one: 0,
				right_one: 0,
				right_two: 0,
				right_three: 0,
				right_four: 0,
				right_five: 0,

				//获取数据集列表定时器 (因为consoleIndex获取用户信息的接口与当前数据集列表接口不同步)
				getCompanyCode: null,

				//企业运维屏信息
				CompanyScreen: {},

				//用于判断当前是否按住Alt 如果是 则取消mousemove时的回调
				altMark: false,


				//所有产品接口获取的物模型存储对象
				ProductFeatureCP: [],

				//报警状态码 0为正常, 1为提示(黄色) 2为警告或故障(红色) -1为离线
				errorState: -1,
				//设备状态码  0为正常, 1为提示(黄色) 2为警告或故障(红色)
				deviceState: 0,

				//用户提权 所有属性初始
				notes: require('@/assets/image/organize/notes.png'),
				verifyForm: {
					verifyCode: '',
				},
				functionShow: false,
				VerifyArr: [],
				verifyCode: '',
				second: 60,
				getCodeShow: true,
				countdownShow: false,
				phone: '',
				time: null,
				rules: {
					verifyCode: [{
						message: '请输入验证码',
						required: true,
						trigger: 'blur'
					}]
				},
        VirtualDevice:{propertyList:[]},
			}
		},
		computed: {
			...mapState("defaultChartsOptions", {
				system_options: 'system_options',
				ChartsDataLength: 'ChartsDataLength',
				NewChartsDataLength: 'NewChartsDataLength'
			}),
			...mapState("defaultImgOptions", {
				ImageBaseUrl: 'ImageBaseUrl',
				editorLeft: 'editorLeft',
				editorTop: 'editorTop'
			}),

      ProductFeature(){
        return this.$store.state.ProductFeature
      },
			nktBoxStyle() {
				return(newScaleLevel, scaleLev) => {
					//					this.$nextTick(() => {
					let scaleLevel = sessionStorage.getItem('scaleLevel') ? sessionStorage.getItem('scaleLevel') : this.scaleLevel //初始缩放等级
					let defaultWidth = 1345 * scaleLev.scaleX * .2; //默认的小地图最大宽度
					let defaultHeight = 838 * scaleLev.scaleY * .2; //默认的小地图最大高度
					let DelScaleLev = 1 - (newScaleLevel - scaleLevel); //1 - (当前缩放等级 - 初始缩放等级) = 小地图需要缩放的等级
					let top = this.dragContainer.newPoint.top; //当前区域的定位top
					let left = this.dragContainer.newPoint.left; //当前区域的定位left
					let ret = {}

					if(this.$refs.Addrobot) {
						if(this.$refs.Addrobot.scaleMaxValue) {
							//记录未修改之前的区域宽高
							if(!this.nktWidth) {
								this.nktWidth = Math.ceil(defaultWidth)
								this.nktHeight = Math.ceil(defaultHeight)
							}

							if(scaleLevel == newScaleLevel) {
								//将初始缩放等级 看做是宽高都为小地图100%
								ret.width = defaultWidth + 'px'
								ret.height = defaultHeight + 'px'

							} else {
								//计算差值之后的区域宽高
								ret.width = defaultWidth * DelScaleLev + 'px'
								ret.height = defaultHeight * DelScaleLev + 'px'
							}

							//计算需要增加的差值left top  使缩放时显示效果为中心点缩放
							let DelLeft = (this.nktWidth - Math.ceil(ret.width.split('px')[0])) / 2;
							let DelTop = (this.nktHeight - Math.ceil(ret.height.split('px')[0])) / 2;

							//更新当前left top
							this.dragContainer.newPoint.left -= DelLeft
							this.dragContainer.newPoint.top -= DelTop

							//计算因为要为中心点缩放而导致偏差的left top
							this.DelX = Math.ceil((defaultWidth - Math.ceil(ret.width.split('px')[0])) / 2);
							this.DelY = Math.ceil((defaultHeight - Math.ceil(ret.height.split('px')[0])) / 2)

							//更新区域宽高 用于下次计算
							this.nktWidth = Math.ceil(ret.width.split('px')[0])
							this.nktHeight = Math.ceil(ret.height.split('px')[0])

							if(this.$refs.Addrobot) {
								this.$refs.Addrobot.editorTopUpdate(Math.ceil((Number(this.dragContainer.newPoint.top) + this.DelY) / .2))
								this.$refs.Addrobot.editorLeftUpdate(Math.ceil((Number(this.dragContainer.newPoint.left) + this.DelX) / .2))
							}

							//console.log(this.nktWidth,this.nktHeight,top,left)
							return ret
							//})
						}
					}

					return ret;
				}
			},
			scaleLevel() { //缩放等级:0.3-1
				return this.$store.getters['defaultImgOptions/getScaleLevel'];
			},
			MiniMapStyle() {
				return(scaleLev, imgUrl) => {
					let width = 1345 * scaleLev.scaleX
					let height = 838 * scaleLev.scaleY
					let bottom = 0;
					let right;
					if(this.mouldId == 2 || this.mouldId == 3 || this.mouldId == 5 || this.mouldId == 6) {
						bottom = 54
					} else if(this.mouldId == 7) {
						bottom = -13;
						right = '65px'
					}
					return {
						'width': width * .2 + 'px',
						'height': height * .2 + 'px',
						'bottom': bottom + 'px',
						'right': right,
						//'background-image': 'url(' + imgUrl + ')',
					}
				}

			},
			fontSizeUpdate() {
				return(value, unit, className) => {
					if(value || value == 0) {
						if(document.getElementsByClassName(className).length == 0) return;
						if(!unit) unit = '';
						let length = String(this.common.fmoney(value) + unit).length + 2;
						let maxWidth = document.getElementsByClassName(className)[0].offsetWidth;
						/*
						 * 1px是因为数字所占是文字所占的长度的一半再减1; 4px为单位的textIndent长度
						 * 算法 => 容器宽度÷(当前数字长度/2-1px)
						 */
						let FontSize = parseInt(maxWidth) / (length / 2 - 1);
						if(FontSize > 27) {
							FontSize = 27
						}

						return {
							'font-size': parseInt(FontSize) + 'px !important'
						}
					}
				}
			},
			fontSizeUpdate7() {
				return(value, unit, className) => {
					if(value || value == 0) {
						if(document.getElementsByClassName(className).length == 0) return;
						if(!unit) unit = '';
						let length = String(this.common.fmoney(value) + unit).length + 2;
						let maxWidth = document.getElementsByClassName(className)[0].offsetWidth;
						/*
						 * 1px是因为数字所占是文字所占的长度的一半再减1; 4px为单位的textIndent长度
						 * 算法 => 容器宽度÷(当前数字长度/2-1px)
						 */
						let FontSize = parseInt(maxWidth) / (length / 2 - 1);
						if(FontSize > 22) {
							FontSize = 22
						}

						return {
							'font-size': parseInt(FontSize) + 'px !important'
						}
					}
				}
			},
			errorTipStyle() {
				let url;
				if(this.errorState == -1) {
					url = require('@/assets/image/editor/Device/gray_error.png')
				} else if(this.errorState == 0) {
					url = require('@/assets/image/editor/Device/green_error.png')
				} else if(this.errorState == 1) {
					url = require('@/assets/image/editor/Device/yellow_error.png')
				} else if(this.errorState == 2) {
					url = require('@/assets/image/editor/Device/red_error.png')
				}
				return {
					'background-image': 'url(' + url + ')'
				}
			},
			stateTipStyle() {
				let url;
				if(this.deviceState == 0) {
					url = require('@/assets/image/editor/Device/green_point.png')
				} else if(this.deviceState == 1) {
					url = require('@/assets/image/editor/Device/yellow_point.png')
				} else if(this.deviceState == 2) {
					url = require('@/assets/image/editor/Device/red_point.png')
				}
				return {
					'background-image': 'url(' + url + ')'
				}
			},
			showTableData() {
				return(value, unit) => {
					if(value == null) {
						return '-'
					} else {
						unit = unit ? unit : ''
						return this.common.fmoneyNoFix(value) + ' ' + unit
					}
				}
			},
			leftcenterStyle() {
				if(this.mouldId == 2 || this.mouldId == 5) {
					return {
						top: '0',
						bottom: '0',
					}
				} else if(this.mouldId == 1 || this.mouldId == 4) {
					return {
						top: '41px',
					}
				} else if(this.mouldId == 3 || this.mouldId == 6) {
					return {
						bottom: '0',
						right: '31px'
					}
				} else if(this.mouldId == 7) {
					return {
						bottom: '29px'
					}
				}
			},
			centerBoxStyle() {
				if(this.mouldId == 7) {
					return {
						'margin-left': '20px',
						'border-radius': '0',
						'width': 'calc(100% - 20px)'
					}
				}
			},
			centerButtonStyle() {
				if(this.mouldId == 7) {
					return {
						right: '15px',
						top: '15px'
					}
				}
			},
			tootipStyle() {

				if(this.mouldId == 1 || this.mouldId == 4) {
					return {}
				} else if(this.mouldId == 2 || this.mouldId == 5) {
					return {
						bottom: '57px'
					}
				} else if(this.mouldId == 3 || this.mouldId == 6) {
					return {
						right: '0',
						bottom: '57px'
					}
				} else if(this.mouldId == 7) {
					return {
						right: '15px',
						bottom: '15px'
					}
				}
			},
			leftStyle() {
				if(this.mouldId == 3 || this.mouldId == 6) {
					return {
						right: 0,
					}
				} else if(this.mouldId == 7) {
					return {
						right: '684px'
					}
				}
			},
			rightStyle() {
				if(this.mouldId == 7) {
					return {
						width: '684px',
						bottom: '31px'
					}
				}
			},
			companyId() {
				return this.$store.state.companyId;
			},
			companyCode() {
				return this.$store.state.companyCode;
			},
			functionList() {
				return this.$store.state.functionList;
			},
			scaleLev() {
				if(this.mouldId == 1 || this.mouldId == 4) {
					return {
						scaleX: 0.72,
						scaleY: 0.72
					}
				} else if(this.mouldId == 2 || this.mouldId == 5) {
					return {
						scaleX: 1,
						scaleY: 1
					}
				} else if(this.mouldId == 3 || this.mouldId == 6) {
					return {
						scaleX: 0.95,
						scaleY: 0.95
					}
				} else {
					return {
						scaleX: 1,
						scaleY: 1
					}
				}
			},
			DarkColor() {
				return this.mouldId == 4 || this.mouldId == 5 || this.mouldId == 6 ? true : false
			},
			tooltipCssByDark() {
				return 'font-size: 15px;line-height:30px;padding: 10px 10px 5px;text-align:left;border-radius: 4px 4px 4px 4px;color: #78859A;background: #fff;box-shadow: rgb(0 0 0 / .3) 0px 26px 33px -15px;border-radius: 5px 5px 5px 5px;';
			},
			tooltipCss() {
				return 'font-size: 15px;line-height:30px;padding: 10px 10px 5px;text-align:left;border-radius: 4px 4px 4px 4px;color: #78859A;background: linear-gradient(to top, rgba(255, 255, 255, 0.38), rgb(255, 255, 255));box-shadow: rgb(0 0 0 / .3) 0px 26px 33px -15px;border-radius: 5px 5px 5px 5px;';
			},
			tooltipCssBy7() {
				return `
					font-size: 12px;
					line-height:25px;
					padding: 0px 10px 5px;
					text-align:left;
					border-radius: 2px;
					color: #C4E1FF;
					background: rgba(1, 1, 14, .7);
					`
			},
		},
		components: {
			preview,
			AttrBlackboard
		},
		created() {

		},
		beforeRouteLeave(to, from, next) {
			from.meta.isBack = true;
			for(let obj of this.MqttByDataSetUrl) {
				this.$store.state.subaru.unsubscribe(obj.url, this.MqttExitBackFunction)
			}
			next();
		},
		activated() {
			//			document.getElementsByClassName('children-view')[0].style.minHeight = 858

			let self = this;
      this.$store.state.headerActive = 0;
			// var afterUrl = window.location.href.split('?')[1];
   //    // console.log(afterUrl)
			// if(afterUrl) {
			// 	/*如果是预览进入 则隐藏头部*/
			// 	this.$parent.ChangeHeaderShow('hide');
			// 	this.typePreview = true;
			// } else {
			// 	//设置头部
			// 	this.$store.state.headerActive = 0;
			// 	this.typePreview = false;
			// }
			if(self.$route.meta.updataMark) {

				/*清空所有图表*/
				let arr = document.getElementsByClassName('datasetBox');
				for(let dom of arr) {
					let ecarts = self.$echarts.getInstanceByDom(dom)
					if(ecarts) {
						ecarts.clear()
					}
				}
				/*复原 防止截图错位*/
				self.editorClear();

				/*如果在首页编辑更新过 则重新加载*/
				self.initScree();
				self.$route.meta.updataMark = false;
				localStorage.removeItem('updataMark');
			}
		},
		mounted() {
			let self = this;
			/*获取公司code*/
			this.getCompanyCode = setInterval(() => {
				if((this.companyCode) && String(this.companyId)) {
					clearInterval(this.getCompanyCode)
          // 获取企业虚拟设备
          this.getVirtualDevice()
					this.mqttMSG(); //开启mqtt
					/*接受mqtt*/
					/*先创建mqtt推消息之后的处理方法 再进行mqtt订阅 防止mqtt订阅之后 消息处理方法还未创建时 mqtt快速推送数据丢失*/
					this.getMqttMessage();
					/*等待companyCode 拿到后再初始化*/
					this.initScree();
				}
			}, 500)

			/*按下*/
			window.addEventListener('keydown', ev => {
				ev = ev || event;
				if(ev.keyCode === 18) {
					this.AttrShow = true;
					this.altMark = true;
					ev.preventDefault();
				}
			});

			/*松开*/
			window.addEventListener('keyup', ev => {
				ev = ev || event;
				if(ev.keyCode === 18) {
					this.AttrShow = false;
					this.altMark = false;
					ev.preventDefault();
				}
			});
		},
//		updated() {
//			let _this = this;
//			// 确保DOM元素已经渲染成功，然后获取拖拽容器和显示区域的大小
//			_this.$nextTick(() => {
//				if(!_this.$refs.dragContainer) return;
//				_this.dragContainer.box = {
//					w: _this.$refs.dragContainer.offsetWidth,
//					h: _this.$refs.dragContainer.offsetHeight
//				};
//				_this.imageShowBox.box = {
//					w: _this.$refs.imageShowBox.offsetWidth,
//					h: _this.$refs.imageShowBox.offsetHeight
//				};
//				// 判断是否允许拖拽
//				/*_this.imageShowBox.dragcheck = {
//					h: _this.imageShowBox.box.w > _this.dragContainer.box.w ? false : true,
//					v: _this.imageShowBox.box.h > _this.dragContainer.box.h ? false : true
//				};*/
//				_this.imageShowBox.dragcheck = {
//					h: true,
//					v: true
//				};
//			});
//		},
		methods: {
      // 获取虚拟设备
      getVirtualDevice(){
        this.get('/VirtualDevice/get',{companyId:this.companyId}).then(res=>{
          if(res.success){
            this.VirtualDevice = res.result
            // 获取虚拟设备属性列表
            this.get('/VirtualDevice/getPropertyList',{deviceId:this.VirtualDevice.id,companyId:this.companyId}).then(r=>{
              if(r.success){
                this.VirtualDevice.propertyList = r.result
              }else{
                this.VirtualDevice.propertyList=[]
                this.$message({
                  message: `获取虚拟设备属性失败：${res.message}`,
                  type: 'warning'
                })
              }
            })
          }else{
            this.$message({
              message: `获取虚拟设备失败：${res.message}`,
              type: 'warning'
            })
          }
        })
      },

			handleScroll(e) {
				this.$refs.Addrobot.handleScroll(e);
			},
			// 鼠标在拖拽容器中按下时触发
			DragContainerMouseDown(e) {
				const _this = this;
				// 记录鼠标点击时的初始坐标
				this.mousePoint = {
					x: e.clientX,
					y: e.clientY
				};
				_this.dragContainer.point = _this.dragContainer.newPoint;
				document.body.onmousemove = _this.DragContainerMouseMove;
				document.onmouseup = _this.DragContainerMouseUp;
				return false;
			},
			// 容器拖拽时触发
			DragContainerMouseMove(e) {
				const _this = this;
				// 鼠标偏移量 = 初始坐标 - 当前坐标
				let dx = _this.mousePoint.x - e.clientX;
				let dy = _this.mousePoint.y - e.clientY;
				// 获取拖拽容器移动后的left和top值
				/*if(_this.imageShowBox.dragcheck.h)
					var newx = dx > 0 ? Math.min(0, _this.dragContainer.point.left + dx) : Math.max(-_this.dragContainer.box.w + _this.imageShowBox.box.w, _this.dragContainer.point.left + dx);
				if(_this.imageShowBox.dragcheck.v)
					var newy = dy > 0 ? Math.min(0, _this.dragContainer.point.top + dy) : Math.max(-_this.dragContainer.box.h + _this.imageShowBox.box.h, _this.dragContainer.point.top + dy);*/

				if(_this.imageShowBox.dragcheck.h)
					var newx = _this.dragContainer.point.left + dx;
				if(_this.imageShowBox.dragcheck.v)
					var newy = _this.dragContainer.point.top + dy;

				_this.dragContainer.newPoint = {
					left: typeof newx != 'undefined' ? newx : _this.dragContainer.point.left,
					top: typeof newy != 'undefined' ? newy : _this.dragContainer.point.top
				};

				this.$nextTick(() => {
					this.$refs.Addrobot.editorTopUpdate(Math.ceil((Number(this.dragContainer.newPoint.top) + this.DelY) / .2))
					this.$refs.Addrobot.editorLeftUpdate(Math.ceil((Number(this.dragContainer.newPoint.left) + this.DelX) / .2))
				})
				//console.log(newx,newy);
				return false;
			},
			// 移动完成 取消onmousemove和onmouseup事件
			DragContainerMouseUp(e) {
				document.body.onmousemove = null;
				document.onmouseup = null;
			},
			PointMouseDown(e) {
				//阻止事件冒泡
				e.stopPropagation();
			},
			/*验证码*/
			// 获取验证码
			getCode() {
				this.get('/UserProfile/sendVerifyCode').then((res) => {
					if(res.success) {
						this.getCodeShow = false
						this.countdownShow = true
						const TIME_COUNT = 60;
						this.$message({
							message: '验证码发送成功',
							type: 'success'
						});
						if(!this.timer) {
							this.second = TIME_COUNT;
							this.show = false;
							this.timer = setInterval(() => {
								if(this.second > 0 && this.second <= TIME_COUNT) {
									this.second--;
								} else {
									this.getCodeShow = true;
									this.countdownShow = false;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000)
						}
					} else {
						this.$message({
							message: `验证码发送失败：${res.message}`,
							type: 'warning'
						});
					}
				})
			},
			// 用户提权
			Privilege() {
				this.$refs.verifyCode.validate((valid) => {
					if(valid) {
						this.post('/UserProfile/privilege', {
							verifyCode: this.verifyForm.verifyCode
						}).then(res => {
							if(res.success) {
								this.$message({
									message: '提权成功',
									type: 'success'
								})
								this.VerifyArr.splice(this.VerifyArr.indexOf(5), 1)
								localStorage.setItem('verifyCodeModule', this.VerifyArr)
								this.$store.state.mask = false
								this.functionShow = false
								this.getCodeShow = true;
								this.countdownShow = false;
								clearInterval(this.timer);
								this.timer = null;
								this.verifyForm.verifyCode = ''
							} else {
								this.$message({
									message: `提权失败：${res.message}`,
									type: 'warning'
								})
							}
						})
					}
				})
			},
			close() {
				this.functionShow = false;
				//				this.$store.state.mask = false;
				this.verifyForm.verifyCode = ''
			},
			//获取系统配置
			getData() {
				this.VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
			},

			/*更新当前页面所有图表尺寸*/
			chartsDomUpdate() {
				let arr = document.getElementsByClassName('datasetBox');
				for(let dom of arr) {
					let ecarts = this.$echarts.getInstanceByDom(dom)
					if(ecarts) {
						ecarts.resize({
							width: dom.offsetWidth,
							height: dom.offsetHeight
						});
						//console.log(ecarts,dom.offsetWidth,dom.offsetHeight)
					}
				}
			},
			/*图例mqtt*/
			MqttByTip() {
				//报警
				this.$store.state.subaru.subscribe('sys/company/' + this.companyId + '/status/push', {
					qos: 1
				})

				/*获取系统运行状态属性值 并开启mqtt*/
				if(this.systemObj.DeviceCode) {
					this.getSystem()
				}

				//状态
				/*this.$store.state.subaru.subscribe('sys/company/' + this.companyId + '/push', {
					qos: 1
				})*/
			},

			/*系统运行状态mqtt连接*/
			mqttBySystemState() {
				//报警
				this.$store.state.subaru.subscribe(this.systemObj.url, {
					qos: 1
				})
			},

			/*通过mqtt推送的值更新当前系统运行状态*/
			updataSystemState(message) {
				let data = JSON.parse(message.toString());
				if(data.deviceCode == this.systemObj.DeviceCode) {
					let items = data.items;
					if(this.common.istrue(items[this.systemObj.attrCode])||items[this.systemObj.attrCode]==0) {
						this.systemState = items[this.systemObj.attrCode];
					}
				}
				this.$forceUpdate()
			},

			/*获取系统运行状态属性值 并开启mqtt*/
			async getSystem() {
				let dataList = await this.getDeviceAttrValue(this.systemObj.DeviceId);
				if(dataList.length != 0) {
					if(dataList.filter(item => item.code == this.systemObj.attrCode).length != 0) {
						this.systemState = dataList.filter(item => item.code == this.systemObj.attrCode)[0].value
					}
				}
				this.$forceUpdate();

				//this.mqttBySystemState();
			},

			/*通过 设备id 获取设备属性值对象*/
			getDeviceAttrValue(deviceId) {
				/* 同步
				 * deviceId => 设备id
				 * deviceCode => 设备Code (用于辨识是否为虚拟设备 调用不同接口)
				 * 返回设备属性值对象
				 * */
				let self = this;
				return new Promise((resolve) => {
					self.get('/Device/getPropertyValue', {
						deviceId: deviceId, //设备id
					}).then((res) => {
						if(res.success == true) {
							resolve(res.result)
						} else {
							resolve([])
						}
					})
				})
			},

			/*视角复原*/
			editorClear() {
				this.$refs.Addrobot.editorClear();
			},
			/*显示缩略看板*/
			mousedown(event) {
				var targ
				if(!e) var e = window.event
				if(e.target) targ = e.target
				else if(e.srcElement) targ = e.srcElement
				if(targ.nodeType == 3) // defeat Safari bug
					targ = targ.parentNode
				if(targ.getAttribute('data-name') != null) {
					this.AttrShow = true;
				}

			},

			/*移除缩略看板图标 隐藏*/
			mousemove(event) {
				var targ
				if(!e) var e = window.event
				if(e.target) targ = e.target
				else if(e.srcElement) targ = e.srcElement
				if(targ.nodeType == 3) // defeat Safari bug
					targ = targ.parentNode
				if(targ.getAttribute('data-name') == null && !this.altMark) {
					this.AttrShow = false;
				}
			},

			/*隐藏缩略看板*/
			mouseup(event) {
				this.AttrShow = false;
			},

			/*mqtt消息监听*/
			mqttMSG() {
				// mqtt连接
				this.MqttOption = {
					clientId: this.$store.state.userData.code + '_' + this.$store.state.companyCode + '_IndexEditShow',
					connectTimeout: 600000,
					clean: true
				}
				this.$store.state.subaru = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, this.MqttOption)
			},
			checkFull() {
				/**
				 * [isFullscreen 判断浏览器是否全屏]
				 * @return [全屏则返回当前调用全屏的元素,不全屏返回false]
				 */
				return document.fullscreenElement ||
					document.msFullscreenElement ||
					document.mozFullScreenElement ||
					document.webkitFullscreenElement || false;
			},
			/*全屏*/
			requestFullScreen() {
				this.FullShowMark = true;
				this.FullType = 'openFull'
				var element = document.getElementById("preview");
				// 判断各种浏览器
				var requestMethod = element.requestFullScreen || //W3C
					element.webkitRequestFullScreen || //FireFox
					element.mozRequestFullScreen || //Chrome等
					element.msRequestFullScreen; //IE11
				if(requestMethod) {
					requestMethod.call(element);
				} else if(typeof window.ActiveXObject !== "undefined") { //for Internet Explorer
					var wscript = new ActiveXObject("WScript.Shell");
					if(wscript !== null) {
						wscript.SendKeys("{F11}");
					}
				}
			},

			/*退出全屏*/
			requestFullScreenClose() {
				this.FullShowMark = false;
				this.FullType = 'closeFull'
				// 判断各种浏览器
				var exitMethod = document.exitFullscreen || //W3C
					document.mozCancelFullScreen || //FireFox
					document.webkitExitFullscreen || //Chrome等
					document.webkitExitFullscreen; //IE11
				if(exitMethod) {
					exitMethod.call(document);
				} else if(typeof window.ActiveXObject !== "undefined") { //for Internet Explorer
					var wscript = new ActiveXObject("WScript.Shell");
					if(wscript !== null) {
						wscript.SendKeys("{F11}");
					}
				}
			},

			/*获取企业运维屏*/
			async initScree() {
				this.loadingMark = true;
				await this.getDataSetList(); //获取数据集列表
				await this.getDeviceList(); //获取设备列表

				//获取当前企业大屏数据
				if(this.typePreview) {
					await this.getDataScreenByStore();
				} else {
					await this.getDataScreenByApi();
				}
        this.loadingMark = false

				setTimeout(async() => {
					if(this.mouldId == 7) {
						/*开启报警统计3D*/
						await this.initAlarm();
					}
					this.initData(); //初始化当前企业大屏数据
				}, 1000)
			},

			/*初始化数据 配置图表 同步调用接口*/
			async initData() {
				let self = this;
				/*监听组态全屏*/
				window.onresize = () => {
					if(this.checkFull() == false) {
						if(this.FullShowMark) {
							this.Addrobot('close');
							this.FullShowMark = false;
						}
					}

					/*更新当前页面所有图表尺寸*/
					this.chartsDomUpdate();

					/*模板7的图表更新尺寸*/
					if(this.mouldId == 7){
						//图表
						let arr = document.getElementsByClassName('last_box');
						for(let dom of arr) {
							let ecarts = this.$echarts.getInstanceByDom(dom)
							if(ecarts) {
								ecarts.resize({
									width: dom.offsetWidth,
									height: dom.offsetHeight
								});
								//console.log(ecarts,dom.offsetWidth,dom.offsetHeight)
							}
						}

						//单独设置大小
						let ecartsB = this.$echarts.getInstanceByDom(document.getElementsByClassName('newDataBox')[0])
						if(ecartsB) {
							ecartsB.resize({
								width: document.getElementsByClassName('newDataBox')[0].offsetWidth,
								height: document.getElementsByClassName('newDataBox')[0].offsetHeight
							});
						}

						//3D饼图
						self.InnerAlarmCharts.setSize(120,47,true)
						self.OuterAlarmCharts.setSize(400,148,true)
					}
				}

				/*获取总数*/
				for(let mould of this.mouldBox) {
					for(let children of mould.children) {
						for(let data of this[mould.name][children.name]) {
							if(this.mouldId == 1 || this.mouldId == 4) {
								if((mould.name == 'left_bottom') || (mould.name == 'right' && (children.name == 'three' || children.name == 'four' || children.name == 'five'))) {
									if(data.chartType) {
										this.totalChartsNum++;
									}
								}
							} else if(this.mouldId == 2 || this.mouldId == 5) {
								if((mould.name == 'right') && (children.name == 'one' || children.name == 'two' || children.name == 'four' || children.name == 'five')) {
									if(data.chartType) {
										this.totalChartsNum++;
									}
								}
							} else if(this.mouldId == 3 || this.mouldId == 6) {
								if(mould.name == 'left_top') {
									if(data.chartType) {
										this.totalChartsNum++;
									}
								}
							} else if(this.mouldId == 7) {
								if(((mould.name == 'left_top_2' || mould.name == 'left_top_3') && (children.name == 'one' || children.name == 'two' || children.name == 'three' || children.name == 'four')) || (mould.name == 'right' && !(children.name == 'three' || children.name == 'two' || children.name == 'one'))) {
									if(data.chartType) {
										this.totalChartsNum++;
									}
								}
							}
						}
					}
				}
				if(this.totalChartsNum == 0) {
					this.loadingMark = false;
					this.NowLoadNum = -1; //防止当图表数为0时 mqtt未开启
				}
				/*实例化图表*/
				for(let mould of this.mouldBox) {
					for(let children of mould.children) {
						let index = 0;
						for(let data of this[mould.name][children.name]) { //一个模型下 需要渲染的数据集列表
							//console.log(mould.name + '_' + children.name + index)

							let mark = false; //判断是否为相对时间段
							let setOptionMark = false; //判断是否需要调用历史数据接口 用于根据模板id判断需要调用的数据集
							let timeInterval; /*计时器循环的时间 毫秒单位*/
							/*根据相对时间段类型 不断更新图表与表格*/
							if(data.frameType == 1) {
								mark = true;
								timeInterval = self.getTimeInterval(data.timeFrame);
							}
							if(this.mouldId == 1 || this.mouldId == 4) {
								if((mould.name == 'left_bottom') || (mould.name == 'right' && (children.name == 'three' || children.name == 'four' || children.name == 'five'))) {
									if(data.chartType) {
										setOptionMark = true;
									}
								}
							} else if(this.mouldId == 2 || this.mouldId == 5) {
								if((mould.name == 'right') && (children.name == 'one' || children.name == 'two' || children.name == 'four' || children.name == 'five')) {
									if(data.chartType) {
										setOptionMark = true;
									}
								}
							} else if(this.mouldId == 3 || this.mouldId == 6) {
								if(mould.name == 'left_top') {
									if(data.chartType) {
										setOptionMark = true;
									}
								}
							} else if(this.mouldId == 7) {
								if(((mould.name == 'left_top_2' || mould.name == 'left_top_3') && (children.name == 'one' || children.name == 'two' || children.name == 'three' || children.name == 'four')) || (mould.name == 'right' && !(children.name == 'three' || children.name == 'two' || children.name == 'one'))) {
									if(data.chartType) {
										setOptionMark = true;
									}
								}
							}
							if(setOptionMark) {
								if((mould.name == 'left_top') || (mould.name == 'right' && (children.name == 'one' || children.name == 'two')) || (mould.name == 'left_top_2') || (mould.name == 'left_top_3')) {
									//console.log(mould.name,children.name)
									/*判断是否为实时*/
									if(data.frameType == 3) {
										self.MqttCharts.push({
											id: data.id,
											obj: data,
											mouldName: mould.name,
											childrenName: children.name,
											index: index,
											type: 'ShowOneData' //只显示一条数据的MqttCharts标识符 用于更新
										})
										let url;
										if(data.type == 1) {
											url = 'sys/dataset/' + data.id + '/' + self.companyCode + '/push'
										} else {
											url = 'sys/dataset/' + data.id + '/push';
										}
										if(self.MqttByDataSetUrl.filter(item => item.id == data.id).length == 0) {
											self.MqttByDataSetUrl.push({
												id: data.id,
												url: url,
											})
										}
									} else {
										/*只显示一条数据的模板*/
										data = await self.initTableValue(data);
									}

									if(mark) {
										self.longTimeOut.setInterval(async(obj) => {
											self[obj.mouldName][obj.childrenName][obj.index] = await self.initTableValue(obj.data);
										}, timeInterval, {
											data: data,
											mouldName: mould.name,
											childrenName: children.name,
											index: index
										})
									}
									self.NowLoadNum++;
								} else {
									if(self.mouldId == 7) {
										if((mould.name == 'right') && (children.name == 'six')) {
											/*仪表盘*/
											self.initGauge(data, {
												dom: self.$refs[mould.name + '_' + children.name + index][0],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'][0].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'][0].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											})
										} else if((mould.name == 'right') && (children.name == 'four')) {
											/*折线图*/
											self.initLineNew(data, {
												dom: self.$refs[mould.name + '_' + children.name + index][0],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'][0].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'][0].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											})
										} else if((mould.name == 'right') && (children.name == 'five')) {
											/*柱状图*/
											self.initBarNew(data, {
												dom: self.$refs[mould.name + '_' + children.name + index][0],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'][0].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'][0].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											})
										} else if((mould.name == 'right') && ((children.name == 'seven') || (children.name == 'eight'))) {
											let name;
											if(children.name == 'seven') {
												name = 'Seven'
											} else {
												name = 'Eight'
											}
											/*仪表盘*/
											self.initGaugeLast(data, {
												dom: self.$refs[mould.name + '_' + children.name + index],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											}, null, 'right' + name)
										} else if((mould.name == 'right') && ((children.name == 'nine') || (children.name == 'ten'))) {
											let name;
											if(children.name == 'nine') {
												name = 'Nine'
											} else {
												name = 'Ten'
											}
											/*水球*/
											self.initWaterLast(data, {
												dom: self.$refs[mould.name + '_' + children.name + index],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											}, null, 'right' + name)
										}

									} else {
										if(data.chartType == 1) {
											/*饼图*/
											self.initPie(data, {
												dom: self.$refs[mould.name + '_' + children.name + index][0],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'][0].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'][0].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											});
										} else if(data.chartType == 2) {
											/*柱状图*/
											self.initBar(data, {
												dom: self.$refs[mould.name + '_' + children.name + index][0],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'][0].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'][0].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											});
										} else if(data.chartType == 3) {
											/*折线图*/
											self.initLine(data, {
												dom: self.$refs[mould.name + '_' + children.name + index][0],
												chartsWidth: self.$refs[mould.name + '_' + children.name + '0'][0].offsetWidth,
												chartsHeight: self.$refs[mould.name + '_' + children.name + '0'][0].offsetHeight,
											}, {
												IntervalMark: mark,
												timeInterval: timeInterval
											});
										} else if(data.chartType == 4) {
											/*文本标签*/
											self.initTable(data, mould.name + '_' + children.name + index);
											if(mark) {
												self.longTimeOut.setInterval((obj) => {
													self.initTable(obj.data, obj.mouldName + '_' + obj.childrenName + obj.index);
												}, timeInterval, {
													data: data,
													mouldName: mould.name,
													childrenName: children.name,
													index: index
												})
											}
											self.NowLoadNum++;
										}
									}
								}
							}

							index++; //当前模型下的数据集索引(最后再++)
						}

					}
				}
			},

			/*传入数据集的timeFrame 返回定时器每次循环的时间*/
			getTimeInterval(timeFrame) {
				let timeInterval;
				if(timeFrame == 1) {
					timeInterval = 60000; //1分钟 	60秒*1000毫秒
				} else if(timeFrame == 2) {
					timeInterval = 3600000; //1小时 	60分钟*60秒*1000毫秒
				} else if(timeFrame == 3) {
					timeInterval = 86400000; //1天 	24小时*60分钟*60秒*1000毫秒
				} else if(timeFrame == 4) {
					timeInterval = 604800000; //1周 	7天*24小时*60分钟*60秒*1000毫秒
				} else if(timeFrame == 5) {
					timeInterval = 2678400000; //1月 	31天*24小时*60分钟*60秒*1000毫秒
				} else if(timeFrame == 6) {
					timeInterval = 8035200000; //1季度(3个月) 	3个月*31天*24小时*60分钟*60秒*1000毫秒
				} else if(timeFrame == 7) {
					timeInterval = 31536000000; //1年 	365天*24小时*60分钟*60秒*1000毫秒
				}
				return timeInterval;
			},

			/*切换选项卡DataSet*/
			changeBox(name, index) {
				this[name] = index;
        // console.log(this.right.five)
			},

			/*获取企业数据集列表*/
			getDeviceList(companyId) {
				let self = this;
				return new Promise((resolve, reject) => {
					self.get('/Device/getList', {
						companyId: companyId ? companyId : self.companyId
					}).then((res) => {
						if(res.success == true) {
							this.DeviceList = res.result;
							resolve();
						}
					})
				})
			},

			/*获取企业数据集列表*/
			getDataSetList() {
				let self = this;
				return new Promise((resolve, reject) => {
					self.get('/Dataset/getList', {
						code: self.companyCode
					}).then((res) => {
						if(res.success == true) {
							this.DataSetList = res.result;
							resolve();
						}
					})
				})
			},

			/*通过预览store 获取当前企业大屏数据*/
			getDataScreenByStore() {
        // console.log('getDataScreenByStore')
				let self = this;
				return new Promise((resolve, reject) => {
					let items = JSON.parse(sessionStorage.getItem('indexEditPreviewItem'));
					let mouldId = Number(sessionStorage.getItem('indexEditPreviewMouldId'));
					let type = Number(sessionStorage.getItem('indexEditPreviewType'))

          if(this.mouldId==8){
            this.$emit('setMould',8)
            return
          }
					this.type = type;
					this.mouldId = mouldId;


					if(items.length > 0) {
						this.ShowContent = true; //展示开关
						/*初始化遍历*/
						let index = 0;
						for(let mouldBox of this.mouldBox) {
							for(let children of mouldBox.children) {
								if(items[index]){
									if(items[index].type != 6) {
										let arr = items[index].value.split(',');
										let arrOther = [];
										for(let ar of arr) {
											if(ar != '') {
												if(this.DataSetList.filter(item => item.id == ar).length != 0) {
													arrOther.push(this.DataSetList.filter(item => item.id == Number(ar))[0])
												}
											}
										}
										this[mouldBox.name][children.name] = arrOther;
									}
								}
								index++;
							}
						}
						let deviceArr = items.filter(item => item.type == 6);
						if(deviceArr.length != 0){
							let obj = JSON.parse(deviceArr[0].value)
							let arr = obj.arr
							let specs = obj.specs
							let deviceId = Number(arr[0]);
							let deviceCode = arr[1].split('-')[1];
							let attrCode = arr[1].split('-')[0];
							let url = 'sys/device/' + deviceCode + '/property/push';

							this.systemObj = {
								DeviceId: deviceId,
								DeviceCode: deviceCode,
								attrCode: attrCode,
								specs: specs,
								url: url
							}
						}
						resolve();
					}
				})
			},

			/*通过接口 获取当前企业大屏数据*/
			getDataScreenByApi() {
				let self = this;
				return new Promise((resolve, reject) => {
					this.get('/CompanyScreen/get', {
						companyId: this.companyId
					}).then((res) => {
						if(res.success) {
							if(JSON.stringify(res.result) == "{}"){
								resolve();
								return;
							}
							this.CompanyScreen = res.result;
							if(res.result.layout) {
								this.mouldId = res.result.layout;
							} else {
								this.mouldId = 1;
							}
              if(this.mouldId==8){
                this.$emit('setMould',8)
                return
              }
							this.type = res.result.type ? res.result.type : 1;

							this.ShowContent = false; //初始化展示开关
							if(this.CompanyScreen.items) {
								if(this.CompanyScreen.items.length > 0) {
									this.ShowContent = true; //展示开关
									/*初始化遍历*/
									let index = 0;
									for(let mouldBox of this.mouldBox) {
										for(let children of mouldBox.children) {
											if(res.result.items[index]){
												if(res.result.items[index].type != 6) {
													let arr = res.result.items[index].value.split(',');
													let arrOther = [];
													for(let ar of arr) {
														if(ar != '') {
															if(this.DataSetList.filter(item => item.id == ar).length != 0) {
																arrOther.push(this.DataSetList.filter(item => item.id == Number(ar))[0])
															}
														}
													}
													this[mouldBox.name][children.name] = arrOther;
												}
											}
											index++;
										}
									}

									let deviceArr = res.result.items.filter(item => item.type == 6);
									if(deviceArr.length != 0){
										let obj = JSON.parse(deviceArr[0].value)
										let arr = obj.arr
										let specs = specs;
										let deviceId = Number(arr[0]);
										let deviceCode = arr[1].split('-')[1];
										let attrCode = arr[1].split('-')[0];
										let url = 'sys/device/' + deviceCode + '/property/push';

										this.systemObj = {
											DeviceId: deviceId,
											DeviceCode: deviceCode,
											attrCode: attrCode,
											specs: specs,
											url: url
										}
									}
								}
							}
							resolve();
						} else {
							this.$message({
								message: `获取企业运维屏失败：${res.message}`,
								type: 'warning'
							});
						}
					})
				})
			},

			/*模板7 水球体*/
			initWaterLast(obj, DomObj, timeObj, chartsInstance, ThisName) {
				/*
				 * 仪表盘 固定样式 可以有多条数据源 但是只获取各个数据源下data的第一条value
					obj => 数据集对象 选中的数据集图表类型为饼图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				 */
				let self = this;
				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				/*初始化setOption*/
				var value = 0;
				var setOption = {
					graphic: {
						elements: [{
							type: 'image',
							z: 3,
							style: {
								image: self.waterGreen,
								width: document.getElementsByClassName('right_last_3')[0].offsetWidth * 0.8,
								height: document.getElementsByClassName('right_last_3')[0].offsetWidth * 0.8
							},
							left: 'center',
							top: 'center',
						}]
					},
					series: [{
						type: 'liquidFill',
						z: 6,
						center: ['50%', '50%'],
						radius: '60%',
						data: [{
							value: value,
							direction: 'right',
							itemStyle: {
								opacity: 1,
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 1,
										color: 'rgba(11, 186, 219, .1)',
									}, {
										offset: 0.5,
										color: 'rgba(11, 186, 219, .5)',
									}, {
										offset: 0,
										color: 'rgba(11, 186, 219, 1)',
									}],
									globalCoord: true
								},
							}
						},{
							value: value,
							direction: 'left',
							itemStyle: {
								opacity: 1,
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 1,
										color: 'rgba(11, 186, 219, .1)',
									}, {
										offset: 0.5,
										color: 'rgba(11, 186, 219, .3)',
									}, {
										offset: 0,
										color: 'rgba(11, 186, 219, .3)',
									}],
									globalCoord: true
								},
							}
						}],
						backgroundStyle: {
							borderWidth: 2,
							color: 'transparent',
							borderColor: 'rgba(11, 186, 219, 1)',
							shadowColor: 'rgba(11, 186, 219, 1)',
							shadowBlur: 13,
						},
						label: {
							normal: {
								formatter: '',
							}
						},
						outline: {
							show: true,
							itemStyle: {
								borderWidth: 2.5,
								borderColor: 'rgba(11, 186, 219, 1)',
								shadowColor: 'rgba(11, 186, 219, 1)',
								shadowBlur: 13,
							},
							borderDistance: 0,
						}
					}]
				}

				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});

					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts,
						type: 6, //1为仪表盘, 2为3D饼图, 3为折线图, 4为柱状图, 5为右下仪表盘, 6为水球体
						name: ThisName
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}
							var data = await self.WaterGetByDeviceCode(obj, res.result, ratio, place)
							setOption.series[0].data[0].value = data.value <= 0 ? 0 : data.value >= 100 ? 1 : data.value / 100;
							setOption.series[0].data[1].value = data.value <= 0 ? 0 : data.value >= 100 ? 1 : data.value / 100;
							if(data.type == 1){
								/*正常 蓝色*/
								setOption.graphic.elements[0].style.image = self.waterGreen
								setOption.series[0].data[0].itemStyle.color.colorStops = [{
									offset: 1,
									color: 'rgba(11, 186, 219, .1)',
								}, {
									offset: 0.5,
									color: 'rgba(11, 186, 219, .5)'
								}, {
									offset: 0,
									color: 'rgba(11, 186, 219, 1)',
								}]
								setOption.series[0].data[1].itemStyle.color.colorStops = [{
									offset: 1,
									color: 'rgba(11, 186, 219, .1)',
								}, {
									offset: 0.5,
									color: 'rgba(11, 186, 219, .3)',
								}, {
									offset: 0,
									color: 'rgba(11, 186, 219, .3)',
								}]
								setOption.series[0].backgroundStyle.borderColor = 'rgba(11, 186, 219, 1)'
								setOption.series[0].backgroundStyle.shadowColor = 'rgba(11, 186, 219, 1)'
								setOption.series[0].outline.itemStyle.borderColor = 'rgba(11, 186, 219, 1)'
								setOption.series[0].outline.itemStyle.shadowColor = 'rgba(11, 186, 219, 1)'
							}else if(data.type == 2 || data.type == 3){
								/*超过 上限/下限 橙色*//*超过 上上限/下下限 红色*/
								setOption.graphic.elements[0].style.image = self.waterRed
								setOption.series[0].data[0].itemStyle.color.colorStops = [{
									offset: 1,
									color: 'rgba(183, 15, 76, .1)',
								}, {
									offset: 0.5,
									color: 'rgba(183, 15, 76, .5)',
								}, {
									offset: 0,
									color: 'rgba(183, 15, 76, 1)',
								}]
								setOption.series[0].data[1].itemStyle.color.colorStops = [{
									offset: 1,
									color: 'rgba(183, 15, 76, .1)',
								}, {
									offset: 0.5,
									color: 'rgba(183, 15, 76, .3)',
								}, {
									offset: 0,
									color: 'rgba(183, 15, 76, .3)',
								}]
								setOption.series[0].backgroundStyle.borderColor = 'rgba(183, 15, 76, 1)'
								setOption.series[0].backgroundStyle.shadowColor = 'rgba(183, 15, 76, 1)'
								setOption.series[0].outline.itemStyle.borderColor = 'rgba(183, 15, 76, 1)'
								setOption.series[0].outline.itemStyle.shadowColor = 'rgba(183, 15, 76, 1)'
							}
							self[ThisName] = data
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										/*仪表盘*/
										self.initWaterLast(obj.data, {}, {}, obj.charts, obj.ThisName)
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts,
										name: ThisName
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}
			},

			/*模板7 最后仪表盘*/
			initGaugeLast(obj, DomObj, timeObj, chartsInstance, ThisName) {
				/*
				 * 仪表盘 固定样式 可以有多条数据源 但是只获取各个数据源下data的第一条value
					obj => 数据集对象 选中的数据集图表类型为饼图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				 */
				let self = this;
				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}
				let img = require('@/assets/image/indexEditor/model7/last.png')
				/*初始化setOption*/
				var setOption = {
					graphic: {
						elements: [{
							type: 'image',
							z: 3,
							style: {
								image: img,
								width: document.getElementsByClassName('right_last_1')[0].offsetWidth * 0.6,
								height: document.getElementsByClassName('right_last_1')[0].offsetWidth * 0.6
							},
							left: 'center',
							top: 'center',
						}]
					},
					series: [{
						type: 'gauge',
						progress: {
							show: false,
							width: 5
						},
						center: ['50%', '50%'],
						radius: '60%',
						axisLine: {
							lineStyle: {
								width: 3,
								color: [
									[0.3, new self.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
											offset: 0,
											color: "#0336FF"
										},
										{
											offset: 1,
											color: "#01B4FF"
										}
									])],
									[0.7, new self.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
											offset: 0.1,
											color: "#FF6600"
										},
										{
											offset: 1,
											color: "#FF9933"
										}
									])],
									[1, new self.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
											offset: 0.1,
											color: "#FF0D72"
										},
										{
											offset: 1,
											color: "#fF5B16"
										}
									])]
								]
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						anchor: {
							show: true,
							showAbove: true,
							size: 10,
							// icon:"",  //指针icon
							itemStyle: {
								borderWidth: 0
							}
						},
						title: {
							show: false
						},
						detail: {
							valueAnimation: true,
							fontSize: 80,
							offsetCenter: [0, '70%'],
							formatter: '{a|{value}}',
							rich: {
								a: {
									opacity: 0
								},
							},
						},
						data: [{
							value: 0
						}]
					}]
				};

				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});

					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts,
						type: 5, //1为仪表盘, 2为3D饼图, 3为折线图, 4为柱状图, 5为右下仪表盘, 6为水球体
						name: ThisName
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}
							var data = {};
							data = await self.LastGaugeGetByDeviceCode(obj, res.result, ratio, place)
							setOption.series[0].data = [{
								value: data.type == 0 ? 0 : (data.type == 1 ? 25 : (data.type == 2 ? 65 : 95))
							}];
							self[ThisName] = data
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										/*仪表盘*/
										self.initGaugeLast(obj.data, {}, {}, obj.charts, obj.ThisName)
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts,
										name: ThisName
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}
			},

			/*模板7 仪表盘*/
			initGauge(obj, DomObj, timeObj, chartsInstance) {
				/*
				 * 仪表盘 固定样式 可以有多条数据源 但是只获取各个数据源下data的第一条value
					obj => 数据集对象 选中的数据集图表类型为饼图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				 */
				let self = this;
				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				/*初始化setOption*/
				var setOption = {
					series: [{
						type: 'gauge',
						startAngle: 90,
						endAngle: -270,
						radius: '90%',
						center: ['50%','50%'],
						z: 0,
						zlevel: 0,
						progress: {
							show: true,
							width: 3,
						},
						axisLine: {
							show: true,
							lineStyle: {
								width: 3,
								color: [
									[1, '#000033']
								],
								shadowColor: 'rgba(0,138,255,0.45)',
								shadowBlur: 20,
								shadowOffsetX: 0,
								shadowOffsetY: 0
							},
						},
						axisTick: {
							show: true,
							length: 8,
							lineStyle: {
								width: 1.5,
								color: '#237EDA'
							},
							distance: 5,
							splitNumber: 2
						},
						splitLine: {
							length: 3,
							lineStyle: {
								width: 2,
								color: '#1e2b43'
							},
							distance: -3
						},
						axisLabel: {
							show: false,
						},
						pointer: {
							show: false
						},
						anchor: {
							show: false,
							showAbove: false,
							size: 0,
							itemStyle: {
								borderWidth: 10
							}
						},
						title: {
							show: false
						},
						detail: {
							valueAnimation: false,
							fontSize: 80,
							offsetCenter: [0, '0%'],
							formatter: '{a|{value}}',
							rich: {
								a: {
									color: '#FFFFFF',
									opacity: 0
								},
							},
						},
						itemStyle: {
							color: '#2C9AFF',
							shadowColor: 'rgba(0,138,255,0.45)',
							shadowBlur: 20,
							shadowOffsetX: 0,
							shadowOffsetY: 0
						},
						data: [{
							value: 0
						}]
					}, {
						type: 'gauge',
						startAngle: 90,
						endAngle: -270,
						radius: '90%',
						center: ['50%','50%'],
						z: 1,
						zlevel: 1,
						progress: {
							show: false,
							width: 0,
						},
						axisLine: {
							show: false,
							lineStyle: {
								width: 18,
								color: [
									[1, '#000033']
								],
							},
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							length: 3,
							lineStyle: {
								width: 1,
								color: '#1e2b43'
							},
							distance: -18
						},
						axisLabel: {
							show: false,
						},
						pointer: {
							show: false
						},
						anchor: {
							show: false,
							showAbove: false,
							size: 0,
							itemStyle: {
								borderWidth: 10
							}
						},
						title: {
							show: false
						},
						detail: {
							valueAnimation: false,
							fontSize: 80,
							offsetCenter: [0, '0%'],
							formatter: '{a|{value}}',
							rich: {
								a: {
									opacity: 0
								},
							},
						},
						data: [{
							value: 0
						}]
					}]
				}

				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});

					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts,
						type: 1, //1为仪表盘, 2为3D饼图, 3为折线图, 4为柱状图, 5为右下仪表盘, 6为水球体
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}

							var data = {};
							data = await self.GaugeGetByDeviceCode(obj, res.result, ratio, place)
							setOption.series[0].data = [{
								value: data.value<0?0:data.value
							}];
							self.rightSix = data
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										/*仪表盘*/
										self.initGauge(obj.data, {}, {}, obj.charts)
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}
			},

			/*更改3D环形图的层级 实现数据提示框永远在最上层*/
			changeZindex(id) {
				let self = this;
				if(id == 1) {
					self.innerZindex = 2
					self.outerZindex = 1
				} else if(id == 2) {
					self.innerZindex = 1
					self.outerZindex = 2
				}
			},

			changeOpenC(id) {
				this['openC' + id] = !this['openC' + id]
				var arr = this.categoryData;
				if(arr.length != 0) {
					if(this['openC' + id]) {
						arr[id - 1][1] = JSON.parse(JSON.stringify(this.categoryDataReal[id - 1][1]));
					} else {
						arr[id - 1][1] = -1
					}
				}
				this.InnerAlarmCharts.series[0].setData(arr)
				if((arr[0][1] == -1 || arr[0][1] == 0) && (arr[1][1] == -1 || arr[1][1] == 0) && (arr[2][1] == -1 || arr[2][1] == 0)) {
					this.InnerAlarmCharts.series[0].hide();
				} else {
					this.InnerAlarmCharts.series[0].show();
				}
				this.$forceUpdate()
			},

			changeOpenL(id) {
				this['openL' + id] = !this['openL' + id]
				var arr = this.levelData;
				if(arr.length != 0) {
					if(this['openL' + id]) {
						arr[id - 1][1] = JSON.parse(JSON.stringify(this.levelDataReal[id - 1][1]));
					} else {
						arr[id - 1][1] = -1
					}
				}
				this.OuterAlarmCharts.series[0].setData(arr)
				if((arr[0][1] == -1 || arr[0][1] == 0) && (arr[1][1] == -1 || arr[1][1] == 0) && (arr[2][1] == -1 || arr[2][1] == 0)) {
					this.OuterAlarmCharts.series[0].hide();
				} else {
					this.OuterAlarmCharts.series[0].show();
				}
				this.$forceUpdate()
			},

			/*报警统计3D 饼图 ref=> Alarm*/
			initAlarm() {
				let self = this;
				return new Promise(async(resolve, reject) => {
					let options = {
						colors: ['#F8FCFF', '#FFFF00', '#FF0000'],
						chart: {
							type: 'pie',
							options3d: {
								enabled: true,
								alpha: 70
							},
							backgroundColor: 'transparent',
							width: 120,
							height: 47,
							margin: [-40, -35, -35, -40]
						},
						credits: {
							enabled: false,
						},
						navigation: {
							buttonOptions: {
								enabled: false
							},
							menuStyle: {
								'display': 'none',
							}
						},
						title: {
							style: {
								'display': 'none'
							}
						},
						subtitle: {
							style: {
								'display': 'none'
							}
						},
						tooltip: {
							enterable: true,
							shared: true,
							followPointer: true,
							crosshairs: true,
							useHTML: true,
							backgroundColor: 'rgba(1, 1, 14, .7)', // 背景颜色
							borderRadius: 2, // 边框圆角
							borderWidth: 0, // 边框宽度
							style: { // 文字内容相关样式
								color: "#FFFFFF",
								fontSize: "17px",
								fontWeight: "blod",
								fontFamily: "Courir new",
								textAlign: 'center',
							},
							pointFormatter: function() {
								/*return `<div style="background-color: rgba(1, 1, 14, 0.7);border-radius: 2px;text-align:center;font-size:17px;">
									<p>${this.options.name}</p>
									<p style="font-family: agencyr;font-weight: bold;color:${this.color}">${this.options.y}</p>
								</div>`*/
								//								self.changeZindex(1)
								return '<b style="font-family: agencyr;font-weight: bold;color:' + this.color + ';padding: 0 21px 10px 21px">' + this.y + '</b>'
							},
							padding: 1,
							hideDelay: 0
						},
						plotOptions: {
							pie: {
								allowPointSelect: false,
								cursor: 'pointer',
								dataLabels: {
									enabled: false
								},
								innerSize: '43%',
								depth: 6
							}
						},
						series: [{
							data: [],
							stickyTracking: true,
						}]
					};
					let options2 = {
						colors: ['#8F8F8F', '#0066FF', '#00FF66'],
						chart: {
							type: 'pie',
							options3d: {
								enabled: true,
								alpha: 75
							},
							backgroundColor: 'transparent',
							margin: [-100, -10, -30, -10]
						},
						credits: {
							enabled: false,
						},
						navigation: {
							buttonOptions: {
								enabled: false
							},
							menuStyle: {
								'display': 'none'
							}
						},
						tooltip: {
							enterable: true,
							shared: true,
							followPointer: true,
							crosshairs: true,
							useHTML: true,
							backgroundColor: 'rgba(1, 1, 14, .7)', // 背景颜色
							borderRadius: 2, // 边框圆角
							borderWidth: 0, // 边框宽度
							style: { // 文字内容相关样式
								color: "#FFFFFF",
								fontSize: "17px",
								fontWeight: "blod",
								fontFamily: "Courir new",
								textAlign: 'center',
							},
							pointFormatter: function() {
								/*return `<div style="background-color: rgba(1, 1, 14, 0.7);border-radius: 2px;text-align:center;font-size:17px;">
									<p>${this.options.name}</p>
									<p style="font-family: agencyr;font-weight: bold;color:${this.color}">${this.options.y}</p>
								</div>`*/
								//								self.changeZindex(2)
								return '<b style="font-family: agencyr;font-weight: bold;color:' + this.color + ';padding: 0 21px 10px 21px">' + this.y + '</b>'
							},
							padding: 1,
							hideDelay: 0
						},
						title: {
							style: {
								'display': 'none'
							}
						},
						subtitle: {
							style: {
								'display': 'none'
							}
						},
						plotOptions: {
							pie: {
								allowPointSelect: false,
								cursor: 'pointer',
								dataLabels: {
									enabled: false
								},
								innerSize: '99%',
								depth: 3
							}
						},
						series: [{
							data: [],
							stickyTracking: true,
						}]
					};

					let category = await this.getAlarmByCategory()
					let level = await this.getAlarmByLevel()

					if(level.length != 0) {
						let data = [];
						for(let c of level) {
							if(c.level == 1) {
								data.push(['提示', c.count])
							} else if(c.level == 2) {
								data.push(['警告', c.count])
							} else if(c.level == 3) {
								data.push(['故障', c.count])
							}
						}
						options.series[0].data = data
						self.categoryData = data;
						self.categoryDataReal = JSON.parse(JSON.stringify(data));
					}
					if(category.length != 0) {
						let data = [];
						for(let c of category) {
							if(c.category == 1) {
								data.push(['未确认', c.count])
							} else if(c.category == 2) {
								data.push(['已确认', c.count])
							} else if(c.category == 3) {
								data.push(['已恢复', c.count])
							}
						}
						options2.series[0].data = data
						self.levelData = data;
						self.levelDataReal = JSON.parse(JSON.stringify(data));
					}

					self.InnerAlarmCharts = this.$highcharts.chart(this.$refs.Alarm2, options)
					self.OuterAlarmCharts = this.$highcharts.chart(this.$refs.Alarm, options2)

					if(category.filter(item => item.count!=0).length == 0){
						/*如果没有报警*/
						self.InnerAlarmCharts.series[0].hide();
					}

					if(level.filter(item => item.count!=0).length == 0){
						/*如果没有报警*/
						self.OuterAlarmCharts.series[0].hide();
					}
					resolve();
				})
			},

			/*饼图*/
			initPie(obj, DomObj, timeObj, chartsInstance) {
				/*
				 * 饼图 可以有多条数据源 但是只获取各个数据源下data的最后一条value
					obj => 数据集对象 选中的数据集图表类型为饼图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				*/
				//console.log(timeObj)
				let self = this;
				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				/*初始化setOption*/
				var setOption = {
					tooltip: {
						enterable: true,
						transitionDuration: 0,
						trigger: 'item',
						show: obj.showData,
						formatter: function(params) {
							let unit = params.data.unit ? params.data.unit : ''
							let deviceCode = params.data.deviceCode
							let attrCode = params.data.attrCode
							let deviceName = self.DeviceList.filter(item => item.code == deviceCode).length != 0 ? '/' + self.DeviceList.filter(item => item.code == deviceCode)[0].name : ''

							return params.data.showName + deviceName + " " + self.common.fmoneyNoFix(params.data.value) + ' ' + unit
						}
					},
					legend: {
						show: obj.showLegend,
						orient: 'horizontal',
						// top: 'middle',
						top: '5%',
						left: 22,
						selectedMode: false,
						icon: 'circle',
						borderRadius: 0,
						itemGap: 12,
						itemWidth: 11,
						itemHeight: 11,
						textStyle: {
							color: '#9DA8BC',
							borderRadius: 0,
							padding: [2, 0, 0, 8]
						},
						formatter: function(params) {
							return params.split('/')[0]
						}
					},
					color: self.PieColor,
					series: [{
						type: 'pie',
						radius: ['40%', '55%'],
						center: ['50%', '55%'],
						animationTypeUpdate: 'transition',
						animationDurationUpdate: 100,
						label: {
							show: obj.showLabel,
							color: self.DarkColor ? '#fff' : '#3F3F3F',
							formatter: '{d}%',
							/*formatter: function(params) {
								return params.data.showName
							}*/
						},
						labelLine: {
							length: 20,
							length2: 20,
							lineStyle: {
								color: '#B5B5B5',

							},
						},
						itemStyle: {
							borderColor: self.DarkColor ? '#2E4E7C' : '#fff',
							borderWidth: 2,
						},
						selectedMode: 'single',
						//data: data,
						avoidLabelOverlap: true,
						minAngle: 5,
					}]
					/*,{
						type: 'pie',
						radius: ['40%', '50%'],
						center: ['50%', '55%'],
						label: {
							show: obj.showPercent,
							position: 'inner',
							formatter: '{d}%',
							fontSize: 13,
						},
						itemStyle: {
							//color:self.DarkPieColor,
						},
						selectedMode: false,
						hoverAnimation: true,
						//data: data,
						avoidLabelOverlap: true,
						minAngle: 5,
					}*/
				}
				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});

					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url,
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}

							var data = [];
							data = await self.PieGetByDeviceCode(obj, res.result, ratio, place)
							//data = data.concat(dataResult)
							setOption.series[0].data = data;
							setOption.series[1] ? setOption.series[1].data = data : null;
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										if(obj.data.chartType == 1) {
											/*饼图*/
											self.initPie(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 2) {
											/*柱状图*/
											self.initBar(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 3) {
											/*折线图*/
											self.initLine(obj.data, {}, {}, obj.charts);
										}
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}
			},

			/*柱状图*/
			initBar(obj, DomObj, timeObj, chartsInstance) {
				/*
				 * 柱状图可以显示多个数据源
					obj => 数据集对象 选中的数据集图表类型为柱状图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				*/
				//console.log(timeObj)
				let self = this;
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				/*初始化setOption*/
				var setOption = {
					color: self.BarColor,
					legend: {
						show: obj.showLegend,
						orient: 'horizontal',
						// top: 'middle',
						top: '3%',
						right: '7%',
						selectedMode: false,
						icon: 'rect',
						borderRadius: 0,
						itemGap: 8,
						itemWidth: 11,
						itemHeight: 11,
						textStyle: {
							color: self.DarkColor ? '#fff' : '#3F3F3F',
							borderRadius: 0,
							padding: [2, 0, 0, 5]
						},
						formatter: function(name) {
							return name.split('0.')[0]
						},
					},
					tooltip: {
						confine: true,
						transitionDuration: 0,
						backgroundColor: '#FFFFFF',
						borderWidth: 0,
						snap: false,
						trigger: 'axis',
						showContent: true,
						axisPointer: {
							z: 1,
							animation: true,
							label: {

							},
							lineStyle: {
								color: 'transparent',
							},
						},
						textStyle: {　　
							align: 'left',
							color: '#292929'
						},
						extraCssText: self.DarkColor ? self.tooltipCssByDark : self.tooltipCss,
						formatter: function(params) {
							//console.log(params)
							let name = params[0].name;
							let div = '';
							let arr = [];
							for(let a of params) {
								if(params.filter(item => item.seriesName.split('0.')[0] == '平均值' || item.seriesName.split('0.')[0] == '增长量').length == 0) {
									/*透传*/
									let code = a.seriesName.split('-&&-')[1];
									let deviceCode = code.split('&-&')[0];
									let attrCode = code.split('&-&')[1];

									let deviceName = self.DeviceList.filter(item => item.code == deviceCode).length != 0 ? '/' + self.DeviceList.filter(item => item.code == deviceCode)[0].name : ''

									if(!arr.includes(code)) {
										if(a.data == '-') {
											div += '<br>' + a.marker + a.seriesName.split('0.')[0] + deviceName + " " + '-';
										} else {
											div += '<br>' + a.marker + a.seriesName.split('0.')[0] + deviceName + " " + self.common.fmoneyNoFix(a.data) + ' ' + a.seriesName.split('-')[1];
										}
										arr.push(code)
									}
								} else {
									/*统计或增长*/
									let name = a.seriesName.split('0.')[0]
									let unit = a.seriesName.split('dataSetUnit=')[1];
									if(!arr.includes(name)) {
										if(a.data == '-') {
											div += '<br>' + a.marker + name + " " + '-';
										} else {
											div += '<br>' + a.marker + name + " " + self.common.fmoneyNoFix(a.data) + unit;
										}
										arr.push(name)
									}
								}
							}
							return name + div;
						}
					},
					grid: {
						left: '2%',
						right: '5%',
						bottom: '5%',
						top: '15%',
						containLabel: true
					},
					xAxis: {
						//data: categoryData,
						silent: false,
						type: 'category',
						scale: true,
						splitLine: {
							show: false,
						},
						axisTick: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							padding: [5, 0, 0, 5],
							lineHeight: 15,
							textStyle: {
								fontSize: 10,
								color: '#BFBFBF'
							},
							formatter: obj.timeWindow < 3 ? (value) => self.showsj(value) : (value) => self.showrq(value)
						},
						axisLine: {
							lineStyle: {
								color: '#122744'
							}
						}
					},
					yAxis: {
						max: function(value) {
							return value.max
						},
						min: function(value) {
							return 0
						},
						splitNumber: 3,
						nameTextStyle: {
							color: '#373737',
							align: 'right',
							padding: [0, 5, 10, 0]
						},
						type: 'value',
						boundaryGap: ['0', '0.1'],
						axisTick: {
							show: false
						},
						splitArea: {
							show: false
						},
						splitLine: {
							show: self.DarkColor,
							lineStyle: {
								color: '#1B3F72'
							},
						},
						axisLabel: {
							padding: [0, 6, 0, 0],
							textStyle: {
								fontSize: 10,
								color: '#BFBFBF'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#227082'
							}
						}
					},
					//series: series
				}
				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});
					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url,
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}
							var Objreturn = {};
							Objreturn = await self.BarGetByDeviceCode(obj, res.result, ratio, place)
							setOption.xAxis.data = Objreturn.categoryData;
							setOption.series = Objreturn.series;
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										if(obj.data.chartType == 1) {
											/*饼图*/
											self.initPie(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 2) {
											/*柱状图*/
											self.initBar(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 3) {
											/*折线图*/
											self.initLine(obj.data, {}, {}, obj.charts);
										}
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}

			},

			/*模板7 柱状图*/
			initBarNew(obj, DomObj, timeObj, chartsInstance) {
				/*
				 * 柱状图可以显示多个数据源
					obj => 数据集对象 选中的数据集图表类型为柱状图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				*/
				//console.log(timeObj)
				let self = this;
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				/*初始化setOption*/
				var setOption = {
					color: ['#00DBFC', '#00FFB2'],
					legend: {
						show: obj.showLegend,
						orient: 'horizontal',
						// top: 'middle',
						top: '0%',
						right: '7%',
						selectedMode: true,
						icon: 'rect',
						borderRadius: 0,
						itemGap: 10,
						itemWidth: 4,
						itemHeight: 4,
						textStyle: {
							color: 'rgba(196, 225, 255, .6)',
							borderRadius: 0,
							padding: [2, 0, 0, 0]
						},
						formatter: function(name) {
							return name.split('0.')[0]
						},
					},
					tooltip: {
						confine: true,
						transitionDuration: 0,
						backgroundColor: '#FFFFFF',
						borderWidth: 0,
						snap: false,
						trigger: 'axis',
						showContent: true,
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
							shadowStyle: {
								color: 'rgba(0,0,0,0.2)',
								shadowColor: 'rgba(255,255,255,.5)',
								shadowBlur: 6
							}
						},
						textStyle: {　　
							align: 'left',
							color: '#292929'
						},
						extraCssText: self.tooltipCssBy7,
						formatter: function(params) {
							let name = params[0].name;
							let div = '';
							let arr = [];
							for(let a of params) {
								if(params.filter(item => item.seriesName.split('0.')[0] == '平均值' || item.seriesName.split('0.')[0] == '增长量').length == 0) {
									/*透传*/
									let code = a.seriesName.split('-&&-')[1];
									let deviceCode = code.split('&-&')[0];
									let attrCode = code.split('&-&')[1];

									let deviceName = self.DeviceList.filter(item => item.code == deviceCode).length != 0 ? '/' + self.DeviceList.filter(item => item.code == deviceCode)[0].name : ''
									let marker = `<span style="display:inline-block;margin-right:9px;width:10px;height:10px;background-color:${a.color};"></span>`
									if(!arr.includes(code)) {
										if(a.data == '-') {
											div += '<br>' + marker + a.seriesName.split('0.')[0] + deviceName + ": " + '<span style="color:' + a.color + ';font-size: 16px;font-family: agencyr;font-weight: bold;">' + '-' + '</span>';
										} else {
											div += '<br>' + marker + a.seriesName.split('0.')[0] + deviceName + ": " + '<span style="color:' + a.color + ';font-size: 16px;font-family: agencyr;font-weight: bold;">' + self.common.fmoneyNoFix(a.data) + ' ' + a.seriesName.split('-')[1] + '</span>';
										}
										arr.push(code)
									}
								} else {
									/*统计或增长*/
									let name = a.seriesName.split('0.')[0]
									let unit = a.seriesName.split('dataSetUnit=')[1];
									if(!arr.includes(name)) {
										if(a.data == '-') {
											div += '<br>' + marker + name + ": " + '<span style="color:' + a.color + ';font-family: agencyr;font-size: 16px;font-weight: bold;">' + '-' + '</span>';
										} else {
											div += '<br>' + marker + name + ": " + '<span style="color:' + a.color + ';font-family: agencyr;font-size: 16px;font-weight: bold;">' + self.common.fmoneyNoFix(a.data) + " " + unit + '</span>';
										}
										arr.push(name)
									}
								}
							}
							return name + div;
						}
					},
					grid: {
						left: '2%',
						right: '5%',
						bottom: '5%',
						top: '15%',
						containLabel: true
					},
					xAxis: {
						//data: categoryData,
						silent: false,
						type: 'category',
						scale: true,
						splitNumber: 2,
						splitLine: {
							show: false,
						},
						axisTick: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							padding: [0, 0, 0, 5],
							lineHeight: 15,
							textStyle: {
								fontSize: 10,
								color: '#C4E1FF'
							},
							formatter: obj.timeWindow < 3 ? (value) => self.showsj(value) : (value) => self.showrq(value)
						},
						axisLine: {
							show: true,
							lineStyle: {
								type: 'solid',
								color: 'rgb(89, 101, 115)'
							},
						},
					},
					yAxis: {
						min: function(value) {
							if(value.min < 0){
                return value.min
              }else{
                return 0
              }
						},
						splitNumber: 3,
						nameTextStyle: {
							color: '#373737',
							align: 'right',
							padding: [0, 5, 10, 0]
						},
						type: 'value',
						boundaryGap: ['0', '0.1'],
						axisTick: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							padding: [0, 6, 0, 0],
							textStyle: {
								fontSize: 10,
								color: '#C4E1FF'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: 'rgba(228, 240, 255, .3)'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#227082'
							}
						}
					},
					//series: series
				}
				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});
					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts,
						type: 4
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url,
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}
							var Objreturn = {};
							Objreturn = await self.NewBarGetByDeviceCode(obj, res.result, ratio, place)
							setOption.xAxis.data = Objreturn.categoryData;
							setOption.series = Objreturn.series;
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										if(obj.data.chartType == 1) {
											/*饼图*/
											self.initPie(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 2) {
											/*柱状图*/
											self.initBar(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 3) {
											/*折线图*/
											self.initLine(obj.data, {}, {}, obj.charts);
										}
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}

			},

			/*模板7 折线图*/
			initLineNew(obj, DomObj, timeObj, chartsInstance) {
				/*
				 * 折线图可以显示多条数据源 且数据源下data的value是值为三个的数组 如："value": [1,3,5]
					obj => 数据集对象 选中的数据集图表类型为折线图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				*/
				// console.log(obj,timeObj)
				let self = this;
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				/*初始化setOption*/
				var setOption = {
					color: ['#00CCFF', '#9933FF', '#00FFCC'],
					legend: {
						show: obj.showLegend,
						orient: 'horizontal',
						// top: 'middle',
						top: '0%',
						right: '5%',
						selectedMode: true,
						icon: 'rect',
						borderRadius: 0,
						itemGap: 12,
						itemWidth: 10,
						itemHeight: 1,
						textStyle: {
							color: 'rgba(196, 225, 255, .6)',
							borderRadius: 0,
							padding: [2, 0, 0, 0]
						},
						formatter: function(name) {
							return name.split('0.')[0]
						}
					},
					tooltip: {
						confine: true,
						transitionDuration: 0,
						backgroundColor: '#FFFFFF',
						borderWidth: 0,
						snap: false,
						trigger: 'axis',
						showContent: true,
						axisPointer: {
							z: 1,
							animation: true,
							label: {

							},
							lineStyle: {
								color: 'rgba(255,255,255,.52)',
							},
						},
						textStyle: {　　
							align: 'left',
							color: '#292929'
						},
						extraCssText: self.tooltipCssBy7,
						formatter: function(params) {
							let name = params[0].name.split(":")[0] + ":" + params[0].name.split(":")[1].split(':')[0]
							let div = '';
							let arr = [];
							for(let a of params) {
								if(params.filter(item => item.seriesName.split('0.')[0] == '平均值' || item.seriesName.split('0.')[0] == '增长量').length == 0) {
									/*透传*/
									let code = a.seriesName.split('-&&-')[1];
									let deviceCode = code.split('&-&')[0];
									let attrCode = code.split('&-&')[1];
									let value = a.data.v_real;
									let deviceName = self.DeviceList.filter(item => item.code == deviceCode).length != 0 ? '/' + self.DeviceList.filter(item => item.code == deviceCode)[0].name : ''
									let marker = `<span style="display:inline-block;margin-right:9px;border-radius:10px;width:10px;height:1px;background-color:${a.color};position: relative;top: -4px;"></span>`
									if(place&&value&&value!='-'){
                    // console.log("value:",value)
                    value = value.toFixed(place)
                  }
                  let showValue = self.common.fmoneyNoFix(value);
									if(showValue == 'NaN'){
										showValue = '-'
									}else{
                    // showValue = place ? Number(showValue).toFixed(place) + ' ' + unit : showValue + ' ' + unit
										showValue = showValue + ' ' + a.data.unit
									}
									if(!arr.includes(code)) {
										if(a.data.value[1] == '-') {
											div += '<br>' + marker + a.seriesName.split('0.')[0] + deviceName + ": " + '<span style="color:' + a.color + ';font-size: 16px;font-family: agencyr;font-weight: bold;">' + '-' + '</span>';
										} else {
											div += '<br>' + marker + a.seriesName.split('0.')[0] + deviceName + ": " + '<span style="color:' + a.color + ';font-size: 16px;font-family: agencyr;font-weight: bold;">' + showValue + '</span>';
										}
										arr.push(code)
									}
								} else {
									/*统计或增长*/
									let name = a.seriesName.split('0.')[0]
									let deviceCode = code.split('&-&')[0];
									let attrCode = code.split('&-&')[1];
									let value = a.data.v_real
									let unit = a.data.unit;
                  if(place&&value&&value!='-'){
                    // console.log("value:",value)
                    value = value.toFixed(place)
                  }
									let showValue = self.common.fmoneyNoFix(value);
									if(showValue == 'NaN'){
										showValue = '-'
									}else{
                    // showValue = place ? Number(showValue).toFixed(place) + ' ' + unit : showValue + ' ' + unit
										showValue = showValue + ' ' + a.data.unit
									}
									if(!arr.includes(name)) {
										if(a.data == '-') {
											div += '<br>' + marker + name + ": " + '<span style="color:' + a.color + ';font-family: agencyr;font-size: 16px;font-weight: bold;">' + '-' + '</span>';
										} else {
											div += '<br>' + marker + name + ": " + '<span style="color:' + a.color + ';font-family: agencyr;font-size: 16px;font-weight: bold;">' + showValue + '</span>';
										}
										arr.push(name)
									}
								}
							}
							return name + div;
						}
					},
					grid: {
						left: '2%',
						right: '5%',
						bottom: '5%',
						top: '17%',
						containLabel: true
					},
					xAxis: {
						type: 'time',
						boundaryGap: false,
						scale: true,
						splitNumber: 5,
						axisLabel: {
							padding: [0, 0, 0, 0],
							lineHeight: 13,
							textStyle: {
								fontSize: 10,
								color: '#C4E1FF'
							},
							//formatter: obj.timeWindow < 3 ? (value) => self.showsj(value) : (value) => self.showrq(value)
							formatter: function(value){
								if(obj.frameType == 3){
									var date = new Date(Number(value));
									let y = date.getFullYear(),
										m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
										d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
										hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
										min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
										second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
									//return y + '-' + m + '-' + d;
									return hours + ":" + min + ':' + second
								}else{
									if(obj.timeWindow < 3){
										return self.showsj(value)
									}else{
										return self.showrq(value)
									}
								}
							}
						},
						splitLine: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								type: 'solid',
								color: 'rgb(89, 101, 115)'
							},
						},
						axisTick: {
							show: false,
						}
					},
					yAxis: {
						max: function(value) {
							let ret;
							let max = String(value.max)
							let arr = max.split('.')
							if(self.NewLineByOneAttr){
								/*只有一个属性时 max保留一位小数*/
								if(arr.length == 1){
									ret = value.max
								}else{
									let decimal = arr[1].split('')
									if(decimal.length > 1){
										let last;
                    if(value.max<0){
                      last = Number(decimal[0])-1
                    }else{
                      last = Number(decimal[0])+1
                    }
										if(last == 10){
											ret = Number(arr[0])+1
										}else{
											ret = Number(arr[0]+'.'+last)
										}
									}else{
										ret = value.max
									}
								}
							}else{
								ret = 100
							}
							return ret
						},
						min: function(value) {
							let ret;
							let min = String(value.min)
							let arr = min.split('.')
							if(self.NewLineByOneAttr){
								/*只有一个属性时 min保留一位小数*/
								if(arr.length == 1){
									ret = value.min
								}else{
									let decimal = arr[1].split('')
									if(value.min < 0){
                    ret = Number(arr[0]+'.'+(Number(decimal[0])+1))
                  }else{
                    ret = Number(arr[0]+'.'+decimal[0])
                  }
								}
							}else{
								ret = 0
							}
							return ret
						},
						//scale: true,
						gridIndex: 0,
						/*splitNumber: 4,
						minInterval: 1,
						maxInterval: 25,*/
						axisTick: {
							show: false,
						},
						axisLabel: {
							padding: [5, 7, 0, 0],
							textStyle: {
								fontSize: 10,
								color: '#C4E1FF'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#122744'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: 'rgba(228, 240, 255, .3)'
							}
						},
					},
					//series: series
				}
				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});
					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts,
						type: 3
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
          // console.log(url) sys/dataset/14/push
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url,
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}
							var Objreturn = await self.NewLineGetByDeviceCode(obj, res.result, ratio, place)
							setOption.series = Objreturn.series;
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								setOption.yAxis = {
									splitNumber: 4,
									minInterval: 1,
									maxInterval: 25
								}
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										if(obj.data.chartType == 1) {
											/*饼图*/
											self.initPie(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 2) {
											/*柱状图*/
											self.initBar(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 3) {
											/*折线图*/
											self.initLine(obj.data, {}, {}, obj.charts);
										}
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}
			},

			/*折线图*/
			initLine(obj, DomObj, timeObj, chartsInstance) {
				/*
				 * 折线图可以显示多条数据源 且数据源下data的value是值为三个的数组 如："value": [1,3,5]
					obj => 数据集对象 选中的数据集图表类型为折线图
					DomObj => dom,chartsWidth,chartsHeight => 当前图表dom,当前图表需要定义的宽度,高度
					timeObj => IntervalMark,timeInterval => 当前是否需要开启定时器,当前定时器时间
				*/
				//console.log(timeObj)
				let self = this;
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				/*初始化setOption*/
				var setOption = {
					color: self.LineColor,
					legend: {
						show: obj.showLegend,
						orient: 'horizontal',
						// top: 'middle',
						top: '3%',
						right: '5%',
						selectedMode: false,
						icon: 'rect',
						borderRadius: 0,
						itemGap: 8,
						itemWidth: 11,
						itemHeight: 11,
						textStyle: {
							color: self.DarkColor ? '#fff' : '#9DA8BC',
							borderRadius: 0,
							padding: [2, 0, 0, 0]
						},
						formatter: function(name) {
							return name.split('0.')[0]
						}
					},
					tooltip: {
						confine: true,
						transitionDuration: 0,
						backgroundColor: '#FFFFFF',
						borderWidth: 0,
						snap: false,
						trigger: 'axis',
						showContent: true,
						axisPointer: {
							z: 1,
							animation: true,
							label: {

							},
							lineStyle: {
								color: 'transparent',
							},
						},
						textStyle: {　　
							align: 'left',
							color: '#292929'
						},
						extraCssText: self.DarkColor ? self.tooltipCssByDark : self.tooltipCss,
						formatter: function(params) {
							let name = params[0].name.split(":")[0] + ":" + params[0].name.split(":")[1].split(':')[0]
							let div = '';
							let arr = [];
							for(let a of params) {
								if(params.filter(item => item.seriesName.split('0.')[0] == '平均值' || item.seriesName.split('0.')[0] == '增长量').length == 0) {
									/*透传*/
									let code = a.seriesName.split('-&&-')[1];
									let deviceCode = code.split('&-&')[0];
									let attrCode = code.split('&-&')[1];

									let deviceName = self.DeviceList.filter(item => item.code == deviceCode).length != 0 ? '/' + self.DeviceList.filter(item => item.code == deviceCode)[0].name : ''

									if(!arr.includes(code)) {
										if(a.data.value[1] == '-') {
											div += '<br>' + a.marker + a.seriesName.split('0.')[0] + deviceName + " " + '-';
										} else {
											div += '<br>' + a.marker + a.seriesName.split('0.')[0] + deviceName + " " + place ? self.common.fmoneyNoFix(a.data.value[1].toFixed(place)): self.common.fmoneyNoFix(a.data.value[1]) + ' ' + a.data.unit;
										}
										arr.push(code)
									}
								} else {
									/*统计或增长*/
									let name = a.seriesName.split('0.')[0]
									let unit = a.data.unit;
									if(!arr.includes(name)) {
										if(a.data == '-') {
											div += '<br>' + a.marker + name + " " + '-';
										} else {
											div += '<br>' + a.marker + name + " " + place ? self.common.fmoneyNoFix(a.data.value[1].toFixed(place)): self.common.fmoneyNoFix(a.data.value[1]) + " " + unit;
										}
										arr.push(name)
									}
								}
							}
							return name + div;
						}
					},
					grid: {
						left: '2%',
						right: '5%',
						bottom: '5%',
						top: '17%',
						containLabel: true
					},
					xAxis: {
						type: 'time',
						boundaryGap: false,
						scale: true,
						splitNumber: 7,
						axisLabel: {
							padding: [0, 0, 0, 0],
							lineHeight: 13,
							textStyle: {
								fontSize: 10,
								color: '#BFBFBF'
							},
							formatter: obj.timeWindow < 3 ? (value) => self.showsj(value) : (value) => self.showrq(value)
						},
						splitLine: {
							show: false,
							interval: 5,
							lineStyle: {
								type: 'solid',
								color: '#F8FAFB'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#122744'
							},
							onZero: false,
						},
						axisTick: {
							show: false,
						}
					},
					yAxis: {
						max: function(value) {
							return value.max
						},
						min: function(value) {
							return value.min
						},
						//scale: true,
						gridIndex: 0,
						splitNumber: 3,
						axisTick: {
							show: false,
						},
						axisLabel: {
							padding: [5, 7, 0, 0],
							textStyle: {
								fontSize: 10,
								color: '#BFBFBF'
							}
						},
						axisLine: {
							show: false,
						},
						splitArea: 2,
						splitLine: {
							show: self.DarkColor,
							interval: 5,
							lineStyle: {
								type: 'solid',
								color: '#122744'
							}
						},
					},
					//series: series
				}
				var charts;
				if(obj.frameType == 3) {
					/* 实时
					 * mqtt*/
					charts = self.$echarts.init(DomObj.dom, '', {
						width: DomObj.chartsWidth,
						height: DomObj.chartsHeight
					}); //初始化图表
					charts.resize({
						height: DomObj.chartsHeight,
						width: DomObj.chartsWidth
					});
					charts.setOption(setOption)
					self.MqttCharts.push({
						id: obj.id,
						obj: obj,
						charts: charts
					})
					let url;
					if(obj.type == 1) {
						url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
					} else {
						url = 'sys/dataset/' + obj.id + '/push';
					}
					if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
						self.MqttByDataSetUrl.push({
							id: obj.id,
							url: url,
						})
					}
					self.NowLoadNum++;
				} else {
					/* 相对时间段 || 指定时间段
					 * 获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async(res) => {
						if(res.success == true) {
							if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
								self.NowLoadNum++;
								return;
							}
							var Objreturn = await self.LineGetByDeviceCode(obj, res.result, ratio, place)
							setOption.series = Objreturn.series;
							if(self.common.istrue(chartsInstance)) {
								chartsInstance.setOption(setOption)
							} else {
								charts = self.$echarts.init(DomObj.dom, '', {
									width: DomObj.chartsWidth,
									height: DomObj.chartsHeight
								}); //初始化图表
								charts.resize({
									height: DomObj.chartsHeight,
									width: DomObj.chartsWidth
								});
								charts.setOption(setOption)
								/*定时器*/
								if(timeObj.IntervalMark) {
									self.longTimeOut.setInterval((obj) => {
										if(obj.data.chartType == 1) {
											/*饼图*/
											self.initPie(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 2) {
											/*柱状图*/
											self.initBar(obj.data, {}, {}, obj.charts);
										} else if(obj.data.chartType == 3) {
											/*折线图*/
											self.initLine(obj.data, {}, {}, obj.charts);
										}
									}, timeObj.timeInterval, {
										data: obj,
										charts: charts
									})
								}
							}
							self.NowLoadNum++;
						} else {
							self.NowLoadNum++;
						}
					})
				}
			},

			/*文本标签*/
			initTable(obj, refName) {
				/*
				 * 表格 可以有多条数据源 即多个tableData.attr	时间一致
					obj => 数据集对象 选中的数据集图表类型为文本标签
				 */
				return new Promise(resolve => {
					let self = this;
					//初始化表格
					self.tableList[refName] = {
						attr: [],
						data: [],
					};
					if(obj.ratio || Number(obj.ratio) == 0) {
						var ratio = obj.ratio
					} else {
						var ratio = 1;
					}
					//保留小数
					if(obj.place) {
						var place = obj.place
					} else {
						var place = null;
					}

					if(obj.frameType == 3) {
						/* 实时
						 * mqtt*/
						self.MqttCharts.push({
							id: obj.id,
							obj: obj,
							refName: refName,
						})
						let url;
						if(obj.type == 1) {
							url = 'sys/dataset/' + obj.id + '/' + self.companyCode + '/push'
						} else {
							url = 'sys/dataset/' + obj.id + '/push';
						}
						if(self.MqttByDataSetUrl.filter(item => item.id == obj.id).length == 0) {
							self.MqttByDataSetUrl.push({
								id: obj.id,
								url: url,
							})
						}
						resolve();
					} else {
						/* 相对时间段 || 指定时间段
						 * 获取数据集历史数据*/
						self.get('/Dataset/getReport', {
							id: obj.id, //数据集编号
							code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
						}).then(async(res) => {
							if(res.success == true) {
								if(JSON.stringify(res.result) == '{}' || JSON.stringify(res.result) == '[]') {
									resolve();
									return;
								}
								let Objreturn = await self.TableGetByDeviceCode(obj, res.result, ratio, place);
								self.tableList[refName] = {
									attr: Objreturn.attr,
									data: Objreturn.data
								};
								resolve();
							} else {
								resolve();
							}
						})
					}
				})
			},

			/*新需求 x轴只显示日期*/
			showrq(value) {
				var date = new Date(value);
				let y = date.getFullYear(),
					m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
					d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
					hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
					min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
				//return y + '-' + m + '-' + d;
				return m + '-' + d;
			},

			/*新需求 x轴只显示时间*/
			showsj(value) {
				var date = new Date(value);
				let y = date.getFullYear(),
					m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
					d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
					hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
					min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
					second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
				//return y + '-' + m + '-' + d;
				return hours + ":" + min + ':' + second
			},

			/*获取公司报警*/
			getAlarmByCategory() {
				let self = this;
				return new Promise((resolve) => {
					self.get('/DeviceAlarm/groupCompanyAlarmByCategory', {
						companyId: self.companyId, //设备code
					}).then((res) => {
						if(res.success == true) {
							resolve(res.result);
						} else {
							resolve([])
						}
					})
				})
			},

			/*获取公司报警*/
			getAlarmByLevel() {
				let self = this;
				return new Promise((resolve) => {
					self.get('/DeviceAlarm/groupCompanyAlarmByLevel', {
						companyId: self.companyId, //设备code
					}).then((res) => {
						if(res.success == true) {
							resolve(res.result);
						} else {
							resolve([])
						}
					})
				})
			},

			/*通过 设备Code/属性code 获取物模型对象*/
			getProductFeature(deviceCode, propertyCode) {
				/* 同步
				 * deviceCode => 设备code
				 * propertyCode => 属性code
				 * 返回物模型对象
				 * */
				let self = this;
				return new Promise((resolve) => {
					if(deviceCode.slice(0,2)=='_V'){
            let property = self.VirtualDevice.propertyList.filter(item => item.code == propertyCode)
            if(property[0]){
              resolve({
              	name: property[0].name + '/虚拟设备',
              	dataType: {
              		specs: {
              			unit:property[0].unit,
                    step:property[0].step
              		}
              	}
              })
            }else{
              resolve({
              	name: '',
              	dataType: {
              		specs: {
              			unit: ''
              		}
              	}
              })
            }
          }else{
            let FeatureArr = self.ProductFeature.filter(item => item.deviceCode == deviceCode)
            if(FeatureArr.length == 0) {
            	self.get('/ProductFeature/getByDeviceCode', {
            		code: deviceCode, //设备code
            	}).then((resPro) => {
            		if(resPro.success == true) {
            			let dataList;
            			if(!resPro.result){
            			  dataList = []
            			}else{
            			  dataList = JSON.parse(resPro.result).properties;
            			}
                  self.ProductFeature.push({
                    deviceCode: deviceCode,
                    properties: dataList
                  })
            			if(propertyCode) {
            				if(!resPro.result){
            					resolve({
            						name: '',
            						dataType: {
            							specs: {
            								unit: ''
            							}
            						}
            					})
            				}else{
            					resolve(dataList.filter(item => item.identifier == propertyCode)[0])
            				}
            			} else {
            				resolve(dataList)
            			}
            			return;
            		}
            	})
            } else {
            	if(propertyCode) {
            		if(FeatureArr[0].properties.length == 0){
            			resolve({
            				name: '',
            				dataType: {
            					specs: {
            						unit: ''
            					}
            				}
            			})
            		}else{
            			resolve(FeatureArr[0].properties.filter(item => item.identifier == propertyCode)[0])
            		}
            	} else {
            		resolve(FeatureArr[0].properties)
            	}
            	return;
            }
          }
				})
			},

			/*通过 产品Code/属性code 获取物模型对象*/
			getProductFeatureByCP(deviceCode, propertyCode) {
				/* 同步
				 * deviceCode => 产品code
				 * propertyCode => 属性code
				 * 返回物模型对象
				 * */
				let self = this;
				return new Promise((resolve) => {
					let FeatureArr = self.ProductFeatureCP.filter(item => item.deviceCode == deviceCode)
					if(FeatureArr.length == 0) {
						self.get('/ProductFeature/get', {
							code: deviceCode, //产品code
						}).then((resPro) => {
							if(resPro.success == true) {
                let dataList = JSON.parse(resPro.result).properties;
								self.ProductFeatureCP.push({
									deviceCode: deviceCode,
									properties: dataList
								})
								resolve(dataList.filter(item => item.identifier == propertyCode)[0])
								return;
							}
						})
					} else {
						resolve(FeatureArr[0].properties.filter(item => item.identifier == propertyCode)[0])
						return;
					}
				})
			},

			/*通过 产品Code 获取该产品下的所有设备 返回列表*/
			getDeviceListByProCode(code) {
				/* 同步
				 * code => 产品code
				 * 返回该产品下的设备列表
				 */
				let self = this;
				return new Promise((resolve) => {
					self.get('/Device/getListByProduct', {
						productCode: code, //产品code
						companyId: self.companyId
					}).then((res) => {
						if(res.success == true) {
							let dataList = res.result;
							resolve(dataList)
							return;
						}
					})
				})
			},

			/*通过报警id获取报警对象*/
			getDictById(id) {
				/* 同步
				 * id => 报警类别id
				 * 返回报警对象名称
				 * */
				let self = this;
				return new Promise((resolve) => {
					self.get('/Dict/getListByType', {
						type: 2, //报警分类
					}).then((resPro) => {
						if(resPro.success == true) {
							let obj = resPro.result.filter(item => item.id == Number(id))[0];
							if(!obj) {
								resolve('')
							} else {
								resolve(obj.name);
							}
						}
					})
				})
			},

			/*通过产品Code获取产品对象*/
			getProductByCode(code) {
				/* 同步
				 * code => 产品code
				 * 返回产品对象名称
				 * */
				let self = this;
				return new Promise((resolve) => {
					self.get('/Product/getList').then((resPro) => {
						if(resPro.success == true) {
							let obj = resPro.result.filter(item => item.code == code)[0];
							if(!obj) {
								resolve('')
							} else {
								resolve(obj.name);
							}
						}
					})
				})
			},

			/*水球 解决异步问题 调用产品物模型*/
			WaterGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 * 返回一对象 包含值 数字 0 ~ 100 和 单位 unit
				 */
				let self = this;
				return new Promise(async(resolve) => {
					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve({
							value: 0,
							unit: ''
						})
						return;
					}

					let data = [];
					let resultList = result[0]
					/*总配置*/
					let nameA = '';
					let nameB = '';
					let nameC = '';
					let featureList;
					let unit;
					let errorDown,//属性值下下限
						errorUp,//属性值上上限
						warnDown,//属性值下限
						warnUp;//属性值上限
					if(obj.function == 'pass') {
						if(resultList.deviceCode.indexOf('_') == 0) {
							/*判断数据集历史记录的单个对象是否为系统属性*/
							unit = '';
							if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
								nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
							} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
								nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
							} else {
								nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
							}
						} else {
							/*不为系统属性时*/
							/*获取TSL 获取 数据属性名称*/
							featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
							errorDown = featureList.dataType.errorDown//属性值下下限
							errorUp = featureList.dataType.errorUp//属性值上上限
							warnDown = featureList.dataType.warnDown//属性值下限
							warnUp = featureList.dataType.warnUp//属性值上限

							unit = featureList.dataType.specs.unit
							nameA = featureList.name;
						}
					} else {
						unit = obj.unit;
						/*配置图例名称后缀*/
						if(obj.function == 'add') {
							//nameA = '-求和'
							nameA = ' ';
						} else if(obj.function == 'growth') {
							nameA = '增长量'
							nameB = '增长率'
						} else if(obj.function == 'time') {
							//nameA = '-持续时长'
							nameA = ' ';
						} else if(obj.function == 'sample') {
							nameA = '最小值'
							nameB = '最大值'
							nameC = '平均值'
						}
					}
					if(!unit) {
						unit = '';
					}

					if(resultList.data.length == 0) {
						resolve({
							value: 0,
							unit: unit,
							type: 1
						})
						return
					}
					let value = Number((resultList.data[0].value[0] * ratio).toFixed(place));
					var colorType = 1;
					if(warnDown != null && warnDown != undefined){
						if(value<=warnDown){
							colorType = 2
						}
					}
					if(warnUp != null && warnUp != undefined){
						if(value>=warnUp){
							colorType = 2
						}
					}
					if(errorDown != null && errorDown != undefined){
						if(value<=errorDown){
							colorType = 3
						}
					}
					if(errorUp != null && errorUp != undefined){
						if(value>=errorUp){
							colorType = 3
						}
					}

					resolve({
						value: value,
						unit: unit,
						type: colorType
					})

				})

			},

			/*仪表盘下方Last 解决异步问题 调用产品物模型*/
			LastGaugeGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 * 返回一对象 包含值 数字 0 ~ 100 和 单位 unit
				 */
				let self = this;
				return new Promise(async(resolve) => {
					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve({
							value: 0,
							unit: ''
						})
						return;
					}

					let data = [];
					let resultList = result[0]
					/*总配置*/
					let nameA = '';
					let nameB = '';
					let nameC = '';
					let featureList;
					let unit;
					let errorDown,//属性值下下限
						errorUp,//属性值上上限
						warnDown,//属性值下限
						warnUp;//属性值上限
					if(obj.function == 'pass') {
						if(resultList.deviceCode.indexOf('_') == 0) {
							/*判断数据集历史记录的单个对象是否为系统属性*/
							unit = '';
							if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
								nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
							} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
								nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
							} else {
								nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
							}
						} else {
							/*不为系统属性时*/
							/*获取TSL 获取 数据属性名称*/
							featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
							errorDown = featureList.dataType.errorDown//属性值下下限
							errorUp = featureList.dataType.errorUp//属性值上上限
							warnDown = featureList.dataType.warnDown//属性值下限
							warnUp = featureList.dataType.warnUp//属性值上限

							unit = featureList.dataType.specs.unit
							nameA = featureList.name;
						}
					} else {
						unit = obj.unit;
						/*配置图例名称后缀*/
						if(obj.function == 'add') {
							//nameA = '-求和'
							nameA = ' ';
						} else if(obj.function == 'growth') {
							nameA = '增长量'
							nameB = '增长率'
						} else if(obj.function == 'time') {
							//nameA = '-持续时长'
							nameA = ' ';
						} else if(obj.function == 'sample') {
							nameA = '最小值'
							nameB = '最大值'
							nameC = '平均值'
						}
					}
					if(!unit) {
						unit = '';
					}

					if(resultList.data.length == 0) {
						resolve({
							value: 0,
							unit: unit,
							type: 0
						})
						return
					}
					let value = Number((resultList.data[0].value[0] * ratio).toFixed(place));
					var colorType = 1;
					if(warnDown != null && warnDown != undefined){
						if(value<=warnDown){
							colorType = 2
						}
					}
					if(warnUp != null && warnUp != undefined){
						if(value>=warnUp){
							colorType = 2
						}
					}
					if(errorDown != null && errorDown != undefined){
						if(value<=errorDown){
							colorType = 3
						}
					}
					if(errorUp != null && errorUp != undefined){
						if(value>=errorUp){
							colorType = 3
						}
					}
					resolve({
						value: value,
						unit: unit,
						type: colorType
					})

				})

			},

			/*仪表盘 解决异步问题 调用产品物模型*/
			GaugeGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 * 返回一对象 包含值 数字 0 ~ 100 和 单位 unit
				 */
				let self = this;
				return new Promise(async(resolve) => {
					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve({
							value: 0,
							unit: ''
						})
						return;
					}

					let data = [];
					let resultList = result[0]
					/*总配置*/
					let nameA = '';
					let nameB = '';
					let nameC = '';
					let featureList;
					let unit;
					if(obj.function == 'pass') {
						if(resultList.deviceCode.indexOf('_') == 0) {
							/*判断数据集历史记录的单个对象是否为系统属性*/
							unit = '';
							if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
								nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
							} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
								nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
							} else {
								nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
							}
						} else {
							/*不为系统属性时*/
							/*获取TSL 获取 数据属性名称*/
							featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
							unit = featureList.dataType.specs.unit
							nameA = featureList.name;
						}
					} else {
						unit = obj.unit;
						/*配置图例名称后缀*/
						if(obj.function == 'add') {
							//nameA = '-求和'
							nameA = ' ';
						} else if(obj.function == 'growth') {
							nameA = '增长量'
							nameB = '增长率'
						} else if(obj.function == 'time') {
							//nameA = '-持续时长'
							nameA = ' ';
						} else if(obj.function == 'sample') {
							nameA = '最小值'
							nameB = '最大值'
							nameC = '平均值'
						}
					}
					if(!unit) {
						unit = '';
					}

					if(resultList.data.length == 0) {
						resolve({
							value: 0,
							unit: unit
						})
						return
					}
					let value = Number((resultList.data[0].value[0] * ratio).toFixed(place));

					resolve({
						value: value,
						unit: unit
					})

				})

			},

			/*饼图 解决异步问题 调用产品物模型*/
			PieGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 */
				let self = this;
				return new Promise(async(resolve) => {
					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve([])
						return;
					}

					let data = [];
					/*总配置*/
					let resultIndex = 0;
					/*将数据集历史记录每条数据的value值作为饼图的值*/
					for(let resultList of result) {
						let nameA = '';
						let nameB = '';
						let nameC = '';
						let featureList;
						let unit;
						if(obj.function == 'pass') {
							if(resultList.deviceCode.indexOf('_') == 0) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
								} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
								}
							} else {
								/*不为系统属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							}
						} else {
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
						}
						if(!unit) {
							unit = '';
						}

						let indexForI = 0
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let valueDataC = []; //value[2]值

						if(resultList.data.length == 0) {
							resolve(data)
							return
						}
						/*数据处理 ...遍历柱状图数量 ...*/
						for(let i of resultList.data[0].value) {
							let name;
							if(indexForI == 0) {
								name = nameA;
							} else if(indexForI == 1) {
								name = nameB;
							} else if(indexForI == 2) {
								name = nameC;
							}
							data.push({
								name: name + '/' + Math.random(),
								deviceCode: resultList.deviceCode,
								attrCode: resultList.propertyCode,
								showName: name,
								propertyCode: name,
								unit: unit,
								value: Number((i * ratio).toFixed(place))
							})
							indexForI++;
						}
						resultIndex++;
						if(resultIndex == result.length) {
							resolve(data)
						}
					}

					/*将数据集历史记录最后一条数据的value值作为饼图的值 (错误)*/
					/*for(let i of result.data[result.data.length - 1].value){
						let name;
						if(indexForI == 0){
							name = nameA;
						}else if(indexForI == 1){
							name = nameB;
						}else if(indexForI == 2){
							name = nameC;
						}
						data.push({
							name: name + '/' +Math.random(),
							showName: name,
							propertyCode: name,
							unit: unit,
							value: Number((i * ratio).toFixed(place))
						})
						indexForI++;
					}
					resolve(data)*/
				})

			},

			/*柱状图 解决异步问题 调用产品物模型*/
			NewBarGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录对象(有多个)
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 * 该函数返回三个值
				 * series,categoryData
				 * =>
				 * 图表series,x轴数据(时间)categoryData
				 */
				let self = this;
				return new Promise(async(resolve) => {
					let series = [];
					let categoryData = [];

					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve({
							series: [],
							categoryData: []
						})
						return;
					}

					/*配置x轴时间*/
					let timeIndex = 0;
					for(let res_data of result[0].data) {
						if(timeIndex < 24){
							//配置x轴时间
							let date = new Date(res_data.time);
							categoryData.push(self.$echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', date))
						}
						timeIndex++;
					}

					/*总配置*/
					let resultIndex = 0;
					for(let resultList of result) {
						let nameA = '';
						let nameB = '';
						let nameC = '';
						let featureList;
						let unit;
						if(obj.function == 'pass') {
							if(resultList.deviceCode.indexOf('_') == 0) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
								} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
								}
							} else {
								/*不为系统属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							}
						} else {
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
						}
						if(!unit) {
							unit = '';
						}
						let index = 0; //当前数据源长度索引
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						/*数据处理 ...遍历柱状图数量 ...*/
						for(let dataList of resultList.data) {
							if(index < 24){
								let value_index = 0; //当前数据源中的value长度索引
								for(let value of dataList.value) {
									if(value_index == 0) {
										if(value == null) {
											valueDataA.push('-')
										} else {
											valueDataA.push(Number((value * ratio).toFixed(place)))
										}
									} else if(value_index == 1) {
										if(value == null) {
											valueDataB.push('-')
										} else {
											valueDataB.push(Number((value * ratio).toFixed(place)))
										}
									}
									value_index++;
								}
							}

							index++;
							if(index == 24) {
								/*一组数据源 需要显示的柱状条数*/
								/*当前数据源最后一次循环时 将数据添加进图表中*/
								let length_index = 0; //当前数据源中的value长度索引
								for(let length of dataList.value) {
									let seriesObj = {}; //临时存储
									if(length_index == 0) {
										seriesObj = {
											propertyCode: nameA,
											code: resultList.deviceCode + '-' + resultList.propertyCode,
											name: nameA + Math.random() + '-' + unit + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'bar',
											data: valueDataA,
											barGap: '35%',
											large: true,
											barWidth: 4,
										}
									} else if(length_index == 1) {
										seriesObj = {
											propertyCode: nameB,
											name: nameB + Math.random() + '-' + unit + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'bar',
											data: valueDataB,
											barGap: '35%',
											large: true,
											barWidth: 4,
										}
									}
									length_index++;
									series.push(seriesObj)
								}
							}
						}
						resultIndex++;
						if((resultIndex >= 2) || (series.length >= 2) || (resultIndex == result.length)) {
							resolve({
								series: series,
								categoryData: categoryData,
							})
							return;
						}
					}
				})
			},

			/*柱状图 解决异步问题 调用产品物模型*/
			BarGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录对象(有多个)
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 * 该函数返回三个值
				 * series,categoryData
				 * =>
				 * 图表series,x轴数据(时间)categoryData
				 */
				let self = this;
				return new Promise(async(resolve) => {
					let series = [];
					let categoryData = [];

					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve({
							series: [],
							categoryData: []
						})
						return;
					}

					/*配置x轴时间*/
					for(let res_data of result[0].data) {
						//配置x轴时间
						let date = new Date(res_data.time);
						categoryData.push(self.$echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', date))
					}

					/*总配置*/
					let resultIndex = 0;
					for(let resultList of result) {
						let nameA = '';
						let nameB = '';
						let nameC = '';
						let featureList;
						let unit;
						if(obj.function == 'pass') {
							if(resultList.deviceCode.indexOf('_') == 0) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
								} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
								}
							} else {
								/*不为系统属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							}
						} else {
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
						}
						if(!unit) {
							unit = '';
						}
						let index = 0; //当前数据源长度索引
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let valueDataC = []; //value[2]值
						/*数据处理 ...遍历柱状图数量 ...*/
						for(let dataList of resultList.data) {
							let value_index = 0; //当前数据源中的value长度索引
							for(let value of dataList.value) {
								if(value_index == 0) {
									if(value == null) {
										valueDataA.push('-')
									} else {
										valueDataA.push(Number((value * ratio).toFixed(place)))
									}
								} else if(value_index == 1) {
									if(value == null) {
										valueDataB.push('-')
									} else {
										valueDataB.push(Number((value * ratio).toFixed(place)))
									}
								} else if(value_index == 2) {
									if(value == null) {
										valueDataC.push('-')
									} else {
										valueDataC.push(Number((value * ratio).toFixed(place)))
									}
								}
								value_index++;
							}

							index++;
							if(index == resultList.data.length) {
								/*一组数据源 需要显示的柱状条数*/
								/*当前数据源最后一次循环时 将数据添加进图表中*/
								let length_index = 0; //当前数据源中的value长度索引
								for(let length of dataList.value) {
									let seriesObj = {}; //临时存储
									if(length_index == 0) {
										seriesObj = {
											propertyCode: nameA,
											code: resultList.deviceCode + '-' + resultList.propertyCode,
											name: nameA + Math.random() + '-' + unit + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'bar',
											data: valueDataA,
											barGap: '35%',
											large: true,
										}
									} else if(length_index == 1) {
										seriesObj = {
											propertyCode: nameB,
											name: nameB + Math.random() + '-' + unit + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'bar',
											data: valueDataB,
											barGap: '35%',
											large: true,
										}
									} else if(length_index == 2) {
										seriesObj = {
											propertyCode: nameC,
											name: nameC + Math.random() + '-' + unit + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'bar',
											data: valueDataC,
											barGap: '35%',
											large: true,
										}
									}
									length_index++;
									series.push(seriesObj)
								}
							}
						}
						resultIndex++;
						if(resultIndex == result.length) {
							resolve({
								series: series,
								categoryData: categoryData,
							})
						}
					}
				})
			},


			/*传入数组 获取最大值最小值*/
			getNumNew(arr,index) {
				if(arr.length == 0) {
					return {
						max: 0,
						min: 0
					}
				}
				var max = arr[0].value[index];
				var min = arr[0].value[index];
				for(var i = 1; i < arr.length; i++) {
					if(arr[i].value[index] || arr[i].value[index] == 0) {
						if(!max && max != 0) max = arr[i].value[index];
						if(!min && min != 0) min = arr[i].value[index];
						if(max < arr[i].value[index]) max = arr[i].value[index];
						if(min > arr[i].value[index]) min = arr[i].value[index];
					}
				}
				return {
					max: max,
					min: min
				}
			},

			/*折线图 解决异步问题 调用产品物模型*/
			NewLineGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录对象(有多个)
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 * 该函数返回一个值
				 * series => 图表series
				 */
				let self = this;
				return new Promise(async(resolve) => {
					let series = [];

					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve({
							series: []
						})
						return;
					}

					this.v_real = JSON.parse(JSON.stringify(result))


					/*总配置*/
					let resultIndex = 0;
					for(let resultList of result) {
						let arrReal = this.v_real.filter(item => item.deviceCode==resultList.deviceCode&&item.propertyCode==resultList.propertyCode)[0];

						/*将值处理修正系数*/
						for(let sultData of resultList.data){
							for(let reVal of sultData.value){
								reVal = (reVal * ratio).toFixed(place);
							}
						}

						/*取最大最小值*/
						let reValIndex = 0;
						let numObj1,numObj2,numObj3;
						for(let n of resultList.data[0].value){
							if(reValIndex == 0){
								numObj1 = this.getNumNew(arrReal.data,reValIndex)
							}else if(reValIndex == 0){
								numObj2 = this.getNumNew(arrReal.data,reValIndex)
							}else if(reValIndex == 0){
								numObj3 = this.getNumNew(arrReal.data,reValIndex)
							}
							reValIndex++;
						}

						//更改value为比例
						for(let d = 0; d < resultList.data.length; d++){
							for(let a = 1; a <= resultList.data[d].value.length; a++){
								if(resultList.data[d].value[a-1] != null){
									let max, min;
									if(a == 1){
										max = numObj1.max;
										min = numObj1.min;
									}else if(a == 2){
										max = numObj2.max;
										min = numObj2.min;
									}else if(a == 3){
										max = numObj3.max;
										min = numObj3.min;
									}
									if(resultList.data[d].value[a-1] == max){
										resultList.data[d].value[a-1] = 100
									}else if(resultList.data[d].value[a-1] == min){
										resultList.data[d].value[a-1] = 0
									}else if(max == min){
										resultList.data[d].value[a-1] = 100
									}else{
										resultList.data[d].value[a-1] = Math.round(((resultList.data[d].value[a-1] - min) / (max - min)) * 100)
									}
								}
							}
						}

						let nameA = '';
						let nameB = '';
						let nameC = '';
						let featureList;
						let unit;
						if(obj.function == 'pass') {
							if(resultList.deviceCode.indexOf('_') == 0) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
								} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
								}
							} else {
								/*不为系统属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							}
						} else {
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
						}
						if(!unit) {
							unit = '';
						}
						let index = 0; //当前数据源的长度索引
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let valueDataC = []; //value[2]值

						/*数据处理 ...遍历折线图数量 ...*/
						for(let dataList of resultList.data) {
							let value_index = 0; //当前数据源中的value长度索引
							for(let value of dataList.value) {
								if(value_index == 0) {
									if(value == null) {
										valueDataA.push(self.randomDataNew(unit, dataList.time, null))
									} else {
										valueDataA.push(self.randomDataNew(unit, dataList.time, value, arrReal.data.filter(item => item.time == dataList.time)[0].value[value_index]))
									}
								} else if(value_index == 1) {
									if(value == null) {
										valueDataB.push(self.randomDataNew(unit, dataList.time, null))
									} else {
										valueDataB.push(self.randomDataNew(unit, dataList.time, value, arrReal.data.filter(item => item.time == dataList.time)[0].value[value_index]))
									}
								} else if(value_index == 2) {
									if(value == null) {
										valueDataC.push(self.randomDataNew(unit, dataList.time, null))
									} else {
										valueDataC.push(self.randomDataNew(unit, dataList.time, value, arrReal.data.filter(item => item.time == dataList.time)[0].value[value_index]))
									}
								}
								value_index++;
							}

							index++;
							if(index == resultList.data.length) {
								/*一组数据源 需要显示的折线条数*/
								/*当前数据源最后一次循环时 将数据添加进图表中*/
								let length_index = 0; //当前数据源中的value长度索引
								for(let length of dataList.value) {
									let seriesObj = {}; //临时存储
									if(length_index == 0) {
										seriesObj = {
											propertyCode: nameA,
											name: nameA + Math.random() + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											code: resultList.deviceCode + '-' + resultList.propertyCode,
											type: 'line',
											symbolSize: 9,
											smooth: true,
											seriesLayoutBy: 'row',
											showSymbol: false,
											hoverAnimation: false,
											data: valueDataA,
											itemStyle: {
												normal: {
													borderWidth: 4,
													shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
													shadowBlur: 8
												},
											},
											lineStyle: {
												shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
												shadowBlur: 8
											},
										}
									} else if(length_index == 1) {
										seriesObj = {
											propertyCode: nameB,
											name: nameB + Math.random() + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'line',
											symbolSize: 9,
											smooth: true,
											seriesLayoutBy: 'row',
											showSymbol: false,
											hoverAnimation: false,
											data: valueDataB,
											itemStyle: {
												normal: {
													borderWidth: 4,
													shadowColor: series.length==1?'#9933FF':'#00FFCC',
													shadowBlur: 8
												},
											},
											lineStyle: {
												shadowColor: series.length==1?'#9933FF':'#00FFCC',
												shadowBlur: 8
											},
										}
									} else if(length_index == 2) {
										seriesObj = {
											propertyCode: nameC,
											name: nameC + Math.random() + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'line',
											symbolSize: 9,
											smooth: true,
											seriesLayoutBy: 'row',
											showSymbol: false,
											hoverAnimation: false,
											data: valueDataC,
											itemStyle: {
												normal: {
													borderWidth: 4,
													shadowColor: '#00FFCC',
													shadowBlur: 8
												},
											},
											lineStyle: {
												shadowColor: '#00FFCC',
												shadowBlur: 8
											},
										}
									}
									length_index++;
									series.push(seriesObj)
								}

							}
						}

						resultIndex++;
						if(series.length == result.length || series.length >= 3) {
							resolve({
								series: series
							})
							return;
						}
					}
				})
			},

			/*折线图 解决异步问题 调用产品物模型*/
			LineGetByDeviceCode(obj, result, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * result => 当前数据集历史记录对象(有多个)
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 * 该函数返回一个值
				 * series => 图表series
				 */
				let self = this;
				return new Promise(async(resolve) => {
					let series = [];

					/*没数据情况下*/
					if(JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
						resolve({
							series: []
						})
						return;
					}

					/*总配置*/
					let resultIndex = 0;
					for(let resultList of result) {
						let nameA = '';
						let nameB = '';
						let nameC = '';
						let featureList;
						let unit;
						if(obj.function == 'pass') {
							if(resultList.deviceCode.indexOf('_') == 0) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
								} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
								}
							} else {
								/*不为系统属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							}
						} else {
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
						}
						if(!unit) {
							unit = '';
						}
						let index = 0; //当前数据源的长度索引
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let valueDataC = []; //value[2]值

						/*数据处理 ...遍历折线图数量 ...*/
						for(let dataList of resultList.data) {
							let value_index = 0; //当前数据源中的value长度索引
							for(let value of dataList.value) {
								if(value_index == 0) {
									if(value == null) {
										valueDataA.push(self.randomData(unit, dataList.time, null))
									} else {
										valueDataA.push(self.randomData(unit, dataList.time, (value * ratio).toFixed(place)))
									}
								} else if(value_index == 1) {
									if(value == null) {
										valueDataB.push(self.randomData(unit, dataList.time, null))
									} else {
										valueDataB.push(self.randomData(unit, dataList.time, (value * ratio).toFixed(place)))
									}
								} else if(value_index == 2) {
									if(value == null) {
										valueDataC.push(self.randomData(unit, dataList.time, null))
									} else {
										valueDataC.push(self.randomData(unit, dataList.time, (value * ratio).toFixed(place)))
									}
								}
								value_index++;
							}

							index++;
							if(index == resultList.data.length) {
								/*一组数据源 需要显示的折线条数*/
								/*当前数据源最后一次循环时 将数据添加进图表中*/
								let length_index = 0; //当前数据源中的value长度索引
								for(let length of dataList.value) {
									let seriesObj = {}; //临时存储
									if(length_index == 0) {
										seriesObj = {
											propertyCode: nameA,
											name: nameA + Math.random() + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											code: resultList.deviceCode + '-' + resultList.propertyCode,
											type: 'line',
											symbolSize: 9,
											smooth: true,
											seriesLayoutBy: 'row',
											showSymbol: false,
											hoverAnimation: false,
											data: valueDataA
										}
									} else if(length_index == 1) {
										seriesObj = {
											propertyCode: nameB,
											name: nameB + Math.random() + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'line',
											symbolSize: 9,
											smooth: true,
											seriesLayoutBy: 'row',
											showSymbol: false,
											hoverAnimation: false,
											data: valueDataB
										}
									} else if(length_index == 2) {
										seriesObj = {
											propertyCode: nameC,
											name: nameC + Math.random() + '-&&-' + resultList.deviceCode + '&-&' + resultList.propertyCode,
											type: 'line',
											symbolSize: 9,
											smooth: true,
											seriesLayoutBy: 'row',
											showSymbol: false,
											hoverAnimation: false,
											data: valueDataC
										}
									}
									length_index++;
									series.push(seriesObj)
								}

							}
						}

						resultIndex++;
						if(resultIndex == result.length) {
							resolve({
								series: series
							})
						}
					}

				})
			},

			/*表格 解决异步问题 调用产品物模型*/
			TableGetByDeviceCode(obj, resultD, ratio, place) {
				/*
				 * obj => 当前数据集对象
				 * resultD => 当前数据集历史记录单个对象
				 * ratio => 当前数据集修正系数
				 * place => 当前数据集保留小数位数
				 */
				let self = this;
				return new Promise(async(resolve) => {
					let data = [];
					let attr = [];

					/*没数据的情况下*/
					if(JSON.stringify(resultD) == '[]' || JSON.stringify(resultD) == '{}') {
						resolve({
							attr: [],
							data: []
						})
						return;
					}

					let index = 0;
					for(let result of resultD) {
						let nameA = '';
						let nameB = '';
						let nameC = '';
						let code = result.deviceCode + '-' + result.propertyCode;
						let featureList;
						let unit;
						if(obj.function == 'pass') {
							if(result.deviceCode.indexOf('_') == 0) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(result.propertyCode.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(result.propertyCode.split('_alarm_category_')[1]);
								} else if(result.propertyCode.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(result.propertyCode.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == result.propertyCode)[0].name;
								}
							} else {
								/*不为系统属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(result.deviceCode, result.propertyCode);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							}
						} else {
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
						}
						if(!unit) {
							unit = '';
						}
						attr.push({
							nameA: nameA + '/*/' + code,
							nameB: nameB,
							nameC: nameC,
							unit: unit
						})

						/*如果是第一次进入 则在data创建新对象 如果是n次进入 则将值直接添加进已创建的data对象中*/
						if(index == 0) {
							for(let resultData of result.data) {
								let nameIndex = 0; //为了赋予函数后缀名而创建的索引
								let objOther = {};
								objOther.createdTime = resultData.time;
								for(let valueList of resultData.value) {
									if(nameIndex == 0) {
										if(valueList == null) {
											objOther[nameA + '/*/' + code] = null;
										} else {
											objOther[nameA + '/*/' + code] = (valueList * ratio).toFixed(place)
										}
									} else if(nameIndex == 1) {
										if(valueList == null) {
											objOther[nameB] = null
										} else {
											objOther[nameB] = (valueList * ratio).toFixed(place)
										}
									} else if(nameIndex == 2) {
										if(valueList == null) {
											objOther[nameC] = null
										} else {
											objOther[nameC] = (valueList * ratio).toFixed(place)
										}
									}
									nameIndex++;
								}
								data.push(objOther);
							}
						} else {
							for(let resultData of result.data) {
								for(let NowData of data) {
									if(NowData.createdTime == resultData.time) {
										let nameIndex = 0; //为了赋予函数后缀名而创建的索引
										for(let valueList of resultData.value) {
											if(nameIndex == 0) {
												if(valueList == null) {
													NowData[nameA + '/*/' + code] = null;
												} else {
													NowData[nameA + '/*/' + code] = (valueList * ratio).toFixed(place);
												}
											} else if(nameIndex == 1) {
												if(valueList == null) {
													NowData[nameB] = null;
												} else {
													NowData[nameB] = (valueList * ratio).toFixed(place);
												}
											} else if(nameIndex == 2) {
												if(valueList == null) {
													NowData[nameC] = null;
												} else {
													NowData[nameC] = (valueList * ratio).toFixed(place);
												}
											}
											nameIndex++;
										}
									}
								}
							}
						}

						index++;
						if(index == resultD.length) {
							resolve({
								attr: attr,
								data: data
							})
						}
					}
				})

			},

			/*格式化数据*/
			randomData(unit, now, value) {
				if(value == null) {
					value = [
						now,
						'-'
					]
				} else {
					value = [
						//时间戳转时间的string 格式 => "1998/1/13" ; getMonth() + 1是为了去掉开头部分
						now,
						//该时间下的值
						value
					]
				}
				now = this.common.timestampToTime(now);
				return {
					name: now,
					value: value,
					unit: unit,
				};
			},

			/*NewLine 格式化数据 (用于模板7的折线图 )*/
			randomDataNew(unit, now, value, v_real) {
				if(value == null) {
					value = [
						now,
						'-'
					]
				} else {
					value = [
						//时间戳转时间的string 格式 => "1998/1/13" ; getMonth() + 1是为了去掉开头部分
						now,
						//该时间下的值
						value
					]
				}
				now = this.common.timestampToTime(now);
				return {
					name: now,
					value: value,
					unit: unit,
					v_real: v_real==undefined?'-':v_real
				};
			},

			/*数字格式化
			 s => 值
			 n => 设置n个值时用逗号隔开
			 * */
			fmoney(s, n) {
				let minus = false; //判断是否为负数
				n = n > 0 && n <= 20 ? n : 2;
				if(Number(s) < 0) {
					minus = true
					s = Number(String(s).split('-')[1])
				}
				s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
				var l = s.split(".")[0].split("").reverse(),
					r = s.split(".")[1];
				var t = "";
				for(let i = 0; i < l.length; i++) {
					t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
				}
				if(minus) {
					return '-' + t.split("").reverse().join("") + "." + r;
				} else {
					return t.split("").reverse().join("") + "." + r;
				}
			},

			/*文本标签 模板中只显示一条数据*/
			initTableValue(obj) {
				/*
				 * 可以有多条数据源 但只显示一条数据(数据集历史数据中第一条数据源的第一条数据)
				 * 该方法需返回一个含有value的obj对象
					obj => 数据集对象 选中的数据集图表类型为文本标签
				 */
				return new Promise(resolve => {
					let self = this;
					if(obj.ratio || Number(obj.ratio) == 0) {
						var ratio = obj.ratio
					} else {
						var ratio = 1;
					}
					//保留小数
					if(obj.place) {
						var place = obj.place
					} else {
						var place = null;
					}

					/*获取数据集历史数据*/
					self.get('/Dataset/getReport', {
						id: obj.id, //数据集编号
						code: obj.type == 1 ? self.companyCode : obj.groupCode //分组或企业编码
					}).then(async (res) => {
						if(res.success == true) {
							if(res.result.length == 0 || res.result[0].data.length == 0) {
								resolve(obj);
								return;
							}

							let resultList = res.result[0]
							/*总配置*/
							let nameA = '';
							let featureList;
							let unit;
							let DeviceList;
							if(obj.function == 'pass') {
								if(resultList.deviceCode.indexOf('_') == 0) {
									/*判断数据集历史记录的单个对象是否为系统属性*/
									unit = '';
									if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
										nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
									} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
										nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
									} else {
										nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
									}
								} else {
									/*不为系统属性时*/
									if(obj.properties[0].type == 2){
										/*获取TSL 获取 数据属性名称*/
										featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
										unit = featureList.dataType.specs.unit
										nameA = featureList.name;
									}else if(obj.properties[0].type == 1){
										/*为产品属性时 只需要将该产品下的第一个设备展示(mqtt会推送该产品下的所有设备code 而不是产品code)*/
										DeviceList = await self.getDeviceListByProCode(obj.properties[0].code)
										//console.log(DeviceList)
										featureList = await self.getProductFeature(DeviceList[0].code, obj.properties[0].property);
										unit = featureList.dataType.specs.unit
										nameA = featureList.name;
									}
								}
							} else {
								unit = obj.unit;
								/*配置图例名称后缀*/
								if(obj.function == 'add') {
									//nameA = '-求和'
									nameA = ' ';
								} else if(obj.function == 'growth') {
									nameA = '增长量'
								} else if(obj.function == 'time') {
									//nameA = '-持续时长'
									nameA = ' ';
								} else if(obj.function == 'sample') {
									nameA = '最小值'
								}
							}
							if(!unit) {
								unit = '';
							}

							let value = res.result[0].data[0].value[0]
							if(value != null) {
								value = Number((value * ratio).toFixed(place))
							}
							obj.value = value;
							obj.unit = unit;
							resolve(obj)
						} else {
							resolve(obj)
						}
					})

				})
			},

			/*水球 mqtt数据更新*/
			async WaterUpdataCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象,
					type: 1, //当前图表类型,
					name: rightNine / rightTen 当前容器名称
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;
				let data = series[0].data;

				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				let resultList = result
				/*总配置*/
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;
				let unit;
				let errorDown,//属性值下下限
					errorUp,//属性值上上限
					warnDown,//属性值下限
					warnUp;//属性值上限
				if(obj.function == 'pass') {
					if(resultList.deviceCode.indexOf('_') == 0) {
						/*判断数据集历史记录的单个对象是否为系统属性*/
						unit = '';
						if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
							nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
						} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
							nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
						} else {
							nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
						}
					} else {
						/*不为系统属性时*/
						/*获取TSL 获取 数据属性名称*/
						featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
						unit = featureList.dataType.specs.unit
						nameA = featureList.name;
						errorDown = featureList.dataType.errorDown//属性值下下限
						errorUp = featureList.dataType.errorUp//属性值上上限
						warnDown = featureList.dataType.warnDown//属性值下限
						warnUp = featureList.dataType.warnUp//属性值上限

					}
				} else {
					unit = obj.unit;
					/*配置图例名称后缀*/
					if(obj.function == 'add') {
						//nameA = '-求和'
						nameA = ' ';
					} else if(obj.function == 'growth') {
						nameA = '增长量'
						nameB = '增长率'
					} else if(obj.function == 'time') {
						//nameA = '-持续时长'
						nameA = ' ';
					} else if(obj.function == 'sample') {
						nameA = '最小值'
						nameB = '最大值'
						nameC = '平均值'
					}
				}
				if(!unit) {
					unit = '';
				}
				let value;
				if(resultList.value.length == 0) {
					value = 0
				} else {
					value = Number((resultList.value[0] * ratio).toFixed(place));
				}

				var colorType = 1;
				if(warnDown != null && warnDown != undefined){
					if(value <= warnDown){
						colorType = 2
					}
				}
				if(warnUp != null && warnUp != undefined){
					if(value >= warnUp){
						colorType = 2
					}
				}
				if(errorDown != null && errorDown != undefined){
					if(value <= errorDown){
						colorType = 3
					}
				}
				if(errorUp != null && errorUp != undefined){
					if(value >= errorUp){
						colorType = 3
					}
				}

				self[DataSetObj.name] = {
					value: value,
					unit: unit,
					type: colorType
				}

				if(colorType == 1){
					/*正常 蓝色*/
					charts.setOption({
						graphic: {
							elements: [{
								style: {
									image: self.waterGreen,
								},
							}]
						},
						series: [{
							data: [{
								value: value <= 0 ? 0 : value >= 100 ? 1 : value / 100,
								itemStyle: {
									color: {
										colorStops: [{
											offset: 1,
											color: 'rgba(11, 186, 219, .1)',
										}, {
											offset: 0.5,
											color: 'rgba(11, 186, 219, .5)'
										}, {
											offset: 0,
											color: 'rgba(11, 186, 219, 1)',
										}]
									}
								}
							},{
								value: value <= 0 ? 0 : value >= 100 ? 1 : value / 100,
								itemStyle: {
									color: {
										colorStops: [{
											offset: 1,
											color: 'rgba(11, 186, 219, .1)',
										}, {
											offset: 0.5,
											color: 'rgba(11, 186, 219, .3)',
										}, {
											offset: 0,
											color: 'rgba(11, 186, 219, .3)',
										}]
									}
								}
							}],
							backgroundStyle: {
								borderColor: 'rgba(11, 186, 219, 1)',
								shadowColor: 'rgba(11, 186, 219, 1)',
							},
							outline: {
								itemStyle: {
									borderColor: 'rgba(11, 186, 219, 1)',
									shadowColor: 'rgba(11, 186, 219, 1)',
								}
							},
						}]
					})

				}else if(colorType == 2){
					/*超过 上限/下限 橙色*/
					charts.setOption({
						graphic: {
							elements: [{
								style: {
									image: self.waterRed,
								},
							}]
						},
						series: [{
							data: [{
								value: value <= 0 ? 0 : value >= 100 ? 1 : value / 100,
								itemStyle: {
									color: {
										colorStops: [{
											offset: 1,
											color: 'rgba(255, 102, 0, .1)',
										}, {
											offset: 0.5,
											color: 'rgba(255, 102, 0, .5)'
										}, {
											offset: 0,
											color: 'rgba(255, 102, 0, 1)',
										}]
									}
								}
							},{
								value: value <= 0 ? 0 : value >= 100 ? 1 : value / 100,
								itemStyle: {
									color: {
										colorStops: [{
											offset: 1,
											color: 'rgba(255, 102, 0, .1)',
										}, {
											offset: 0.5,
											color: 'rgba(255, 102, 0, .3)',
										}, {
											offset: 0,
											color: 'rgba(255, 102, 0, .3)',
										}]
									}
								}
							}],
							backgroundStyle: {
								borderColor: 'rgba(255, 102, 0, 1)',
								shadowColor: 'rgba(255, 102, 0, 1)',
							},
							outline: {
								itemStyle: {
									borderColor: 'rgba(255, 102, 0, 1)',
									shadowColor: 'rgba(255, 102, 0, 1)',
								}
							},
						}]
					})
				}else if(colorType == 3){
					/*超过 上上限/下下限 红色*/
					charts.setOption({
						graphic: {
							elements: [{
								style: {
									image: self.waterRed,
								},
							}]
						},
						series: [{
							data: [{
								value: value <= 0 ? 0 : value >= 100 ? 1 : value / 100,
								itemStyle: {
									color: {
										colorStops: [{
											offset: 1,
											color: 'rgba(183, 15, 76, .1)',
										}, {
											offset: 0.5,
											color: 'rgba(183, 15, 76, .5)',
										}, {
											offset: 0,
											color: 'rgba(183, 15, 76, 1)',
										}]
									}
								}
							},{
								value: value <= 0 ? 0 : value >= 100 ? 1 : value / 100,
								itemStyle: {
									color: {
										colorStops: [{
											offset: 1,
											color: 'rgba(183, 15, 76, .1)',
										}, {
											offset: 0.5,
											color: 'rgba(183, 15, 76, .3)',
										}, {
											offset: 0,
											color: 'rgba(183, 15, 76, .3)',
										}]
									}
								}
							}],
							backgroundStyle: {
								borderColor: 'rgba(183, 15, 76, 1)',
								shadowColor: 'rgba(183, 15, 76, 1)',
							},
							outline: {
								itemStyle: {
									borderColor: 'rgba(183, 15, 76, 1)',
									shadowColor: 'rgba(183, 15, 76, 1)'
								}
							},
						}]
					})
				}

			},

			/*仪表盘 mqtt数据更新*/
			async LastGaugeUpdataCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象,
					type: 1, //当前图表类型,
					name: rightSeven / rightEight 当前容器名称
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;
				let data = series[0].data;

				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				let resultList = result
				/*总配置*/
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;
				let unit;
				let errorDown,//属性值下下限
					errorUp,//属性值上上限
					warnDown,//属性值下限
					warnUp;//属性值上限
				if(obj.function == 'pass') {
					if(resultList.deviceCode.indexOf('_') == 0) {
						/*判断数据集历史记录的单个对象是否为系统属性*/
						unit = '';
						if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
							nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
						} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
							nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
						} else {
							nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
						}
					} else {
						/*不为系统属性时*/
						/*获取TSL 获取 数据属性名称*/
						featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
						unit = featureList.dataType.specs.unit
						nameA = featureList.name;
						errorDown = featureList.dataType.errorDown//属性值下下限
						errorUp = featureList.dataType.errorUp//属性值上上限
						warnDown = featureList.dataType.warnDown//属性值下限
						warnUp = featureList.dataType.warnUp//属性值上限
					}
				} else {
					unit = obj.unit;
					/*配置图例名称后缀*/
					if(obj.function == 'add') {
						//nameA = '-求和'
						nameA = ' ';
					} else if(obj.function == 'growth') {
						nameA = '增长量'
						nameB = '增长率'
					} else if(obj.function == 'time') {
						//nameA = '-持续时长'
						nameA = ' ';
					} else if(obj.function == 'sample') {
						nameA = '最小值'
						nameB = '最大值'
						nameC = '平均值'
					}
				}
				if(!unit) {
					unit = '';
				}
				let value;
				if(resultList.value.length == 0) {
					value = 0
				} else {
					value = Number((resultList.value[0] * ratio).toFixed(place));
				}
				var colorType = 1;
				if(warnDown != null && warnDown != undefined){
					if(value <= warnDown){
						colorType = 2
					}
				}
				if(warnUp != null && warnUp != undefined){
					if(value >= warnUp){
						colorType = 2
					}
				}
				if(errorDown != null && errorDown != undefined){
					if(value <= errorDown){
						colorType = 3
					}
				}
				if(errorUp != null && errorUp != undefined){
					if(value >= errorUp){
						colorType = 3
					}
				}

				self[DataSetObj.name] = {
					value: value,
					unit: unit,
					type: colorType
				}
				charts.setOption({
					series: [{
						data: [{
							value: colorType == 0 ? 0 : (colorType == 1 ? 25 : (colorType == 2 ? 65 : 95))
						}]
					}]
				})
			},

			/*仪表盘 mqtt数据更新*/
			async GaugeUpdataCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象,
					type: 1, //当前图表类型
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;
				let data = series[0].data;

				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				let resultList = result
				/*总配置*/
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;
				let unit;
				if(obj.function == 'pass') {
					if(resultList.deviceCode.indexOf('_') == 0) {
						/*判断数据集历史记录的单个对象是否为系统属性*/
						unit = '';
						if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
							nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
						} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
							nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
						} else {
							nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
						}
					} else {
						/*不为系统属性时*/
						/*获取TSL 获取 数据属性名称*/
						featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
						unit = featureList.dataType.specs.unit
						nameA = featureList.name;
					}
				} else {
					unit = obj.unit;
					/*配置图例名称后缀*/
					if(obj.function == 'add') {
						//nameA = '-求和'
						nameA = ' ';
					} else if(obj.function == 'growth') {
						nameA = '增长量'
						nameB = '增长率'
					} else if(obj.function == 'time') {
						//nameA = '-持续时长'
						nameA = ' ';
					} else if(obj.function == 'sample') {
						nameA = '最小值'
						nameB = '最大值'
						nameC = '平均值'
					}
				}
				if(!unit) {
					unit = '';
				}
				let value;
				if(resultList.value.length == 0) {
					value = 0
				} else {
					value = Number((resultList.value[0] * ratio).toFixed(place));
				}

				if(value > 100) {
					value = 100
				} else if(value < 0) {
					value = 0
				}

				self.rightSix = {
					value: value,
					unit: unit
				}
				charts.setOption({
					series: [{
						data: [{
							value: value
						}]
					}]
				})
			},

			/*饼图 mqtt数据更新*/
			async PieUpdateCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;
				let data = series[0].data;
				let Newdata = series[0].data ? series[0].data : [];

				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}
				let unit;
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;

				if(Newdata.filter(item => item.deviceCode == result.deviceCode && item.attrCode == result.propertyCode).length == 0) {
					/*第一次创建 将所有属性全部显示*/
					for(let properties of obj.properties) {
						if(obj.function == 'pass') {
							/*透传*/
							/* 多个seriesObj对象 value只有一个
							 * 查找当前已实例化的图表series中是否有创建过该数据集*/
							if(properties.type == 3) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(properties.code.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(properties.code.split('_alarm_category_')[1]);
								} else if(properties.code.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(properties.code.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == properties.property)[0].name;
								}
							} else if(properties.type == 2) {
								/*不为系统属性时 为设备属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(properties.code, properties.property);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							}

							/*push进series*/
							if(properties.type == 1) {
								/*为产品属性时 需要将该产品下的所有设备都push进series(mqtt会推送该产品下的所有设备code 而不是产品code)*/
								let DeviceList = await self.getDeviceListByProCode(properties.code)
								//console.log(DeviceList)
								for(let device of DeviceList) {
									featureList = await self.getProductFeature(device.code, properties.property);
									unit = featureList.dataType.specs.unit
									nameA = featureList.name;
									if(!unit) {
										unit = '';
									}
									let seriesObj = {}; //临时存储
									if(result.deviceCode == device.code && result.propertyCode == properties.property) {
										seriesObj = {
											name: nameA + '/' + Math.random(),
											showName: nameA,
											deviceCode: device.code,
											attrCode: properties.property,
											propertyCode: nameA,
											unit: unit,
											value: Number((result.value[0] * ratio).toFixed(place))
										}
									} else {
										seriesObj = {
											name: nameA + '/' + Math.random(),
											showName: nameA,
											deviceCode: device.code,
											attrCode: properties.property,
											propertyCode: nameA,
											unit: unit,
											value: 0
										}
									}
									Newdata.push(seriesObj)
								}
							} else {
								/*不为产品属性时 直接在series中push一次*/
								if(!unit) {
									unit = '';
								}
								let seriesObj = {}; //临时存储
								if(result.deviceCode == properties.code && result.propertyCode == properties.property) {
									seriesObj = {
										name: nameA + '/' + Math.random(),
										showName: nameA,
										deviceCode: properties.code,
										attrCode: properties.property,
										propertyCode: nameA,
										unit: unit,
										value: Number((result.value[0] * ratio).toFixed(place))
									}
								} else {
									seriesObj = {
										name: nameA + '/' + Math.random(),
										showName: nameA,
										deviceCode: properties.code,
										attrCode: properties.property,
										propertyCode: nameA,
										unit: unit,
										value: 0
									}
								}
								Newdata.push(seriesObj)
							}
						}
					}

					/*不是透传的情况下 mqtt推送的result.deviceCode和result.propertyCode是无意义的 无需处理*/
					if(obj.function != 'pass') {
						/*不是透传*/
						/* 最多只有三个seriesObj对象 value最多三个 */
						unit = obj.unit;
						/*配置图例名称后缀*/
						if(obj.function == 'add') {
							//nameA = '-求和'
							nameA = ' ';
						} else if(obj.function == 'growth') {
							nameA = '增长量'
							nameB = '增长率'
						} else if(obj.function == 'time') {
							//nameA = '-持续时长'
							nameA = ' ';
						} else if(obj.function == 'sample') {
							nameA = '最小值'
							nameB = '最大值'
							nameC = '平均值'
						}

						if(!unit) {
							unit = '';
						}
						/*将当前mqtt推送数据的value值作为饼图的值*/
						let indexForI = 0;
						for(let i of result.value) {
							let name;
							if(indexForI == 0) {
								name = nameA;
							} else if(indexForI == 1) {
								name = nameB;
							} else if(indexForI == 2) {
								name = nameC;
							}
							Newdata.push({
								name: name + '/' + Math.random(),
								showName: name,
								deviceCode: result.deviceCode,
								attrCode: result.propertyCode,
								propertyCode: name,
								unit: unit,
								value: Number((i * ratio).toFixed(place))
							})
							indexForI++;
						}
					}
				} else {
					/*已经创建过所有属性 直接替换*/
					if(obj.function == 'pass') {
						/*数据集为透传的情况下 当饼图中已有相应的数据时 只需要改动当前传入的数据的值*/
						for(let properties of Newdata) {
							if(properties.deviceCode == result.deviceCode && properties.attrCode == result.propertyCode) {
								properties.value = Number((result.value[0] * ratio).toFixed(place))
							}
						}
					} else {
						/*不为透传的情况下 通过name来替换当前数据*/
						unit = obj.unit;
						/*配置图例名称后缀*/
						if(obj.function == 'add') {
							//nameA = '-求和'
							nameA = ' ';
						} else if(obj.function == 'growth') {
							nameA = '增长量'
							nameB = '增长率'
						} else if(obj.function == 'time') {
							//nameA = '-持续时长'
							nameA = ' ';
						} else if(obj.function == 'sample') {
							nameA = '最小值'
							nameB = '最大值'
							nameC = '平均值'
						}
						let indexForI = 0
						for(let i of result.value) {
							let name;
							if(indexForI == 0) {
								name = nameA;
							} else if(indexForI == 1) {
								name = nameB;
							} else if(indexForI == 2) {
								name = nameC;
							}
							for(let properties of Newdata) {
								if(properties.showName == name) {
									properties.value = Number((i * ratio).toFixed(place))
								}
							}
							indexForI++
						}
					}
				}
				data = data ? data : [];
				let NewdataValue = [];
				let dataValue = [];
				for(let o of Newdata) {
					NewdataValue.push(o.value)
				}
				for(let p of data) {
					dataValue.push(p.value)
				}
				if(series.length == 2) {
					charts.setOption({
						series: [{
							data: Newdata
						}, {
							data: Newdata
						}]
					})
				} else {
					charts.setOption({
						series: [{
							data: Newdata
						}]
					})
				}

			},

			/*柱状图 mqtt数据更新*/
			async BarUpdateCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;
				let categoryData;
				if(!option.xAxis[0].data) {
					categoryData = [];
				} else {
					categoryData = option.xAxis[0].data;
				}
				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				let date = new Date(result.time)
				let realDate = self.$echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', date);
				if(categoryData.filter(item => item == realDate).length == 0) {
					categoryData.push(realDate)
					if(categoryData.length > self.ChartsDataLength) {
						categoryData.splice(0, 1);
					}
				}

				let unit;
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;

				if(obj.function == 'pass') {
					/* 多个seriesObj对象 value只有一个
					 * 查找当前已实例化的图表series中是否有创建过该数据集*/
					if(series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode).length == 0) {
						/*没创建过情况下*/
						if(result.deviceCode.indexOf('_') == 0) {
							/*判断数据集历史记录的单个对象是否为系统属性*/
							unit = '';
							if(result.propertyCode.indexOf('_alarm_category_') != -1) {
								nameA = await self.getDictById(result.propertyCode.split('_alarm_category_')[1]);
							} else if(result.propertyCode.indexOf('_device_product_') != -1) {
								nameA = await self.getProductByCode(result.propertyCode.split('_device_product_')[1]);
							} else {
								nameA = self.system_options.filter(item => item.id == result.propertyCode)[0].name;
							}
						} else {
							/*不为系统属性时*/
							/*获取TSL 获取 数据属性名称*/
							featureList = await self.getProductFeature(result.deviceCode, result.propertyCode);
							unit = featureList.dataType.specs.unit
							nameA = featureList.name;
						}
						if(!unit) {
							unit = '';
						}
						let valueDataA = []; //value[0]值
						if(result.value[0] == null) {
							valueDataA.push('-')
						} else {
							valueDataA.push(Number((result.value[0] * ratio).toFixed(place)))
						}
						/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
						if(valueDataA.length != categoryData.length) {
							let leng = categoryData.length - valueDataA.length;
							for(let le = 0; le < leng; le++) {
								valueDataA.unshift('-')
							}
						}
						let seriesObj = {}; //临时存储
						seriesObj = {
							propertyCode: nameA,
							code: result.deviceCode + '-' + result.propertyCode,
							name: nameA + Math.random() + '-' + unit + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
							type: 'bar',
							data: valueDataA,
							barGap: '35%',
							large: true,
						}
						series.push(seriesObj)
					} else {
						/*创建过情况下*/
						let value = [];
						if(result.value[0] == null) {
							value.push('-')
						} else {
							value.push(Number((result.value[0] * ratio).toFixed(place)))
						}
						let ng = series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.length;
						ng = ng + value.length;
						/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
						if(ng != categoryData.length) {
							let leng = categoryData.length - ng;
							for(let le = 0; le < leng; le++) {
								value.unshift('-')
							}
						}
						series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data = series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.concat(value);
						if(series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.length > self.ChartsDataLength) {
							series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.splice(0, 1);
						}
					}
				} else {
					/* 最多只有三个seriesObj对象 value最多三个
					 * 查找当前已实例化的图表series中是否有创建过该数据集*/
					unit = obj.unit;
					/*配置图例名称后缀*/
					if(obj.function == 'add') {
						//nameA = '-求和'
						nameA = ' ';
					} else if(obj.function == 'growth') {
						nameA = '增长量'
						nameB = '增长率'
					} else if(obj.function == 'time') {
						//nameA = '-持续时长'
						nameA = ' ';
					} else if(obj.function == 'sample') {
						nameA = '最小值'
						nameB = '最大值'
						nameC = '平均值'
					}
					if(!unit) {
						unit = '';
					}
					if(series.length == 0) {
						/*没创建过情况下*/
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let valueDataC = []; //value[2]值
						let value_index = 0; //当前数据源中的value长度索引
						for(let value of result.value) {
							if(value_index == 0) {
								if(value == null) {
									valueDataA.push('-')
								} else {
									valueDataA.push(Number((value * ratio).toFixed(place)))
								}
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(valueDataA.length != categoryData.length) {
									let leng = categoryData.length - valueDataA.length;
									for(let le = 0; le < leng; le++) {
										valueDataA.unshift('-')
									}
								}
							} else if(value_index == 1) {
								if(value == null) {
									valueDataB.push('-')
								} else {
									valueDataB.push(Number((value * ratio).toFixed(place)))
								}
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(valueDataB.length != categoryData.length) {
									let leng = categoryData.length - valueDataB.length;
									for(let le = 0; le < leng; le++) {
										valueDataB.unshift('-')
									}
								}
							} else if(value_index == 2) {
								if(value == null) {
									valueDataC.push('-')
								} else {
									valueDataC.push(Number((value * ratio).toFixed(place)))
								}
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(valueDataC.length != categoryData.length) {
									let leng = categoryData.length - valueDataC.length;
									for(let le = 0; le < leng; le++) {
										valueDataC.unshift('-')
									}
								}
							}
							value_index++;
						}
						/*一组数据源 需要显示的柱状条数*/

						let length_index = 0; //当前数据源中的value长度索引
						for(let length of result.value) {
							let seriesObj = {}; //临时存储
							if(length_index == 0) {
								seriesObj = {
									propertyCode: nameA,
									code: result.deviceCode + '-' + result.propertyCode,
									name: nameA + Math.random() + '-' + unit + '-&&-' + result.deviceCode + '&-&' + result.propertyCode + 'dataSetUnit=' + unit,
									type: 'bar',
									data: valueDataA,
									barGap: '35%',
									large: true,
								}
							} else if(length_index == 1) {
								seriesObj = {
									propertyCode: nameB,
									name: nameB + Math.random() + '-' + unit + '-&&-' + result.deviceCode + '&-&' + result.propertyCode + 'dataSetUnit=' + unit,
									type: 'bar',
									data: valueDataB,
									barGap: '35%',
									large: true,
								}
							} else if(length_index == 2) {
								seriesObj = {
									propertyCode: nameC,
									name: nameC + Math.random() + '-' + unit + '-&&-' + result.deviceCode + '&-&' + result.propertyCode + 'dataSetUnit=' + unit,
									type: 'bar',
									data: valueDataC,
									barGap: '35%',
									large: true,
								}
							}
							length_index++;
							series.push(seriesObj)
						}
					} else {
						/*创建过情况下*/
						let length_index = 0; //当前数据源中的value长度索引
						for(let value of result.value) {
							if(length_index == 0) {
								let val = [];
								if(value == null) {
									val.push('-')
								} else {
									val.push(Number((value * ratio).toFixed(place)))
								}
								let ng = series.filter(item => item.propertyCode == nameA)[0].data.length;
								ng = ng + val.length;
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(ng != categoryData.length) {
									let leng = categoryData.length - ng;
									for(let le = 0; le < leng; le++) {
										val.unshift('-')
									}
								}
								series.filter(item => item.propertyCode == nameA)[0].data = series.filter(item => item.propertyCode == nameA)[0].data.concat(val);
								if(series.filter(item => item.propertyCode == nameA)[0].data.length > self.ChartsDataLength) {
									series.filter(item => item.propertyCode == nameA)[0].data.splice(0, 1);
								}
							} else if(length_index == 1) {
								let val = [];
								if(value == null) {
									val.push('-')
								} else {
									val.push(Number((value * ratio).toFixed(place)))
								}
								let ng = series.filter(item => item.propertyCode == nameB)[0].data.length;
								ng = ng + val.length;
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(ng != categoryData.length) {
									let leng = categoryData.length - ng;
									for(let le = 0; le < leng; le++) {
										val.unshift('-')
									}
								}
								series.filter(item => item.propertyCode == nameB)[0].data = series.filter(item => item.propertyCode == nameB)[0].data.concat(val);
								if(series.filter(item => item.propertyCode == nameB)[0].data.length > self.ChartsDataLength) {
									series.filter(item => item.propertyCode == nameB)[0].data.splice(0, 1);
								}
							} else if(length_index == 2) {
								let val = [];
								if(value == null) {
									val.push('-')
								} else {
									val.push(Number((value * ratio).toFixed(place)))
								}
								let ng = series.filter(item => item.propertyCode == nameC)[0].data.length;
								ng = ng + val.length;
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(ng != categoryData.length) {
									let leng = categoryData.length - ng;
									for(let le = 0; le < leng; le++) {
										val.unshift('-')
									}
								}
								series.filter(item => item.propertyCode == nameC)[0].data = series.filter(item => item.propertyCode == nameC)[0].data.concat(val);
								if(series.filter(item => item.propertyCode == nameC)[0].data.length > self.ChartsDataLength) {
									series.filter(item => item.propertyCode == nameC)[0].data.splice(0, 1);
								}
							}
							length_index++;
						}
					}
				}
				charts.setOption({
					xAxis: {
						data: categoryData,
					},
					series: series
				})
			},

			/*用于计算当前时间位于当前data的哪个位置 返回一个位置数字*/
			pushNum(data, time) {
				let i = 0;
				for(let a of data) {
					if(a.value[0] < time) {
						i++
					}
				}
				return i
			},

			/*模板7 柱状图mqtt推送*/
			async NewBarUpdateCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;
				let categoryData;
				if(!option.xAxis[0].data) {
					categoryData = [];
				} else {
					categoryData = option.xAxis[0].data;
				}
				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				let date = new Date(result.time)
				let realDate = self.$echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', date);
				if(categoryData.filter(item => item == realDate).length == 0) {
					categoryData.push(realDate)
					if(categoryData.length > self.NewChartsDataLength) {
						categoryData.splice(0, 1);
					}
				}

				let unit;
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;

				if(obj.function == 'pass') {
					/* 多个seriesObj对象 value只有一个
					 * 查找当前已实例化的图表series中是否有创建过该数据集*/
					if((series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode).length == 0) && series.length < 3) {
						/*没创建过情况下*/
						if(result.deviceCode.indexOf('_') == 0) {
							/*判断数据集历史记录的单个对象是否为系统属性*/
							unit = '';
							if(result.propertyCode.indexOf('_alarm_category_') != -1) {
								nameA = await self.getDictById(result.propertyCode.split('_alarm_category_')[1]);
							} else if(result.propertyCode.indexOf('_device_product_') != -1) {
								nameA = await self.getProductByCode(result.propertyCode.split('_device_product_')[1]);
							} else {
								nameA = self.system_options.filter(item => item.id == result.propertyCode)[0].name;
							}
						} else {
							/*不为系统属性时*/
							/*获取TSL 获取 数据属性名称*/
							featureList = await self.getProductFeature(result.deviceCode, result.propertyCode);
							unit = featureList.dataType.specs.unit
							nameA = featureList.name;
						}
						if(!unit) {
							unit = '';
						}
						let valueDataA = []; //value[0]值
						if(result.value[0] == null) {
							valueDataA.push('-')
						} else {
							valueDataA.push(Number((result.value[0] * ratio).toFixed(place)))
						}
						/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
						if(valueDataA.length != categoryData.length) {
							let leng = categoryData.length - valueDataA.length;
							for(let le = 0; le < leng; le++) {
								valueDataA.unshift('-')
							}
						}
						let seriesObj = {}; //临时存储
						seriesObj = {
							propertyCode: nameA,
							code: result.deviceCode + '-' + result.propertyCode,
							name: nameA + Math.random() + '-' + unit + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
							type: 'bar',
							data: valueDataA,
							barGap: '35%',
							large: true,
							barWidth: 4,
						}
						series.push(seriesObj)
					} else {
						/*创建过情况下*/
						let value = [];
						if(result.value[0] == null) {
							value.push('-')
						} else {
							value.push(Number((result.value[0] * ratio).toFixed(place)))
						}
						let ng = series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.length;
						ng = ng + value.length;
						/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
						if(ng != categoryData.length) {
							let leng = categoryData.length - ng;
							for(let le = 0; le < leng; le++) {
								//复制上一个值
								value.unshift(series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data[series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.length-1])
							}
						}
						series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data = series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.concat(value);
						if(series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.length > self.NewChartsDataLength) {
							series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode)[0].data.splice(0, 1);
						}
					}
				} else {
					/* 最多只有三个seriesObj对象 value最多三个
					 * 查找当前已实例化的图表series中是否有创建过该数据集*/
					unit = obj.unit;
					/*配置图例名称后缀*/
					if(obj.function == 'add') {
						//nameA = '-求和'
						nameA = ' ';
					} else if(obj.function == 'growth') {
						nameA = '增长量'
						nameB = '增长率'
					} else if(obj.function == 'time') {
						//nameA = '-持续时长'
						nameA = ' ';
					} else if(obj.function == 'sample') {
						nameA = '最小值'
						nameB = '最大值'
						nameC = '平均值'
					}
					if(!unit) {
						unit = '';
					}
					if(series.length == 0) {
						/*没创建过情况下*/
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let value_index = 0; //当前数据源中的value长度索引
						for(let value of result.value) {
							if(value_index == 0) {
								if(value == null) {
									valueDataA.push('-')
								} else {
									valueDataA.push(Number((value * ratio).toFixed(place)))
								}
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(valueDataA.length != categoryData.length) {
									let leng = categoryData.length - valueDataA.length;
									for(let le = 0; le < leng; le++) {
										valueDataA.unshift('-')
									}
								}
							} else if(value_index == 1) {
								if(value == null) {
									valueDataB.push('-')
								} else {
									valueDataB.push(Number((value * ratio).toFixed(place)))
								}
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(valueDataB.length != categoryData.length) {
									let leng = categoryData.length - valueDataB.length;
									for(let le = 0; le < leng; le++) {
										valueDataB.unshift('-')
									}
								}
							}
							value_index++;
						}
						/*一组数据源 需要显示的柱状条数*/

						let length_index = 0; //当前数据源中的value长度索引
						for(let length of result.value) {
							let seriesObj = {}; //临时存储
							if(length_index == 0) {
								seriesObj = {
									propertyCode: nameA,
									code: result.deviceCode + '-' + result.propertyCode,
									name: nameA + Math.random() + '-' + unit + '-&&-' + result.deviceCode + '&-&' + result.propertyCode + 'dataSetUnit=' + unit,
									type: 'bar',
									data: valueDataA,
									barGap: '35%',
									large: true,
									barWidth: 4,
								}
							} else if(length_index == 1) {
								seriesObj = {
									propertyCode: nameB,
									name: nameB + Math.random() + '-' + unit + '-&&-' + result.deviceCode + '&-&' + result.propertyCode + 'dataSetUnit=' + unit,
									type: 'bar',
									data: valueDataB,
									barGap: '35%',
									large: true,
									barWidth: 4,
								}
							}
							length_index++;
							if(series.length < 2) {
								series.push(seriesObj)
							}

						}
					} else {
						/*创建过情况下*/
						let length_index = 0; //当前数据源中的value长度索引
						for(let value of result.value) {
							if(length_index == 0) {
								let val = [];
								if(value == null) {
									val.push('-')
								} else {
									val.push(Number((value * ratio).toFixed(place)))
								}
								let ng = series.filter(item => item.propertyCode == nameA)[0].data.length;
								ng = ng + val.length;
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(ng != categoryData.length) {
									let leng = categoryData.length - ng;
									for(let le = 0; le < leng; le++) {
										val.unshift('-')
									}
								}
								series.filter(item => item.propertyCode == nameA)[0].data = series.filter(item => item.propertyCode == nameA)[0].data.concat(val);
								if(series.filter(item => item.propertyCode == nameA)[0].data.length > self.NewChartsDataLength) {
									series.filter(item => item.propertyCode == nameA)[0].data.splice(0, 1);
								}
							} else if(length_index == 1) {
								let val = [];
								if(value == null) {
									val.push('-')
								} else {
									val.push(Number((value * ratio).toFixed(place)))
								}
								let ng = series.filter(item => item.propertyCode == nameB)[0].data.length;
								ng = ng + val.length;
								/*用于处理第一次创建该对象时 前面值未导入数组导致时间对应的值错乱*/
								if(ng != categoryData.length) {
									let leng = categoryData.length - ng;
									for(let le = 0; le < leng; le++) {
										val.unshift('-')
									}
								}
								series.filter(item => item.propertyCode == nameB)[0].data = series.filter(item => item.propertyCode == nameB)[0].data.concat(val);
								if(series.filter(item => item.propertyCode == nameB)[0].data.length > self.NewChartsDataLength) {
									series.filter(item => item.propertyCode == nameB)[0].data.splice(0, 1);
								}
							}
							length_index++;
						}
					}
				}
				charts.setOption({
					xAxis: {
						data: categoryData,
					},
					series: series
				})
			},

			upFixed (num, fix) {
			  // num为原数字，fix是保留的小数位数
			  let result = '0'
			  if (Number(num) && fix > 0) { // 简单的做个判断
			    fix = +fix || 2
			    num = num + ''
			    if (/e/.test(num)) { // 如果是包含e字符的数字直接返回
			      result = num
			    } else if (!/\./.test(num)) { // 如果没有小数点
			      result = num + `.${Array(fix + 1).join('0')}`
			    } else { // 如果有小数点
			      num = num + `${Array(fix + 1).join('0')}`
			      let reg = new RegExp(`-?\\d*\\.\\d{0,${fix}}`)
			      let floorStr = reg.exec(num)[0]
			      if (+floorStr >= +num) {
			        result = floorStr
			      } else {
			        let floorNumber = +floorStr + +`0.${Array(fix).join('0')}1`
			        let point = /\./.test(floorNumber + '') ? '' : '.'
			        let floorStr2 = floorNumber + point + `${Array(fix + 1).join('0')}`
			        result = reg.exec(floorStr2)[0]
			      }
			    }
			  }
			  return result
			},

			downFixed (num, fix) {
			  // num为原数字，fix是保留的小数位数
			  let result = '0'
			  if (Number(num) && fix > 0) { // 简单的做个判断
			    fix = +fix || 2
			    num = num + ''
			    if (/e/.test(num)) { // 如果是包含e字符的数字直接返回
			      result = num
			    } else if (!/\./.test(num)) { // 如果没有小数点
			      result = num + `.${Array(fix + 1).join('0')}`
			    } else { // 如果有小数点
			      num = num + `${Array(fix + 1).join('0')}`
			      let reg = new RegExp(`-?\\d*.\\d{0,${fix}}`)
			      result = reg.exec(num)[0]
			    }
			  }
			  return result
			},

			/*折线图 mqtt数据更新*/
			async NewLineUpdateCharts(DataSetObj, result) {
				/*保留最近60s的时间 从右往左推 右边是当前时间 左边是60s的时间 以推过来的最新时间为0  计算之前的时间 如果最新时间 - 之前的时间 超出了60秒 则删除*/
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;

				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				for(let reVal of result.value){
					reVal = (reVal * ratio).toFixed(place);
				}

				let realData = JSON.parse(JSON.stringify(result))
				/*将mqtt推送数据 push进真实数据数组里*/
				if((this.v_real.length == 0) || (this.v_real.filter(item => (item.deviceCode == realData.deviceCode) && (item.propertyCode == realData.propertyCode)).length == 0)){
					let v_obj = {
						deviceCode: realData.deviceCode,
						propertyCode: realData.propertyCode,
						data: [{
							time: realData.time,
							value: realData.value
						}]
					}
					this.v_real.push(JSON.parse(JSON.stringify(v_obj)))
				}else{
					for(let v of this.v_real){
						if((v.deviceCode == realData.deviceCode) && (v.propertyCode == realData.propertyCode)){
							v.data.push({
								time: realData.time,
								value: realData.value
							})
							/*if(v.data.length > 8){
								v.data.splice(0, 1);
							}*/
						}
					}
				}


				/*按比例显示*/
				var DeviceListTest;
				if((obj.properties.length != 0) && (obj.properties.filter(aa => aa.type == 1).length != 0)){
					DeviceListTest = await self.getDeviceListByProCode(obj.properties.code)
				}

				if((obj.properties.length == 1) && ((obj.properties[0].type == 2 || 3) || (DeviceListTest&&DeviceListTest.length==1))){
					/*当只有一个属性的时候 显示实际值*/
					self.NewLineByOneAttr = true;
				}else{
					self.NewLineByOneAttr = false;
					/*当有一个以上的值时 显示百分比*/
					let reValIndex = 0;
					for(let a = 0; a < result.value.length; a++){
						if(result.value[a] != null){
							let numObj = this.getNumNew(this.v_real.filter(item => item.deviceCode==result.deviceCode&&item.propertyCode==result.propertyCode)[0].data,reValIndex)
							if(result.value[a] == numObj.max){
								result.value[a] = 100
							}else if(result.value[a] == numObj.min){
								result.value[a] = 0
							}else if(numObj.max == numObj.min){
								result.value[a] = 100
							}else{
								result.value[a] = Math.round(((result.value[a] - numObj.min) / (numObj.max - numObj.min)) * 100)
							}
						}
						reValIndex++
					}
				}

//				console.log(result.value,realData.value)
				let unit;
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;

				/*新逻辑*/
				if((series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode).length == 0) && series.length < 3) {
					//console.log(DataSetObj.obj,series)
					/*第一次创建 将所有属性全部显示*/
					let propertiesIndex = 0
					for(let properties of obj.properties) {
						if(propertiesIndex < 3) {
							if(obj.function == 'pass') {
								/*透传*/
								/* 多个seriesObj对象 value只有一个
								 * 查找当前已实例化的图表series中是否有创建过该数据集*/
								if(properties.type == 3) {
									/*判断数据集历史记录的单个对象是否为系统属性*/
									unit = '';
									if(properties.code.indexOf('_alarm_category_') != -1) {
										nameA = await self.getDictById(properties.code.split('_alarm_category_')[1]);
									} else if(properties.code.indexOf('_device_product_') != -1) {
										nameA = await self.getProductByCode(properties.code.split('_device_product_')[1]);
									} else {
										nameA = self.system_options.filter(item => item.id == properties.property)[0].name;
									}
								} else if(properties.type == 2) {
									/*不为系统属性时 为设备属性时*/
									/*获取TSL 获取 数据属性名称*/
									featureList = await self.getProductFeature(properties.code, properties.property);
									unit = featureList.dataType.specs.unit
									nameA = featureList.name;
								} else if(properties.type == 1) {
									/*不为系统属性时 为产品属性时*/
									/*获取TSL 获取 数据属性名称*/
									/*featureList = await self.getProductFeatureByCP(properties.code, properties.property);
									unit = featureList.dataType.specs.unit
									nameA = featureList.name;*/
								}

								/*push进series*/
								if(properties.type == 1) {
									/*为产品属性时 需要将该产品下的所有设备都push进series(mqtt会推送该产品下的所有设备code 而不是产品code)*/
									let DeviceList = await self.getDeviceListByProCode(properties.code)
									//console.log(DeviceList)
									for(let device of DeviceList) {
										featureList = await self.getProductFeature(device.code, properties.property);
										unit = featureList.dataType.specs.unit
										nameA = featureList.name;
										if(!unit) {
											unit = '';
										}
										let valueDataA = []; //value[0]值
										if(result.deviceCode == device.code && result.propertyCode == properties.property) {
											if(result.value[0] == null) {
												valueDataA.push(self.randomDataNew(unit, result.time, null))
											} else {
												valueDataA.push(self.randomDataNew(unit, result.time, result.value[0], realData.value[0]))
											}
										} else {
											valueDataA.push(self.randomDataNew(unit, result.time, null))
										}

										let seriesObj = {}; //临时存储
										seriesObj = {
											propertyCode: nameA,
											unit: unit,
											code: device.code + '-' + properties.property,
											name: nameA + Math.random() + '-&&-' + device.code + '&-&' + properties.property,
											type: 'line',
											symbolSize: 9,
											smooth: true,
											seriesLayoutBy: 'row',
											showSymbol: false,
											hoverAnimation: false,
											data: valueDataA,
											itemStyle: {
												normal: {
													borderWidth: 4,
													shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
													shadowBlur: 8
												},
											},
											lineStyle: {
												shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
												shadowBlur: 8
											},
										}
										series.push(seriesObj)
									}
								} else {
									/*不为产品属性时 直接在series中push一次*/
									if(!unit) {
										unit = '';
									}
									let valueDataA = []; //value[0]值
									if(result.deviceCode == properties.code && result.propertyCode == properties.property) {
										if(result.value[0] == null) {
											valueDataA.push(self.randomDataNew(unit, result.time, null))
										} else {
											valueDataA.push(self.randomDataNew(unit, result.time, result.value[0], realData.value[0]))
										}
									} else {
										valueDataA.push(self.randomDataNew(unit, result.time, null))
									}

									let seriesObj = {}; //临时存储
									seriesObj = {
										propertyCode: nameA,
										unit: unit,
										code: properties.code + '-' + properties.property,
										name: nameA + Math.random() + '-&&-' + properties.code + '&-&' + properties.property,
										type: 'line',
										symbolSize: 9,
										smooth: true,
										seriesLayoutBy: 'row',
										showSymbol: false,
										hoverAnimation: false,
										data: valueDataA,
										itemStyle: {
											normal: {
												borderWidth: 4,
												shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
												shadowBlur: 8
											},
										},
										lineStyle: {
											shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
											shadowBlur: 8
										},
									}
									series.push(seriesObj)
								}

							}
						}
						propertiesIndex++;
					}
					if(obj.function != 'pass') {
						/*不是透传*/
						/* 最多只有三个seriesObj对象 value最多三个
						 * 查找当前已实例化的图表series中是否有创建过该数据集*/
						unit = obj.unit;
						/*配置图例名称后缀*/
						if(obj.function == 'add') {
							//nameA = '-求和'
							nameA = ' ';
						} else if(obj.function == 'growth') {
							nameA = '增长量'
							nameB = '增长率'
						} else if(obj.function == 'time') {
							//nameA = '-持续时长'
							nameA = ' ';
						} else if(obj.function == 'sample') {
							nameA = '最小值'
							nameB = '最大值'
							nameC = '平均值'
						}
						if(!unit) {
							unit = '';
						}
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let valueDataC = []; //value[2]值
						let value_index = 0; //当前数据源中的value长度索引
						for(let value of result.value) {
							if(value_index == 0) {
								if(value == null) {
									valueDataA.push(self.randomDataNew(unit, result.time, null))
								} else {
									valueDataA.push(self.randomDataNew(unit, result.time, value, realData.value[value_index]))
								}
							} else if(value_index == 1) {
								if(value == null) {
									valueDataB.push(self.randomDataNew(unit, result.time, null))
								} else {
									valueDataB.push(self.randomDataNew(unit, result.time, value, realData.value[value_index]))
								}
							} else if(value_index == 2) {
								if(value == null) {
									valueDataC.push(self.randomDataNew(unit, result.time, null))
								} else {
									valueDataC.push(self.randomDataNew(unit, result.time, value, realData.value[value_index]))
								}
							}
							value_index++;
						}
						/*一组数据源 需要显示的柱状条数*/
						let length_index = 0; //当前数据源中的value长度索引
						for(let length of result.value) {
							let seriesObj = {}; //临时存储
							if(length_index == 0) {
								seriesObj = {
									propertyCode: nameA,
									unit: unit,
									code: result.deviceCode + '-' + result.propertyCode,
									name: nameA + Math.random() + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
									type: 'line',
									symbolSize: 9,
									smooth: true,
									seriesLayoutBy: 'row',
									showSymbol: false,
									hoverAnimation: false,
									data: valueDataA,
									itemStyle: {
										normal: {
											borderWidth: 4,
											shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
											shadowBlur: 8
										},
									},
									lineStyle: {
										shadowColor: series.length==0?'#00CCFF':series.length==1?'#9933FF':'#00FFCC',
										shadowBlur: 8
									},
								}
							} else if(length_index == 1) {
								seriesObj = {
									propertyCode: nameB,
									unit: unit,
									code: result.deviceCode + '-' + result.propertyCode,
									name: nameB + Math.random() + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
									type: 'line',
									symbolSize: 9,
									smooth: true,
									seriesLayoutBy: 'row',
									showSymbol: false,
									hoverAnimation: false,
									data: valueDataB,
									itemStyle: {
										normal: {
											borderWidth: 4,
											shadowColor: series.length==1?'#9933FF':'#00FFCC',
											shadowBlur: 8
										},
									},
									lineStyle: {
										shadowColor: series.length==1?'#9933FF':'#00FFCC',
										shadowBlur: 8
									},
								}
							} else if(length_index == 2) {
								seriesObj = {
									propertyCode: nameC,
									unit: unit,
									code: result.deviceCode + '-' + result.propertyCode,
									name: nameC + Math.random() + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
									type: 'line',
									symbolSize: 9,
									smooth: true,
									seriesLayoutBy: 'row',
									showSymbol: false,
									hoverAnimation: false,
									data: valueDataC,
									itemStyle: {
										normal: {
											borderWidth: 4,
											shadowColor: '#00FFCC',
											shadowBlur: 8
										},
									},
									lineStyle: {
										shadowColor: '#00FFCC',
										shadowBlur: 8
									},
								}
							}
							length_index++;
							series.push(seriesObj)
						}
					}
				} else {
					/*已将全部属性创建完毕 更新数据*/
					for(let properties of series) {
						if(obj.function == 'pass') {
							let deviceCode = properties.code.split('-')[0];
							let attrCode = properties.code.split('-')[1];
							/*透传*/
							unit = properties.unit;
							if(result.deviceCode == deviceCode && result.propertyCode == attrCode) {
								if(properties.data.filter(itemData => itemData.value[0] == result.time).length != 0) {
									/*如果在data中已创建过result.time时间的value 则覆盖*/
									if(result.value[0] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-'
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[0];
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].v_real = realData.value[0];
									}
								} else {
									/*如果在data中未创建过result.time时间的value 则遍历*/
									if(result.value[0] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, result.value[0], realData.value[0]))
									}
								}
							} else {
								if(properties.data.filter(itemData => itemData.value[0] == result.time).length == 0) {
									if(properties.data[properties.data.length - 1].value[1] == '-') {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, properties.data[properties.data.length - 1].value[1], properties.data[properties.data.length - 1].v_real))
									}
								}
							}

							if(properties.data.length > 7) {
								properties.data.splice(0, 1);
							}
						} else {
							/*不是透传*/
							/* 最多只有三个seriesObj对象 value最多三个
							 * 查找当前已实例化的图表series中是否有创建过该数据集*/
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
							if(!unit) {
								unit = '';
							}

							if(properties.data.filter(itemData => itemData.value[0] == result.time).length != 0) {
								if(properties.propertyCode == nameA) {
									if(result.value[0] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-';
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[0];
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].v_real = realData.value[0];
									}
								} else if(properties.propertyCode == nameB) {
									if(result.value[1] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-';
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[1];
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].v_real = realData.value[1];
									}
								} else if(properties.propertyCode == nameC) {
									if(result.value[2] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-';
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[2];
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].v_real = realData.value[2];
									}
								}
							} else {
								if(properties.propertyCode == nameA) {
									if(result.value[0] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, result.value[0], realData.value[0]))
									}
								} else if(properties.propertyCode == nameB) {
									if(result.value[1] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, result.value[1], realData.value[1]))
									}
								} else if(properties.propertyCode == nameC) {
									if(result.value[2] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomDataNew(unit, result.time, result.value[2], realData.value[2]))
									}
								}
							}
							if(properties.data.length > 7) {
								properties.data.splice(0, 1);
							}
						}
					}
				}
				/*根据chartStyle编写样式*/
				/*if(obj.chartStyle == 2) {
					let styleIndex = 0
					for(let ser of series) {
						ser.areaStyle = {
							color: new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: self.LineColor1[styleIndex]
							}, {
								offset: 1,
								color: '#ffe'
							}])
						}
						styleIndex++
					}
				}*/

				/*重新计算一遍最大值最小值 更新之前的数据*/
				if((obj.properties.length == 1) && ((obj.properties[0].type == 2 || 3) || (DeviceListTest&&DeviceListTest.length==1))){
					/*当只有一个属性的时候 显示实际值*/
				}else{
					if(obj.function == 'pass'){
						for(let s of series){
							let deviceCode = s.code.split('-')[0];
							let attrCode = s.code.split('-')[1];
							let resData = self.v_real.filter(item => item.deviceCode==deviceCode&&item.propertyCode==attrCode);
							if(resData.length != 0){
								let numObj = self.getNumNew(resData[0].data,0)
								for(let d of s.data){
									if(d.value[1] != '-' && resData[0].data.filter(item => item.time == d.value[0]).length != 0){
										let valueReal = resData[0].data.filter(item => item.time == d.value[0])[0].value[0];
										if(valueReal == numObj.max){
											d.value[1] = 100
										}else if(valueReal == numObj.min){
											d.value[1] = 0
										}else if(numObj.max == numObj.min){
											d.value[1] = 100
										}else{
											d.value[1] = Math.round(((valueReal - numObj.min) / (numObj.max - numObj.min)) * 100)
										}
									}
								}
							}
						}
					}else{
						let sIndex = 0;
						for(let s of series){
							let deviceCode = s.code.split('-')[0];
							let attrCode = s.code.split('-')[1];
							let resData = self.v_real.filter(item => item.deviceCode==deviceCode&&item.propertyCode==attrCode);
							if(resData.length != 0){
								let numObj = self.getNumNew(resData[0].data,sIndex)
								for(let d of s.data){
									if(d.value[1] != '-' && resData[0].data.filter(item => item.time == d.value[0]).length != 0){
										let valueReal = resData[0].data.filter(item => item.time == d.value[0])[0].value[sIndex];
										if(valueReal == numObj.max){
											d.value[1] = 100
										}else if(valueReal == numObj.min){
											d.value[1] = 0
										}else if(numObj.max == numObj.min){
											d.value[1] = 100
										}else{
											d.value[1] = Math.round(((valueReal - numObj.min) / (numObj.max - numObj.min)) * 100)
										}
									}
								}
							}
							sIndex++
						}
					}
				}

				/*添加minInterval: 1,maxInterval: 25,用于存在多个属性时 显示0-100的值与设计图一致,若只有一个属性 则不需要添加*/
				let chartsOptions = {
					series: series
				}
				if((obj.properties.length == 1) && ((obj.properties[0].type == 2 || 3) || (DeviceListTest&&DeviceListTest.length==1))){
					/*只有一个属性时*/

				}else{
					chartsOptions.yAxis = {
						splitNumber: 4,
						minInterval: 1,
						maxInterval: 25
					}
				}


				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				/*将x轴数据重新编写*/
				if(self.setxAxisTime.filter(item => item.id == DataSetObj.id).length == 0){
					/*该数据集没有保存当前时间*/
					self.setxAxisTime.push({
						id: DataSetObj.id,
						time: result.time
					})
				}else{
					/*保存过 则替换当前时间	*/
					self.setxAxisTime.filter(item => item.id == DataSetObj.id)[0].time = result.time;
				}
//				self.setxAxisTime xAxisNowTime =

				charts.setOption(chartsOptions)
				// console.log(charts.getOption().series)
			},

			/*折线图 mqtt数据更新*/
			async LineUpdateCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					charts: 当前数据集已实例化的图表,
					obj: 当前数据集整个对象
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let charts = DataSetObj.charts;
				let option = charts.getOption();
				let series = option.series;

				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				let unit;
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let featureList;

				/*新逻辑*/
				if(series.filter(item => item.code == result.deviceCode + '-' + result.propertyCode).length == 0) {
					//console.log(DataSetObj.obj,series)
					/*第一次创建 将所有属性全部显示*/
					for(let properties of obj.properties) {
						if(obj.function == 'pass') {
							/*透传*/
							/* 多个seriesObj对象 value只有一个
							 * 查找当前已实例化的图表series中是否有创建过该数据集*/
							if(properties.type == 3) {
								/*判断数据集历史记录的单个对象是否为系统属性*/
								unit = '';
								if(properties.code.indexOf('_alarm_category_') != -1) {
									nameA = await self.getDictById(properties.code.split('_alarm_category_')[1]);
								} else if(properties.code.indexOf('_device_product_') != -1) {
									nameA = await self.getProductByCode(properties.code.split('_device_product_')[1]);
								} else {
									nameA = self.system_options.filter(item => item.id == properties.property)[0].name;
								}
							} else if(properties.type == 2) {
								/*不为系统属性时 为设备属性时*/
								/*获取TSL 获取 数据属性名称*/
								featureList = await self.getProductFeature(properties.code, properties.property);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;
							} else if(properties.type == 1) {
								/*不为系统属性时 为产品属性时*/
								/*获取TSL 获取 数据属性名称*/
								/*featureList = await self.getProductFeatureByCP(properties.code, properties.property);
								unit = featureList.dataType.specs.unit
								nameA = featureList.name;*/
							}

							/*push进series*/
							if(properties.type == 1) {
								/*为产品属性时 需要将该产品下的所有设备都push进series(mqtt会推送该产品下的所有设备code 而不是产品code)*/
								let DeviceList = await self.getDeviceListByProCode(properties.code)
								//console.log(DeviceList)
								for(let device of DeviceList) {
									featureList = await self.getProductFeature(device.code, properties.property);
									unit = featureList.dataType.specs.unit
									nameA = featureList.name;
									if(!unit) {
										unit = '';
									}
									let valueDataA = []; //value[0]值
									if(result.deviceCode == device.code && result.propertyCode == properties.property) {
										if(result.value[0] == null) {
											valueDataA.push(self.randomData(unit, result.time, null))
										} else {
											valueDataA.push(self.randomData(unit, result.time, (result.value[0] * ratio).toFixed(place)))
										}
									} else {
										valueDataA.push(self.randomData(unit, result.time, null))
									}

									let seriesObj = {}; //临时存储
									seriesObj = {
										propertyCode: nameA,
										unit: unit,
										code: device.code + '-' + properties.property,
										name: nameA + Math.random() + '-&&-' + device.code + '&-&' + properties.property,
										type: 'line',
										symbolSize: 9,
										smooth: true,
										seriesLayoutBy: 'row',
										showSymbol: false,
										hoverAnimation: false,
										data: valueDataA
									}
									series.push(seriesObj)
								}
							} else {
								/*不为产品属性时 直接在series中push一次*/
								if(!unit) {
									unit = '';
								}
								let valueDataA = []; //value[0]值
								if(result.deviceCode == properties.code && result.propertyCode == properties.property) {
									if(result.value[0] == null) {
										valueDataA.push(self.randomData(unit, result.time, null))
									} else {
										valueDataA.push(self.randomData(unit, result.time, (result.value[0] * ratio).toFixed(place)))
									}
								} else {
									valueDataA.push(self.randomData(unit, result.time, null))
								}

								let seriesObj = {}; //临时存储
								seriesObj = {
									propertyCode: nameA,
									unit: unit,
									code: properties.code + '-' + properties.property,
									name: nameA + Math.random() + '-&&-' + properties.code + '&-&' + properties.property,
									type: 'line',
									symbolSize: 9,
									smooth: true,
									seriesLayoutBy: 'row',
									showSymbol: false,
									hoverAnimation: false,
									data: valueDataA
								}
								series.push(seriesObj)
							}

						}
					}
					if(obj.function != 'pass') {
						/*不是透传*/
						/* 最多只有三个seriesObj对象 value最多三个
						 * 查找当前已实例化的图表series中是否有创建过该数据集*/
						unit = obj.unit;
						/*配置图例名称后缀*/
						if(obj.function == 'add') {
							//nameA = '-求和'
							nameA = ' ';
						} else if(obj.function == 'growth') {
							nameA = '增长量'
							nameB = '增长率'
						} else if(obj.function == 'time') {
							//nameA = '-持续时长'
							nameA = ' ';
						} else if(obj.function == 'sample') {
							nameA = '最小值'
							nameB = '最大值'
							nameC = '平均值'
						}
						if(!unit) {
							unit = '';
						}
						let valueDataA = []; //value[0]值
						let valueDataB = []; //value[1]值
						let valueDataC = []; //value[2]值
						let value_index = 0; //当前数据源中的value长度索引
						for(let value of result.value) {
							if(value_index == 0) {
								if(value == null) {
									valueDataA.push(self.randomData(unit, result.time, null))
								} else {
									valueDataA.push(self.randomData(unit, result.time, (value * ratio).toFixed(place)))
								}
							} else if(value_index == 1) {
								if(value == null) {
									valueDataB.push(self.randomData(unit, result.time, null))
								} else {
									valueDataB.push(self.randomData(unit, result.time, (value * ratio).toFixed(place)))
								}
							} else if(value_index == 2) {
								if(value == null) {
									valueDataC.push(self.randomData(unit, result.time, null))
								} else {
									valueDataC.push(self.randomData(unit, result.time, (value * ratio).toFixed(place)))
								}
							}
							value_index++;
						}
						/*一组数据源 需要显示的柱状条数*/
						let length_index = 0; //当前数据源中的value长度索引
						for(let length of result.value) {
							let seriesObj = {}; //临时存储
							if(length_index == 0) {
								seriesObj = {
									propertyCode: nameA,
									unit: unit,
									code: result.deviceCode + '-' + result.propertyCode,
									name: nameA + Math.random() + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
									type: 'line',
									symbolSize: 9,
									smooth: true,
									seriesLayoutBy: 'row',
									showSymbol: false,
									hoverAnimation: false,
									data: valueDataA
								}
							} else if(length_index == 1) {
								seriesObj = {
									propertyCode: nameB,
									unit: unit,
									name: nameB + Math.random() + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
									type: 'line',
									symbolSize: 9,
									smooth: true,
									seriesLayoutBy: 'row',
									showSymbol: false,
									hoverAnimation: false,
									data: valueDataB
								}
							} else if(length_index == 2) {
								seriesObj = {
									propertyCode: nameC,
									unit: unit,
									name: nameC + Math.random() + '-&&-' + result.deviceCode + '&-&' + result.propertyCode,
									type: 'line',
									symbolSize: 9,
									smooth: true,
									seriesLayoutBy: 'row',
									showSymbol: false,
									hoverAnimation: false,
									data: valueDataC
								}
							}
							length_index++;
							series.push(seriesObj)
						}
					}
				} else {
					/*已将全部属性创建完毕 更新数据*/
					for(let properties of series) {
						if(obj.function == 'pass') {
							let deviceCode = properties.code.split('-')[0];
							let attrCode = properties.code.split('-')[1];
							/*透传*/
							unit = properties.unit
							if(result.deviceCode == deviceCode && result.propertyCode == attrCode) {
								if(properties.data.filter(itemData => itemData.value[0] == result.time).length != 0) {
									/*如果在data中已创建过result.time时间的value 则覆盖*/
									if(result.value[0] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-'
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[0];
									}
								} else {
									/*如果在data中未创建过result.time时间的value 则遍历*/
									if(result.value[0] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, (result.value[0] * ratio).toFixed(place)))
									}
								}
							} else {
								if(properties.data.filter(itemData => itemData.value[0] == result.time).length == 0) {
									if(properties.data[properties.data.length - 1].value[1] == '-') {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, properties.data[properties.data.length - 1].value[1]))
									}
								}
							}

							if(properties.data.length > self.ChartsDataLength) {
								properties.data.splice(0, 1);
							}
						} else {
							/*不是透传*/
							/* 最多只有三个seriesObj对象 value最多三个
							 * 查找当前已实例化的图表series中是否有创建过该数据集*/
							unit = obj.unit;
							/*配置图例名称后缀*/
							if(obj.function == 'add') {
								//nameA = '-求和'
								nameA = ' ';
							} else if(obj.function == 'growth') {
								nameA = '增长量'
								nameB = '增长率'
							} else if(obj.function == 'time') {
								//nameA = '-持续时长'
								nameA = ' ';
							} else if(obj.function == 'sample') {
								nameA = '最小值'
								nameB = '最大值'
								nameC = '平均值'
							}
							if(!unit) {
								unit = '';
							}

							if(properties.data.filter(itemData => itemData.value[0] == result.time).length != 0) {
								if(properties.propertyCode == nameA) {
									if(result.value[0] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-';
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[0];
									}
								} else if(properties.propertyCode == nameB) {
									if(result.value[1] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-';
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[1];
									}
								} else if(properties.propertyCode == nameC) {
									if(result.value[2] == null) {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = '-';
									} else {
										properties.data.filter(itemData => itemData.value[0] == result.time)[0].value[1] = result.value[2];
									}
								}
							} else {
								if(properties.propertyCode == nameA) {
									if(result.value[0] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, (result.value[0] * ratio).toFixed(place)))
									}
								} else if(properties.propertyCode == nameB) {
									if(result.value[1] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, (result.value[1] * ratio).toFixed(place)))
									}
								} else if(properties.propertyCode == nameC) {
									if(result.value[2] == null) {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, null))
									} else {
										properties.data.splice(self.pushNum(properties.data, result.time), 0, self.randomData(unit, result.time, (result.value[2] * ratio).toFixed(place)))
									}
								}
							}
							if(properties.data.length > self.ChartsDataLength) {
								properties.data.splice(0, 1);
							}
						}
					}
				}
				/*根据chartStyle编写样式*/
				if(obj.chartStyle == 2) {
					let styleIndex = 0
					for(let ser of series) {
						ser.areaStyle = {
							color: new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: self.LineColor1[styleIndex]
							}, {
								offset: 1,
								color: '#ffe'
							}])
						}
						styleIndex++
					}
				}
				charts.setOption({
					series: series
				})
				//console.log(charts.getOption().series)
			},

			/*表格 mqtt数据更新*/
			async TableUpdateCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					refName: 当前this对象中存放地
					用法 =>
					self.tableList[refName] = {
						attr: attr,
						data: data
					};,
					obj: 当前数据集整个对象
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				let refName = DataSetObj.refName;
				let attr = this.tableList[refName].attr;
				let data = this.tableList[refName].data;
				let nameA = '';
				let nameB = '';
				let nameC = '';
				let code = result.deviceCode + '-' + result.propertyCode;
				let featureList;
				let unit;
				//修正系数
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}

				if(obj.function == 'pass') {
					if(result.deviceCode.indexOf('_') == 0) {
						/*判断数据集历史记录的单个对象是否为系统属性*/
						unit = '';
						if(result.propertyCode.indexOf('_alarm_category_') != -1) {
							nameA = await self.getDictById(result.propertyCode.split('_alarm_category_')[1]);
						} else if(result.propertyCode.indexOf('_device_product_') != -1) {
							nameA = await self.getProductByCode(result.propertyCode.split('_device_product_')[1]);
						} else {
							nameA = self.system_options.filter(item => item.id == result.propertyCode)[0].name;
						}
					} else {
						/*不为系统属性时*/
						/*获取TSL 获取 数据属性名称*/
						featureList = await self.getProductFeature(result.deviceCode, result.propertyCode);
						unit = featureList.dataType.specs.unit
						nameA = featureList.name;
					}
				} else {
					unit = obj.unit;
					/*配置图例名称后缀*/
					if(obj.function == 'add') {
						//nameA = '-求和'
						nameA = ' ';
					} else if(obj.function == 'growth') {
						nameA = '增长量'
						nameB = '增长率'
					} else if(obj.function == 'time') {
						//nameA = '-持续时长'
						nameA = ' ';
					} else if(obj.function == 'sample') {
						nameA = '最小值'
						nameB = '最大值'
						nameC = '平均值'
					}
				}
				unit = unit ? unit : ''
				if(attr.filter(item => item.nameA == (nameA + '/*/' + code)).length == 0) {
					/*未创建的情况下*/
					this.tableList[refName].attr.push({
						nameA: nameA + '/*/' + code,
						nameB: nameB,
						nameC: nameC,
						unit: unit
					})
				}

				if(self.tableList[refName].data.filter(item => item.createdTime == result.time).length != 0) {
					/*tableList.data中有创建过相应的时间数组情况下*/
					let nameIndex = 0;
					for(let valueList of result.value) {
						if(nameIndex == 0) {
							if(valueList == null) {
								self.tableList[refName].data.filter(item => item.createdTime == result.time)[0][nameA + '/*/' + code] = null;
							} else {
								self.tableList[refName].data.filter(item => item.createdTime == result.time)[0][nameA + '/*/' + code] = (valueList * ratio).toFixed(place)
							}
						} else if(nameIndex == 1) {
							if(valueList == null) {
								self.tableList[refName].data.filter(item => item.createdTime == result.time)[0][nameB] = null
							} else {
								self.tableList[refName].data.filter(item => item.createdTime == result.time)[0][nameB] = (valueList * ratio).toFixed(place)
							}
						} else if(nameIndex == 2) {
							if(valueList == null) {
								self.tableList[refName].data.filter(item => item.createdTime == result.time)[0][nameC] = null
							} else {
								self.tableList[refName].data.filter(item => item.createdTime == result.time)[0][nameC] = (valueList * ratio).toFixed(place)
							}
						}
						nameIndex++;
					}
				} else {
					let objOther = {};
					objOther.createdTime = result.time;
					let nameIndex = 0;
					for(let valueList of result.value) {
						if(nameIndex == 0) {
							if(valueList == null) {
								objOther[nameA + '/*/' + code] = null;
							} else {
								objOther[nameA + '/*/' + code] = (valueList * ratio).toFixed(place)
							}
						} else if(nameIndex == 1) {
							if(valueList == null) {
								objOther[nameB] = null
							} else {
								objOther[nameB] = (valueList * ratio).toFixed(place)
							}
						} else if(nameIndex == 2) {
							if(valueList == null) {
								objOther[nameC] = null
							} else {
								objOther[nameC] = (valueList * ratio).toFixed(place)
							}
						}
						nameIndex++;
					}
					self.tableList[refName].data.unshift(objOther)
				}
				if(self.tableList[refName].data.length > self.ChartsDataLength) {
					self.tableList[refName].data.splice(self.tableList[refName].data.length - 1, 1)
				}

				self.$forceUpdate() /*强制刷新 略略略*/
			},

			/*只显示一条数据 mqtt数据更新*/
			async TableValueUpdateCharts(DataSetObj, result) {
				/*
				 * DataSetObj => {
					id: 当前数据集id,
					obj: 当前数据集整个对象,
					以下三个为当前this对象中的存放地
					mouldName: mould.name,
					childrenName: children.name,
					index: index,
					用法 => this[mouldName][childrenName][index] => {obj} => 当前数据集
				 * }
				 * result => 当前mqtt推送的数据 => {
				  	deviceCode: "atlas_air_pump_01"
					propertyCode: "E_Craft_PT_Comp"
					time: 1596098671895
					value: [3]
				 * }
				 */
				let self = this;
				let obj = DataSetObj.obj;
				if(obj.ratio || Number(obj.ratio) == 0) {
					var ratio = obj.ratio
				} else {
					var ratio = 1;
				}
				//保留小数
				if(obj.place) {
					var place = obj.place
				} else {
					var place = null;
				}
				let resultList = result
				/*总配置*/
				let nameA = '';
				let featureList;
				let unit;
				let DeviceList;

				if(obj.function == 'pass') {
          // 虚拟设备
          if(resultList.deviceCode.indexOf('_V')!=-1){

          }else if(resultList.deviceCode.indexOf('_') == 0) {
						/*判断数据集历史记录的单个对象是否为系统属性*/
						unit = '';
						if(resultList.propertyCode.indexOf('_alarm_category_') != -1) {
							nameA = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
						} else if(resultList.propertyCode.indexOf('_device_product_') != -1) {
							nameA = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
						} else {
							nameA = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
						}
					} else {
						/*不为系统属性时*/
						if(obj.properties[0].type == 2){
							/*获取TSL 获取 数据属性名称*/
							featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
							unit = featureList.dataType.specs.unit
							nameA = featureList.name;
						}else if(obj.properties[0].type == 1){
							/*为产品属性时 只需要将该产品下的第一个设备展示(mqtt会推送该产品下的所有设备code 而不是产品code)*/
							DeviceList = await self.getDeviceListByProCode(obj.properties[0].code)
							//console.log(DeviceList)
							featureList = await self.getProductFeature(DeviceList[0].code, obj.properties[0].property);
							unit = featureList.dataType.specs.unit
							nameA = featureList.name;
						}
					}
				} else {
					unit = obj.unit;
					/*配置图例名称后缀*/
					if(obj.function == 'add') {
						//nameA = '-求和'
						nameA = ' ';
					} else if(obj.function == 'growth') {
						nameA = '增长量'
					} else if(obj.function == 'time') {
						//nameA = '-持续时长'
						nameA = ' ';
					} else if(obj.function == 'sample') {
						nameA = '最小值'
					}
				}
				if(!unit) {
					unit = '';
				}

				let mark = false;
				if(obj.function == 'pass'){
					/*透传*/
					if(obj.properties[0].type == 2 || obj.properties[0].type == 3){
						/*为设备属性 或 系统属性时*/
						if((result.deviceCode == obj.properties[0].code) && (result.propertyCode == obj.properties[0].property)){
							mark = true
						}
					}else{
						/*为产品属性时 只需要将该产品下的第一个设备展示(mqtt会推送该产品下的所有设备code 而不是产品code)*/
						if((result.deviceCode == DeviceList[0].code) && (result.propertyCode == obj.properties[0].property)){
							mark = true
						}
					}
				}
				if(mark){
					let value = result.value[0]
					if(value != null) {
						value = (value * ratio).toFixed(place)
					}
					self[DataSetObj.mouldName][DataSetObj.childrenName][DataSetObj.index].value = value;
					self[DataSetObj.mouldName][DataSetObj.childrenName][DataSetObj.index].unit = unit;
				}

				self.$forceUpdate() /*强制刷新*/
			},

			/*通过mqtt返回的值更新图表*/
			UpdateChartsByMqtt(DataSetObj, item) {
        // console.log(DataSetObj, item)
				let self = this;
				let type = DataSetObj.type
				if(type == 'ShowOneData') {
					/*只显示一条数据*/
					self.TableValueUpdateCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
				} else if(type == 1) {
					/*仪表盘*/
					self.GaugeUpdataCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
				} else if(type == 3) {
					/*折线图*/
					self.NewLineUpdateCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
				} else if(type == 4) {
					/*柱状图*/
					self.NewBarUpdateCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
				} else if(type == 5) {
					/*右下仪表盘*/
					self.LastGaugeUpdataCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
				} else if(type == 6) {
					/*右下水球*/
					self.WaterUpdataCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
				} else {
					if(DataSetObj.obj.chartType == 1) {
						/*饼图*/
						self.PieUpdateCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
					} else if(DataSetObj.obj.chartType == 2) {
						/*柱状图*/
						self.BarUpdateCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
					} else if(DataSetObj.obj.chartType == 3) {
						/*折线图*/
						self.LineUpdateCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
					} else if(DataSetObj.obj.chartType == 4) {
						/*文本标签*/
						self.TableUpdateCharts(DataSetObj, JSON.parse(JSON.stringify(item)))
					}
				}
			},

			/*连接mqtt*/
			contentMqtt() {
				for(let obj of this.MqttByDataSetUrl) {
					this.$store.state.subaru.subscribe(obj.url, {
						qos: 1
					})
				}
			},

			/*接收mqtt*/
			getMqttMessage() {
				let self = this;
				// 接收消息处理
				this.$store.state.subaru.on('message', (topic, message) => {
					// if(topic=='sys/dataset/14/push'){
     //        console.log(JSON.parse(message.toString()));
     //      }
					if(topic.indexOf('/property/push') != -1) {
						/*看板*/
						if(this.FullShowMark) {
							this.$refs.addrobotFullScreen.UpdateDataByMqtt(topic, message)
						} else {
							this.$refs.addrobot.UpdateDataByMqtt(topic, message)
						}
						this.$refs.Addrobot.mqttUpdateFunction(topic, message)
						if(this.systemObj.DeviceCode) {
							this.updataSystemState(message);
						}

						this.$forceUpdate()
					} else if(topic.indexOf('sys/dataset') != -1) {
						/*数据集*/
						let item = JSON.parse(message.toString()); //转码
						//						console.log(item)
						let DataSetId = this.MqttByDataSetUrl.filter(item => item.url == topic)[0].id;
						let DataSetArr = this.MqttCharts.filter(item => item.id == DataSetId); //可能有多个(存在 同一个数据集 不同Box情况)
						/*通过mqtt返回的值更新所有实时图表*/
						for(let DataSetObj of DataSetArr) {
							this.UpdateChartsByMqtt(DataSetObj, item);
              // console.log(item)
						}
					} else if(topic.indexOf('sys/company') != -1) {
						/*图例*/
						let item = JSON.parse(message.toString()); //转码
						// console.log(item)
						if(!JSON.parse(item.online)) {
							this.errorState = -1;
						} else if(item.alarm.error > 0) {
							this.errorState = 2;
						} else if((item.alarm.infor > 0) || (item.alarm.warn > 0)) {
							this.errorState = 1;
						} else {
							this.errorState = 0;
						}
					}
				})
			},

			/*改变看板颜色*/
			changeDivSpan(index) {
				this.$refs.Addrobot.changeDivSpan(index);
			},

			/*展示图例*/
			changeTip() {
				var self = this;
				this.$refs.tipBody.style.display = "block";
				this.tipMark = true;
				setTimeout(function() {
					self.$refs.tipBody.style.opacity = 1;
					self.$refs.tipBody.style.bottom = 0 + 'px';
				}, 50)
			},

			/*关闭图例*/
			closeTip() {
				var self = this;
				this.$refs.tipBody.style.opacity = 0;
				self.$refs.tipBody.style.bottom = -20 + 'px';
				this.tipMark = false;
				setTimeout(function() {
					self.$refs.tipBody.style.display = "none";
				}, 100)
			},

			/*展示实时数据*/
			async Addrobot(obj) {
				var self = this; //addrobotFullScreen
				if(this.FullShowMark) {
					if(obj == 'close') {
						this.$refs.addrobotFullScreen.$el.style.opacity = 0;
						self.$refs.addrobotFullScreen.$children[0].$el.style.top = -50 + 'px';
						self.maskStateByFull = false;
						setTimeout(function() {
							self.$refs.addrobotFullScreen.$el.style.display = "none";
						}, 100)
						return;
					}
					if(this.$refs.addrobotFullScreen.$el.style.display == "" || this.$refs.addrobotFullScreen.$el.style.display == "none") {
						await this.$refs.addrobotFullScreen.binding(obj);
						this.$refs.addrobotFullScreen.$el.style.display = "block";
						self.maskStateByFull = true;
						document.getElementsByClassName('mask')[0].style.opacity = '0';
						document.getElementsByClassName('mask')[0].style.transition = '.1s';
						setTimeout(function() {
							self.$refs.addrobotFullScreen.$el.style.opacity = 1;
							self.$refs.addrobotFullScreen.$children[0].$el.style.top = 0 + 'px';
							document.getElementsByClassName('mask')[0].style.opacity = '1';
						}, 50)
					} else {
						this.$refs.addrobotFullScreen.$el.style.opacity = 0;
						self.$refs.addrobotFullScreen.$children[0].$el.style.top = -50 + 'px';
						self.maskStateByFull = false;
						setTimeout(function() {
							self.$refs.addrobotFullScreen.$el.style.display = "none";
						}, 100)
					}
				} else {
					if(obj == 'close') {
						if(self.$route.path == '/CompanyConsole/IndexEditShow') {
							self.$store.state.mask = false;
							this.$refs.addrobot.$el.style.opacity = 0;
							self.$refs.addrobot.$children[0].$el.style.top = -50 + 'px';
							setTimeout(function() {
								self.$refs.addrobot.$el.style.display = "none";
							}, 100)
						}
						return;
					}
					if(this.$refs.addrobot.$el.style.display == "" || this.$refs.addrobot.$el.style.display == "none") {
						await this.$refs.addrobot.binding(obj);
						this.$refs.addrobot.$el.style.display = "block";
						self.$store.state.mask = true;
						document.getElementsByClassName('mask')[0].style.opacity = '0';
						document.getElementsByClassName('mask')[0].style.transition = '.1s';
						setTimeout(function() {
							self.$refs.addrobot.$el.style.opacity = 1;
							self.$refs.addrobot.$children[0].$el.style.top = 0 + 'px';
							document.getElementsByClassName('mask')[0].style.opacity = '1';
						}, 50)
					} else {
						this.$refs.addrobot.$el.style.opacity = 0;
						self.$refs.addrobot.$children[0].$el.style.top = -50 + 'px';
						self.$store.state.mask = false;
						setTimeout(function() {
							self.$refs.addrobot.$el.style.display = "none";
						}, 100)
					}
				}
			},

			newPointTop(val) {
				this.dragContainer.newPoint.top = val;
				//console.log(this.dragContainer.newPoint.top)
			},

			newPointLeft(val) {
				this.dragContainer.newPoint.left = val;
				//console.log(this.dragContainer.newPoint.left)
			},

		}, //结束创建方法
		beforeDestroy() {
			// 在Vue实例销毁前，清除我们的定时器
			if(this.getCompanyCode) {
				clearInterval(this.getCompanyCode);
			}
		},
		watch: {
			NowLoadNum(val) {
				let self = this;
				if(val == -1) {
					/*连接mqtt*/
					self.contentMqtt();

					//开启 图例mqtt
					self.MqttByTip();
				} else {
					if(val == this.totalChartsNum) {
						/*等待之后 */
						self.$nextTick(() => {
							/*改变完成状态开关*/
							setTimeout(() => {
								self.loadingMark = false
								self.$forceUpdate();
							}, 1000)

							/*正常性组态*/
							if(self.type == 1) {
								/*连接mqtt*/
								self.contentMqtt();

								//开启 图例mqtt
								self.MqttByTip();
							} else if(self.type == 2) {
								/*3D组态*/
								//self.contentMqttByThree();
							}

							/*let a = self.charts.getOption();
							let data = a.series[0].data;
							data.push({
								name: '1',
								showName: '1',
								unit: '',
								value: 200
							});
							self.charts.setOption({
								series: [{
									data: data
								}]
							})*/
						})
					}
				}
			}
		},
	}
</script>
<style scoped>
	.ttt .right_ {
		margin-top: 15px !important;
	}
	.last_box{
	    top: -5%;
    	position: relative;
	}
	.right_last .last_name{
		color: #ddf1ff !important;
	    top: 15px;
    	position: relative;
	}

	.last_body {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.right_last_4 .last_value,.right_last_3 .last_value {
		color: #3BF9DA;
		background: linear-gradient(0deg, #00FFF6 0%, #00CCFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}


	.right_last .right_last_ .right_last_colorY .last_value {
		color: #3BF9DA;
		background: linear-gradient(0deg, #FF6600 0%, #FF9933 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.right_last .right_last_ .right_last_colorR .last_value {
		color: #FF3366;
		background: linear-gradient(0deg, #FF0D72 0%, #FF5B16 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.right_last_1 .last_value,
	.right_last_2 .last_value {
		color: #3BF9DA;
		background: linear-gradient(0deg, #00FFF6 0%, #00CCFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.last_value {
		position: absolute;
		bottom: -4px;
		left: 13px;
		right: 0;
		margin: auto;
		font-family: agencyr;
		font-size: 23px;
		font-weight: 700;
	}

	.last_box {
		float: left;
		height: calc(100% - 30px);
		width: 100%;
	}

	.last_name {
		float: left;
		width: 100%;
		height: 30px;
		color: #cff;
		text-align: center;
		font-size: 16px;
	}

	.show_content .right .right_Old .datasetTitle {
		color: #cff;
		line-height: 1;
		text-align: left;
		font-size: 16px;
		margin-bottom: 10px;
		text-indent: 0;
	}

	.right_Old {
		background-color: transparent !important;
		box-shadow: unset !important;
	}

	.openC3 {
		background-image: url(../../assets/image/indexEditor/model7/c3.png) !important;
	}

	.openC2 {
		background-image: url(../../assets/image/indexEditor/model7/c2.png) !important;
	}

	.openC1 {
		background-image: url(../../assets/image/indexEditor/model7/c1.png) !important;
	}

	.openL3 {
		background-image: url(../../assets/image/indexEditor/model7/l3.png) !important;
	}

	.openL2 {
		background-image: url(../../assets/image/indexEditor/model7/l2.png) !important;
	}

	.openL1 {
		background-image: url(../../assets/image/indexEditor/model7/l1.png) !important;
	}

	.c3 {
		background-image: url(../../assets/image/indexEditor/model7/noc3.png);
	}

	.c2 {
		background-image: url(../../assets/image/indexEditor/model7/noc2.png);
	}

	.c1 {
		background-image: url(../../assets/image/indexEditor/model7/noc1.png);
	}

	.l3 {
		background-image: url(../../assets/image/indexEditor/model7/nol3.png);
	}

	.l2 {
		background-image: url(../../assets/image/indexEditor/model7/nol2.png);
	}

	.l1 {
		background-image: url(../../assets/image/indexEditor/model7/nol1.png);
	}

	.cbody {
		float: left;
		background-position: 0;
		background-repeat: no-repeat;
		color: #c4e1ff;
		font-size: 12px;
		text-indent: 16px;
		margin-bottom: 5px;
		width: 100%;
		cursor: pointer;
		text-align: left;
	}

	.cBox {
		right: 0;
		width: 60px;
	}

	.lBox {
		left: 15px;
		width: 80px;
	}

	.lBox,
	.cBox {
		position: absolute;
		bottom: 0;
		z-index: 5;
	}

	.threeBg {
		background-image: url(../../assets/image/indexEditor/model7/three.png);
		background-position: center bottom;
		background-repeat: no-repeat;
	}

	.Alarm2 {
		height: 47px;
		width: 120px;
		top: 15px;
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
	}

	.Alarm {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.newValue {
		position: absolute;
		top: 35px;
		bottom: 0;
		right: 0;
		left: 0;
		font-size: 26px;
		margin: auto;
		width: max-content;
		height: max-content;
		color: #FFFFFF;
		background: linear-gradient(0deg, #118AFF 0%, #33CCFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-family: agencyr;
		font-weight: bold;
	}

	.newDataBox {
		width: 100%;
		height: calc(100% - 35px);
		float: left;
		position: relative;
		z-index: 5;
	}

	.newName {
		color: #cff;
		line-height: 1;
		text-align: left;
		font-size: 16px;
		float: left;
		width: 100%;
		height: 25px;
		margin-bottom: 10px;
	}

	.newDataSet {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.right_last_1,
	.right_last_2,
	.right_last_3 {
		background-image: url(../../assets/image/indexEditor/model7/border.png);
	}

	.right_last {
		flex: 1;
		margin-top: 20px !important;
		display: flex;
		width: calc(100% - 64px);
		margin-left: 34px;
		transition: .3s;
	}

	.right4 {
		flex: 1;
		margin-top: 20px !important;
		display: flex;
		width: calc(100% - 64px);
		margin-left: 34px;
		transition: .3s;
	}

	.right4_ {
		height: 100%;
		position: relative;
		/*background-color: #fff;*/
		/*box-shadow: 0 42px 53px 0 rgba(0,173,227,.15);*/
		border-radius: 15px;
	}

	.right4_right {
		flex: 1;
		margin-left: 20px;
	}

	.right4_left {
		flex: .5;
	}

	.AlarmCount {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		margin: auto;
		height: max-content;
		font-size: 15px;
	}

	.right_last_ {
		height: 100%;
		position: relative;
		/*background-color: #fff;*/
		flex: 1;
		/*margin-right: 20px;*/
		background-position: 145px;
		background-repeat: no-repeat;
	}

	.center_working .workError {
		background-image: url(../../assets/image/indexEditor/model7/workError.png);
	}

	.center_working .workNormal {
		background-image: url(../../assets/image/indexEditor/model7/workNormal.png);
	}

	.center_working div {
		background-position: center left;
		background-size: 24px 24px;
		background-repeat: no-repeat;
		width: 100%;
		color: #C4E1FF;
		font-size: 12px;
		text-indent: 35px;
		height: 24px;
		line-height: 24px;
	}

	.center_working p {
		line-height: 51px;
		color: #FFFFFF;
		font-size: 16px;
		text-indent: 0;
	}

	.center_working {
		position: absolute;
		left: 66px;
		top: 0;
		width: 120px;
		transition: .1s;
		z-index: 50;
		text-align: left;
	}

	.row-data.four .data-content {
		color: #CC33FF;
	}

	.row-data.three .data-content {
		color: #00FFFF;
	}

	.row-data.two .data-content {
		color: #0099FF;
	}

	.row-data.one .data-content .top-value {
		color: #00CC66;
	}

	.data-content .top-value div:nth-child(2) {
		position: relative;
		left: 4px;
		float: left;
		top: 9px;
	}

	.data-content .top-value div:nth-child(1) {
		font-family: agencyr;
		margin-left: 2px;
		max-width: 147px;
		float: left;
		text-overflow: ellipsis;
		white-space: nowrap;
		word-break: keep-all;
		overflow: hidden;
	}

	.data-content .top-value {
		line-height: 1;
		text-indent: 0;
		margin-left: 110px;
		width: calc(100% - 110px) !important;
		font-size: 22px;
	}

	.data-content .top-name img {
		top: 9px;
		position: relative;
	}

	.data-content .top-name {
		line-height: 33px;
		color: #cff;
		font-size: 16px;
		margin-top: -5px;
	}

	.data-content .top-name,
	.data-content .top-value {
		float: left;
		width: 100%;
	}
	/*模板7开始*/

	.row-data .data-content {
		width: 100%;
		height: 100%;
		position: relative;
		background-position: 58px;
		background-repeat: no-repeat;
		text-align: left;
		text-indent: 110px;
		/* background-size: 32px 45px;*/
	}

	.row-data.four .data-content {
		background-image: url(../../assets/image/indexEditor/model7/icon4.png);
	}

	.row-data.three .data-content {
		background-image: url(../../assets/image/indexEditor/model7/icon3.png);
	}

	.row-data.two .data-content {
		background-image: url(../../assets/image/indexEditor/model7/icon2.png);
	}

	.row-data.one .data-content {
		background-image: url(../../assets/image/indexEditor/model7/icon1.png);
	}

	.showLine .row-data.four {
		background-image: url(../../assets/image/indexEditor/model7/line4.png);
	}

	.showLine .row-data.three {
		background-image: url(../../assets/image/indexEditor/model7/line3.png);
	}

	.showLine .row-data.two {
		background-image: url(../../assets/image/indexEditor/model7/line2.png);
	}

	.showLine .row-data.one {
		background-image: url(../../assets/image/indexEditor/model7/line1.png);
	}

	.row-data {
		flex: 1;
		margin-left: 20px;
		height: 100%;
		background-position: top;
		background-size: 100%;
		background-repeat: no-repeat;
	}

	.top-row {
		width: 100%;
		float: left;
		display: flex;
		height: 70px;
	}

	.left_top_7 {
		width: 100%;
		position: relative;
		height: 140px;
		margin-top: 20px;
	}

	.centerBoxBy7 {
		background-image: url(../../assets/image/indexEditor/frame.png);
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	/*模板7结束*/
	/*地图开始*/

	.borderFFF {
		border: 2px solid #fff;
		transform: scale(0.7);
	}

	.drag-img {
		text-indent: 0 !important;
	}

	.shotImg {
		z-index: 1;
		position: absolute;
		text-indent: 0 !important;
		left: 0;
		right: 0;
		bottom: unset !important;
	}

	.minizz {
		background-color: rgba(0, 0, 0, .4);
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 5;
		text-indent: 0;
	}

	.MiniMap {
		position: absolute;
		bottom: 0;
		right: 100px;
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		z-index: 55;
		text-indent: 0;
		border: 2px solid #999;
		overflow: hidden;
	}

	.MiniMap .image-move-wapper {
		position: absolute;
		/*right: 50px;*/
		/*top: 50px;*/
		background: #fff;
		box-shadow: rgba(255, 255, 255, 0.5);
		/*padding: 10px;*/
		z-index: 6;
		outline: 2px solid #000000a8;
	}

	.MiniMap .image-show-box {
		cursor: move;
		overflow: hidden;
		position: relative;
		/*width: 100px;
		height: 80px;*/
	}

	.MiniMap .drag-container {
		position: absolute;
		left: 0px;
		top: 0;
		/*禁止元素选中*/
		-moz-user-select: none;
		/*火狐*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-ms-user-select: none;
		/*IE10*/
		-khtml-user-select: none;
		/*早期浏览器*/
		user-select: none;
	}

	.MiniMap .drag-image-box {
		position: relative;
	}

	.MiniMap .point {
		position: absolute;
		background: red;
		height: 30px;
		width: 30px;
		border-radius: 50%;
	}
	/*地图结束*/
	/*验证码css*/

	i.close {
		font-size: 20px;
		float: right;
		margin-top: 24px;
	}

	.popup>div {
		position: fixed !important;
		top: 10%;
		left: 50%;
		padding: 0 28px;
		box-sizing: border-box;
		margin-left: -407px;
		width: 578px;
		background-color: #fff;
		z-index: 9999 !important;
		padding-bottom: 30px;
		box-shadow: 0px 0px 35px 0px rgb(0 0 0 / 15%);
	}

	.popup-title {
		font-size: 16px;
		line-height: 64px;
		border-bottom: 1px solid #e5e5e5;
		margin-bottom: 22px;
		text-align: left;
	}

	.popup-lab {
		font-size: 14px;
		line-height: 30px;
		margin-bottom: 14px;
	}

	.btn-box {
		position: relative;
		margin-top: 260px;
	}

	.btn-box2 {
		text-align: center;
		width: 100%;
		margin-top: 46px;
	}

	.btn-box>p {
		margin-top: 10px;
		color: #909090;
	}
	/*验证码结束*/

	.datasetTable>>>.el-table__body {
		width: 100% !important;
	}

	.leftTopTable {
		margin-left: 26px !important;
		width: calc(100% - 26px) !important;
	}

	.leftTopTable .TableUnit {
		position: relative;
		top: 24px;
		left: -5px;
	}

	.leftTopTable .TableValue {
		position: relative;
		top: 24px;
		/*left: -10px;*/
	}

	.darkTootip .legend .tip {
		background-color: rgba(12, 25, 42, 0.2);
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		color: #FFFFFF;
		border: 1px solid #122744;
	}

	.darkTootip .legend .alltip {
		background-color: rgba(12, 25, 42, 0.2);
		color: #fff;
	}

	.darkTootip .legend .tip_body {
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		background-color: rgba(12, 25, 42, 0.2);
		color: #FFFFFF;
		border: 1px solid #122744;
	}

	.darkTootip .stateTip {
		background-color: rgba(12, 25, 42, 0.2);
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		border: 1px solid rgba(18, 39, 68, 1);
		color: #FFFFFF;
	}

	.darkTootip .errorTip {
		background-color: rgba(12, 25, 42, 0.2);
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		border: 1px solid rgba(18, 39, 68, 1);
		color: #FFFFFF;
		float: right !important;
		margin: 0 !important;
	}

	.darkTootip .errorTip:hover {
		background-color: rgba(12, 25, 42, 0.5) !important;
	}

	.darkTootip .stateTip:hover {
		background-color: rgba(12, 25, 42, 0.5) !important;
	}

	.darkTootip .legend .tip_body .tip_box:hover {
		background-color: rgba(12, 25, 42, 0.5) !important;
	}

	.lightTootip .legend .tip {
		background-color: rgba(255, 255, 255, 1);
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		color: #242424;
	}

	.lightTootip .legend .alltip {
		background-color: rgba(255, 255, 255, 1);
		color: #242424;
	}

	.lightTootip .legend .tip_body {
		box-shadow: 0px 8px 18px 0px rgba(0, 0, 0, 0.11);
		background-color: rgba(255, 255, 255, 1);
		color: #373737;
	}

	.lightTootip .stateTip {
		background-color: rgba(255, 255, 255, 1);
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		color: #242424;
		width: calc(50% - 6.5px) !important;
	}

	.lightTootip .errorTip {
		background-color: rgba(255, 255, 255, 1);
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		color: #242424;
		width: calc(50% - 6.5px) !important;
		float: right !important;
		margin-right: 0 !important;
	}

	.lightTootip .errorTip:hover {
		background-color: #E4E4E4 !important;
	}

	.lightTootip .stateTip:hover {
		background-color: #E4E4E4 !important;
	}

	.lightTootip .legend .tip_body .tip_box:hover {
		background-color: #E4E4E4 !important;
	}

	.stateTip span {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 9px;
		margin: auto;
		font-size: 12px;
		text-align: center;
		text-indent: 2px;
		letter-spacing: normal;
		transform: scale(0.9);
	}

	.stateTip {
		/*background-image: url(../../assets/image/indexEditor/all_state.png);*/
		background-position: center 32px;
		background-repeat: no-repeat;
		background-size: auto;
		border-radius: 10px;
		width: calc(50% - 8.5px);
		height: 77px;
		float: left;
		cursor: pointer;
		text-align: center;
		position: relative;
		transition: .1s;
	}

	.errorTip span {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 9px;
		margin: auto;
		font-size: 12px;
		text-align: center;
		text-indent: 2px;
		letter-spacing: normal;
		transform: scale(0.9);
	}

	.errorTip {
		/*background-image: url(../../assets/image/indexEditor/all_error.png);*/
		background-position: center 17px;
		background-repeat: no-repeat;
		background-size: auto;
		border-radius: 10px;
		width: calc(50% - 8.5px);
		height: 77px;
		float: left;
		margin-right: 13px;
		cursor: pointer;
		text-align: center;
		position: relative;
		transition: .1s;
	}

	.tip_box.lx {
		background-image: url(../../assets/image/indexEditor/gray_error_system.png);
	}
	.tip_box.gj {
		background-image: url(../../assets/image/indexEditor/gray_error.png);
	}

	.tip_box.gz {
		background-image: url(../../assets/image/indexEditor/red_error.png);
	}

	.tip_box.jg {
		background-image: url(../../assets/image/indexEditor/yellow_error.png);
	}

	.tip_box.zc {
		background-image: url(../../assets/image/indexEditor/green_error.png);
	}


	.legend .tip_body .tip_box span {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 9px;
		margin: auto;
		font-size: 12px;
		text-indent: 1px;
		transform: scale(0.9);
	}

	.legend .tip_body .tip_box {
		width: 100%;
		height: calc((100% - 35px) / 5);
		position: relative;
		float: left;
		background-position: center 7px;
		background-repeat: no-repeat;
		background-size: 14px 17px;
		cursor: pointer;
		text-align: center;
		transition: .1s;
	}

	.legend .tip_body {
		position: absolute;
		right: 0;
		bottom: -20px;
		height: 290px;
		width: 37px;
		opacity: 0;
		display: none;
		transition: .2s;
		border-radius: 8px;
		z-index: 5;
		overflow: hidden;
	}

	.legend .tip:hover {
		background-color: rgba(70, 158, 255, 1);
		color: #fff;
	}

	.legend .tip.active {
		background-color: rgba(70, 158, 255, 1);
		color: #fff;
	}

	.legend .tip {
		width: 37px;
		height: 35px;
		border-radius: 8px;
		line-height: 35px;
		cursor: pointer;
		z-index: 10;
		font-size: 12px;
		position: absolute;
		right: 0;
		bottom: 0;
		text-indent: 2px;
		text-align: center;
		transition: .1s;
	}

	.legend {
		width: 100%;
		position: relative;
		float: left;
		margin-bottom: 15px;
		height: calc(100% - 92px);
	}

	.center_tootip {
		position: absolute;
		right: 0;
		bottom: 7px;
		width: 170px;
		height: 126px;
		letter-spacing: 1px;
		z-index: 50;
	}

	.right_bottom_ {
		position: absolute;
		bottom: -1px;
		right: -1px;
		width: 19px;
		height: 19px;
		border-bottom: 3px solid #379BAA;
		border-right: 3px solid #379BAA;
	}

	.left_bottom_ {
		position: absolute;
		bottom: -1px;
		left: -1px;
		width: 19px;
		height: 19px;
		border-bottom: 3px solid #379BAA;
		border-left: 3px solid #379BAA;
	}

	.right_top_ {
		position: absolute;
		top: -1px;
		right: -1px;
		width: 19px;
		height: 19px;
		border-top: 3px solid #379BAA;
		border-right: 3px solid #379BAA;
	}

	.left_top_ {
		position: absolute;
		top: -1px;
		left: -1px;
		width: 19px;
		height: 19px;
		border-top: 3px solid #379BAA;
		border-left: 3px solid #379BAA;
	}

	#NewMouldBy.backgroundBy456 .datasetTable>>>.el-table__body tr.current-row>td {
		background: rgba(70, 158, 255, .6) !important;
	}

	#NewMouldBy.backgroundBy456 .datasetTable .TableValue {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .datasetTable .TableUnit {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .datasetTable>>>.el-table__empty-text {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .datasetTable>>>.el-table__body tr:hover>td {
		background: rgba(70, 158, 255, .4) !important;
	}

	#NewMouldBy.backgroundBy456 .datasetTable>>>.el-table th,
	#NewMouldBy.backgroundBy456 .datasetTable>>>.el-table tr {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .datasetTable>>>.has-gutter tr,
	#NewMouldBy.backgroundBy456 .datasetTable>>>.has-gutter th {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .datasetTitle {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .left_center>>>.center_button .box {
		background-color: rgba(12, 25, 42, .2) !important;
	}

	#NewMouldBy.backgroundBy456 .left_center>>>.center_title {
		color: #FEFEFE !important;
		-webkit-text-fill-color: #FEFEFE !important;
		background: unset !important;
	}

	#NewMouldBy.backgroundBy456 .datasetHeader .headerFatherBox:hover {
		background: rgba(70, 158, 255, 0.6) !important;
	}

	#NewMouldBy.backgroundBy456 .datasetHeader .headerFatherBox.active {
		background: rgba(70, 158, 255, 0.6) !important;
	}

	#NewMouldBy.backgroundBy456 .datasetHeader .headerFatherBox {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .datasetHeader .shu {
		background: rgba(4, 10, 17, 1) !important;
	}

	#NewMouldBy.backgroundBy456 .datasetHeader {
		background: rgba(9, 17, 28, 0.3) !important;
	}

	#NewMouldBy.backgroundBy456 .left_center {
		/*background-color: transparent !important;*/
	}

	#NewMouldBy.backgroundBy456 .left_centerQP {
		background-image: url(../../assets/image/indexEditor/mould/background456.png);
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	#NewMouldBy.backgroundBy7 .left_centerQP {
		background-image: url(../../assets/image/indexEditor/mould/background7.png) !important;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	#NewMouldBy.backgroundBy456 .choice_data>>>.el-form-item__label {
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .choice_data>>>.el-input__inner {
		border: 1px solid rgba(83, 83, 83, 1) !important;
		color: #fff !important;
	}

	#NewMouldBy.backgroundBy456 .top-box {
		background: rgba(12, 25, 42, 0.2) !important;
		border: 2px solid rgba(18, 39, 68, 1) !important;
		border-radius: 0 !important;
		box-shadow: unset !important;
	}

	#NewMouldBy.backgroundBy456 .right_ {
		background: rgba(12, 25, 42, 0.2) !important;
		border: 2px solid rgba(18, 39, 68, 1) !important;
		border-radius: 0 !important;
		box-shadow: unset !important;
	}

	#NewMouldBy.backgroundBy456 .bottom-box {
		border-radius: 0 !important;
		background: rgba(12, 25, 42, 0.2) !important;
		border: 2px solid rgba(18, 39, 68, 1) !important;
		box-shadow: unset !important;
	}

	#NewMouldBy.backgroundBy456 .center-box {
		border-radius: 0 !important;
	}

	#NewMouldBy.backgroundBy456 {
		background-image: url(../../assets/image/indexEditor/mould/background456.png);
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	#NewMouldBy.backgroundBy7 {
		background-image: url(../../assets/image/indexEditor/mould/background7.png);
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.TitleThree {
		top: 10px !important;
	}

	.TitleTwo {
		top: 40px !important;
	}

	.ButtonThree {
		top: 10px !important;
	}

	.ButtonTwo {
		top: 40px !important;
	}

	.centerTitleFull {
		top: 110px !important;
	}

	.centerBoxFull {
		right: 110px !important;
		top: 110px !important;
	}

	.mask {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, .4);
		z-index: 100;
	}

	.noScale {
		transform: unset !important;
	}

	.overunset {
		overflow: unset !important;
	}

	.right1 .TableUnit,
	.right2 .TableUnit {
		position: relative;
		/*top: 5px;*/
	}

	.right1 .datasetTable,
	.right2 .datasetTable {
		line-height: 45px !important;
		/* text-indent: -72px; */
		margin-left: 26px !important;
		width: calc(100% - 26px) !important;
		height: 45px;
	}

	.right1 .datasetBox,
	.right2 .datasetBox {
		/*height: calc(100% - 58px);*/
		height: 45px;
		top: unset;
		bottom: 2px;
	}

	.right1 .datasetTitle,
	.right2 .datasetTitle {
		line-height: 50px;
		margin-top: 8px;
		margin-bottom: 0px;
	}

	.top-box .datasetTitle {
		line-height: 59px !important;
		margin-top: 0px !important;
		margin-bottom: 5px !important;
	}

	.left_bottom .datasetHeader {
		width: 405px !important;
		margin-top: 11px;
		margin-bottom: 7px;
		height: 23px;
	}

	.indexEdit .datasetTable>>>.el-table__empty-block {
		width: 100% !important;
	}

	.indexEdit .datasetTable>>>.el-table__body tr.current-row>td {
		background: rgba(233, 233, 233, 1) !important;
		padding: 6px 0;
	}

	.indexEdit .datasetTable>>>.el-table__body tr:hover>td {
		background: rgba(233, 233, 233, .6);
	}

	.indexEdit .datasetTable>>>.el-table::before {
		height: 0px !important;
	}

	.indexEdit .datasetTable>>>.el-table .el-table__row:hover {
		background-color: transparent !important;
	}

	.indexEdit .datasetTable>>>.el-table .createdTimeForTable {
		letter-spacing: 0.5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.indexEdit .datasetTable>>>.el-table td,
	.indexEdit .datasetTable>>>.el-table th.is-leaf {
		border: 0px !important;
		padding: 6px 0;
	}

	.indexEdit .datasetTable>>>.el-table .cell {
		white-space: nowrap !important;
		overflow: unset !important;
		word-break: unset !important;
	}

	.indexEdit .datasetTable>>>.el-table th,
	.indexEdit .datasetTable>>>.el-table tr {
		background-color: transparent;
		color: #5C5C5C;
	}

	.indexEdit .datasetTable>>>.el-table,
	.indexEdit .datasetTable>>>.el-table__expanded-cell {
		background-color: transparent;
	}

	.indexEdit .datasetTable>>>.has-gutter tr,
	.indexEdit .datasetTable>>>.has-gutter th {
		background-color: transparent;
		font-weight: unset !important;
		color: #5C5C5C;
	}
	/*滚动条样式：谷歌浏览器下*/

	.indexEdit .datasetTable>>>.el-table__body-wrapper::-webkit-scrollbar-corner {
		background-color: rgba(0, 0, 0, 0);
	}

	.indexEdit .datasetTable>>>.el-table__body-wrapper::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: transparent;
	}
	/*滚动条的轨道*/

	.indexEdit .datasetTable>>>.el-table__body-wrapper::-webkit-scrollbar-track {
		/*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
		background-color: transparent;
	}
	/*滚动条的滑块按钮*/

	.indexEdit .datasetTable>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #E4E4E4;
		/*box-shadow: inset 0 0 5px #000;*/
	}
	/*滚动条的上下两端的按钮*/

	.indexEdit .datasetTable>>>.el-table__body-wrapper::-webkit-scrollbar-button {
		height: 0px;
		background-color: transparent;
		/*width: 0px;*/
	}

	.showEdit .el-loading-mask {
		position: absolute !important;
		/*background-color: unset;*/
	}

	.indexEdit .el-loading-mask {
		position: absolute !important;
	}

	.preview {
		transform-origin: 50% 0%;
		transform: scale(.6);
	}

	.datasetTable {
		position: absolute;
		height: calc(100% - 2px);
		width: 100%;
		overflow: hidden;
		/*margin-left: 26px;*/
		font-size: 27px;
		/* padding-left: 35px; */
		/*line-height: 77px;*/
		text-align: left;
	}

	.TableUnitEn {
		/* float: left; */
		color: #3C3C3C;
		font-size: 21px;
		/* line-height: 1; */
	}

	.TableUnit {
		/*float: left; */
		color: #3C3C3C;
		/* font-size: 12px; */
		position: absolute;
		/* top: 2px; */
		margin: auto;
		text-indent: 4px;
	}

	.TableValue {
		color: #3C3C3C;
		/* float: left; */
		/* font-size: 21px; */
		/* text-indent: 37px; */
		/* line-height: 1; */
	}

	.datasetBox {
		width: 100%;
		height: calc(100% - 39px);
		float: left;
		position: absolute;
		top: 37px;
	}

	.marLeftZero {
		margin-left: 0 !important;
	}

	.datasetHeader .headerbox {
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto;
		left: 0;
		right: 0;
		height: 18.5px;
		overflow: hidden;
	}

	.datasetHeader .headerFatherBox.active {
		background: #0089FD;
		color: #fff !important;
	}

	.datasetHeader .headerFatherBox:hover {
		background: #0089FD;
		color: #fff !important;
	}

	.datasetHeader .headerFatherBox {
		-webkit-transition: .1s;
		transition: .1s;
		cursor: pointer;
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
		margin-left: 2px;
		position: relative;
	}

	.datasetHeader .shu {
		width: 2px;
		height: 100%;
		background-color: rgba(214, 214, 214, .5);
		position: absolute;
		top: 0;
		right: -2px;
	}

	.datasetHeader {
		float: left;
		background: #F1F1F1;
		border-radius: 10px;
		text-align: center;
		position: relative;
		left: 22px;
		/*width: calc(85% + 4px);*/
		width: 215px;
		color: #5C5C5C;
		font-size: 13px;
		overflow: hidden;
		display: flex;
		margin-top: 9px;
		/*margin-bottom: 9px;*/
		height: 30px;
	}

	.datasetTitle {
		color: #5E5E5E;
		font-size: 16px;
		position: relative;
		/* top: 20px; */
		/* left: 33px; */
		float: left;
		letter-spacing: 0.5px;
		line-height: 23px;
		text-indent: 25px;
		margin-top: 7px;
		margin-bottom: 7px;
	}

	.dataSet {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.OneDataSet .choice_data {
		height: 34px !important;
	}

	.robotname {
		line-height: 34px;
	}

	.choice_data>>>.el-input {
		width: 183px;
		height: 34px;
		line-height: 34px;
	}

	.choice_data>>>.el-input__inner {
		width: 183px;
		height: 34px;
		line-height: 34px;
		border-radius: 0;
	}

	.choice_data>>>.el-input__icon {
		line-height: 34px;
		height: 34px;
	}

	.choice_data>>>.el-form-item {
		margin-bottom: 11px !important;
	}

	.choice_data>>>.el-select {
		/*width: 100%;*/
	}

	.choice_data>>>.el-form-item__content {
		width: 183px !important;
		top: 0 !important;
		float: left;
	}

	.choice_data>>>.el-form-item__label {
		line-height: 34px !important;
		float: left;
	}

	.choice_data {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		margin: auto;
		width: 260px;
		height: 133px;
	}

	.el-form {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.top-box {
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 15px 30px 0px rgba(0, 173, 227, 0.15);
		border-radius: 15px;
		flex: 1;
		margin-right: 21px;
		height: calc(100% - 52px);
		margin-top: 22px;
		position: relative;
	}

	.left_top {
		width: calc(100% - 64px);
		margin: 0 31px 0 33px;
		display: flex;
	}

	.right_ {
		width: calc(100% - 64px);
		height: 100%;
		background-color: #fff;
		box-shadow: 0px 42px 53px 0px rgba(0, 173, 227, 0.15);
		border-radius: 15px;
		margin-top: 30px;
		margin-left: 34px;
		transition: .3s;
		position: relative;
	}

	.bottom-box {
		width: calc(100% - 34px);
		height: calc(100% - 90px);
		background-color: #fff;
		box-shadow: 0px 42px 53px 0px rgba(0, 173, 227, 0.15);
		margin: 30px 0 60px 34px;
		border-radius: 15px;
		position: relative;
	}

	.center_button .box.noFull {
		background-image: url(../../assets/image/indexEditor/noFull.png);
	}

	.center_button .box.rightCenter {
		background-image: url(../../assets/image/indexEditor/Full.png);
	}

	.center_button .box.leftCenter {
		background-image: url(../../assets/image/indexEditor/attrShowTrue.png) !important;
		margin-right: 16px;
	}

	.center_button .box.noFullTwo {
		background-image: url(../../assets/image/indexEditor/attrShowNo.png);
		margin-right: 16px;
	}

	.center_button .box.editorClear {
		background-image: url(../../assets/image/editor/icon/viewTrue.png);
		margin-right: 16px;
	}

	.lightButton.center_button .box:hover {
		background-color: #E4E4E4 !important;
	}

	#NewMouldBy.backgroundBy456 .left_center .darkButton.center_button .box:hover {
		background-color: rgba(12, 25, 42, .5) !important;
	}

	.center_button .box {
		float: left;
		width: 37px;
		height: 39px;
		box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
		border-radius: 7px;
		background-color: rgba(255, 255, 255, 1);
		background-position: center;
		background-size: 22px 22px;
		background-repeat: no-repeat;
		cursor: pointer;
		transition: .1s;
	}

	.center_button {
		position: absolute;
		right: 0;
		top: 0;
		width: 143px;
		height: 39px;
		transition: .1s;
		z-index: 50;
	}

	.center_title {
		position: absolute;
		left: 0;
		top: 0px;
		transition: .1s;
		font-size: 27px;
		font-weight: bold;
		background: -webkit-gradient(linear, left bottom, left top, from(#89c4ff), to(#007eff));
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		color: transparent;
	}

	.center-box {
		width: calc(100% - 35px);
		height: calc(100% - 2px);
		margin: 0 0 0 33px;
		/*border: 1px dashed rgba(180, 180, 180, 1);*/
		border-radius: 15px;
		text-indent: 11px;
		letter-spacing: 2px;
		overflow: hidden;
		position: relative;
		border-top-right-radius: 0;
	}

	.right1 {
		flex: .5;
		margin-top: 41px !important;
	}

	.right2 {
		flex: .5;
	}

	.right3 {
		flex: 1;
		margin-top: 41px !important;
	}

	.right_center {
		flex: 1;
	}

	.right_bottom {
		flex: 1;
	}

	.left_bottom {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		height: 280px;
		transition: .3s;
	}

	.left_centerBy123 {
		background-color: #F5F5F6;
	}

	.left_center {
		position: absolute;
		bottom: 280px;
		left: 0;
		right: 0;
		top: 160px;
		margin: auto;
		font-size: 24px;
		transition: .3s;
		overflow: hidden;
		/*background-color: #F5F5F6;*/
	}

	.left_top {
		position: absolute;
		top: 0;
		left: 0;
		/* margin: auto; */
		height: 160px;
		transition: .3s;
	}

	.left {
		position: absolute;
		left: 0;
		right: 360px;
		bottom: 0;
		top: 0;
		margin: auto;
		text-align: left;
		transition: .3s;
	}

	.right {
		width: 360px;
		position: absolute;
		right: 0;
		bottom: 60px;
		top: 0;
		display: flex;
		flex-flow: column;
		margin: auto;
		transition: .3s;
	}

	.ButtonNoset {
		background-color: #a0cfff !important;
		border-color: #a0cfff !important;
		cursor: not-allowed !important;
	}

	.show_content {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.right_header span {
		position: absolute;
		bottom: 8px;
		left: 0;
		right: 0;
		margin: auto;
	}

	.right_header {
		float: right;
		color: #606060;
		width: 24px;
		height: 59px;
		font-size: 12px;
		text-align: center;
		position: relative;
		margin-right: 38px;
		cursor: pointer;
		transition: .1s;
	}

	.save {
		background: url(../../assets/image/indexEditor/save.png)no-repeat center;
		background-position-y: 12px;
	}

	.save:hover {
		background: url(../../assets/image/indexEditor/saveHover.png)no-repeat center;
		background-position-y: 12px;
	}

	.show_header {
		width: 100%;
		height: 59px;
		background-color: #fff;
		border-bottom: 1px solid rgba(229, 229, 229, 1);
	}

	.mould_show {
		width: 100%;
		height: 100%;
		position: relative;
		background-color: #F5F5F6;
		float: left;
		z-index: 0;
	}

	.mould_box .box_title {
		text-align: center;
		line-height: 35px;
		color: #373737;
		font-size: 12px;
		float: left;
		width: 100%;
	}

	.mould_box .box_img {
		width: 100%;
		height: 133px;
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		float: left;
		border-top: 1px solid rgba(220, 220, 220, 1);
	}

	.mould_box:hover {
		outline: 2px solid #5087E4 !important;
	}

	.mould_box.active {
		outline: 2px solid #5087E4 !important;
	}

	.mould_box {
		width: calc(100% - 81px);
		float: left;
		margin: 2px 28px 37px 28px;
		padding: 10px 12px 0 13px;
		cursor: pointer;
		background: rgba(255, 255, 255, 1);
		outline: 1px solid rgba(220, 220, 220, 1);
		transition: .1s;
	}

	.overAuto {
		width: 100%;
		height: calc(100% - 49px);
		float: left;
		position: relative;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.choice_title {
		color: #383838;
		line-height: 49px;
		text-indent: 23px;
		text-align: left;
		float: left;
		width: 100%;
		font-size: 14px;
	}

	.overAuto::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: #f5f7fa;
	}
	/*滚动条的轨道*/

	.overAuto::-webkit-scrollbar-track {
		/*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
		background-color: #fff;
	}
	/*滚动条的滑块按钮*/

	.overAuto::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #DCDCDC;
		/*box-shadow: inset 0 0 5px #000;*/
		/*box-shadow: 8px 0 0 #A5ADB7 inset;*/
	}
	/*滚动条的上下两端的按钮*/

	.overAuto::-webkit-scrollbar-button {
		height: 0px;
		background-color: #eee;
	}

	.mould_choice {
		float: left;
		width: 309px;
		height: 100%;
		background: #FFFFFF;
		border: 1px solid #DCDCDC;
	}

	.indexEdit {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	.noContent {
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		width: 422px;
		height: 75px;
	}

	.nullSpan {
		position: relative;
		top: -20px;
		margin-left: 20px;
		font-size: 15px;
		color: #545454;
	}

	.clearfix:after {
		content: "";
		display: block;
		clear: both;
	}

	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/IndexEditShow/indexEditShow.vue